webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GlobalChannel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ifpeAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return properties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createParseFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createDocumentFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_parse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_parse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_toastr__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mini_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mini_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mathjs__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mathjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mathjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_client_oauth2__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_client_oauth2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_client_oauth2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_parse___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_mini_toastr___default.a; });
var _this = this;








__WEBPACK_IMPORTED_MODULE_0_parse___default.a.initialize("eadflow");
__WEBPACK_IMPORTED_MODULE_0_parse___default.a.serverURL = "https://eadflow.ifpe.edu.br/parse";
var properties = {};
properties.passwordChangeURL = "https://eadflow.ifpe.edu.br/parse" + '/apps/' + "eadflow" + '/request_password_reset';

__WEBPACK_IMPORTED_MODULE_1_mini_toastr___default.a.init();

var GlobalChannel = new __WEBPACK_IMPORTED_MODULE_2_vue___default.a({});

var ifpeAuth = new __WEBPACK_IMPORTED_MODULE_4_client_oauth2___default.a({
  clientId: "eadflow",
  clientSecret: '',
  accessTokenUri: 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/token',
  authorizationUri: 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/auth',
  redirectUri: "https://eadflow.ifpe.edu.br" + '/#/auth/callback',
  state: 'asdhaisdhasd',
  scopes: ['openid', 'profile', 'email', 'offline_access']
});

var computeValue = function computeValue(formula, fieldsInstances) {
  var concreteFormula = formula;
  fieldsInstances.forEach(function (f) {
    var re = new RegExp(f.name, 'g');
    concreteFormula = concreteFormula.replace(re, f.value || f.stringField || f.numField || f.dateField || '0');
  });
  return String(__WEBPACK_IMPORTED_MODULE_3_mathjs___default.a.eval(concreteFormula));
};

var createDocumentFile = function createDocumentFile(formField, event) {
  var counter = 0;
  var allowedFileExtensions = ['bmp', 'gif', 'jpeg', 'jpg', 'png'];
  if (event && event.target.files.length > 0) {
    var doc = new __WEBPACK_IMPORTED_MODULE_5_jspdf__('p', 'mm', [400, 480]);
    for (var i = 0; i < event.target.files.length; i++) {
      var readFunction = function readFunction(file, i) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (saveFile) {
          var fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length).toLowerCase();
          if (allowedFileExtensions.includes(fileExtension)) {
            doc.addImage(reader.result, fileExtension, 20, 20, 360, 440);
          } else {
            this.message = 'A extensão ' + fileExtension + ' não é válida para os anexos.';
            __WEBPACK_IMPORTED_MODULE_1_mini_toastr___default.a.error(this.message);
            throw this.message;
          }
          counter++;
          if (counter !== event.target.files.length) {
            doc.addPage();
          } else {
            var output64 = btoa(doc.output());
            var parseFile = new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.File('file' + Math.random().toString(36).substring(7) + '.pdf', { base64: output64 });
            formField.value = parseFile;
            formField.filename = 'generatedDocument.pdf';
          }
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      };
      readFunction(event.target.files[i], i);
    }
  }
};

var createParseFile = function createParseFile(formField, event) {
  if (event && event.target.files.length > 0) {
    var file = event.target.files[0];
    var allowedFileExtensions = ['.bmp', '.doc', '.gif', '.jpeg', '.jpg', '.pdf', '.png', '.dwg', '.zip', '.rar', '.doc'];
    var fileExtension = file.name.substring(file.name.lastIndexOf('.'), file.name.length).toLowerCase();
    if (allowedFileExtensions.includes(fileExtension)) {
      var parseFile = new __WEBPACK_IMPORTED_MODULE_0_parse___default.a.File('file' + Math.random().toString(36).substring(7) + fileExtension, file);
      formField.value = parseFile;
      formField.filename = file.name;
    } else {
      _this.message = 'A extensão ' + fileExtension + ' não é válida para os anexos.';
      __WEBPACK_IMPORTED_MODULE_1_mini_toastr___default.a.error(_this.message);
      throw _this.message;
    }
  }
};



GlobalChannel.$on('loginSuccess', function (self) {
  var next = self.$route.query.next;
  self.$router.push(next || '/openRequest');
});

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(883)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(615),
  /* template */
  __webpack_require__(1457),
  /* scopeId */
  "data-v-6b3caaa9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1325:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 378,
	"./af.js": 378,
	"./ar": 386,
	"./ar-dz": 379,
	"./ar-dz.js": 379,
	"./ar-kw": 380,
	"./ar-kw.js": 380,
	"./ar-ly": 381,
	"./ar-ly.js": 381,
	"./ar-ma": 382,
	"./ar-ma.js": 382,
	"./ar-ps": 383,
	"./ar-ps.js": 383,
	"./ar-sa": 384,
	"./ar-sa.js": 384,
	"./ar-tn": 385,
	"./ar-tn.js": 385,
	"./ar.js": 386,
	"./az": 387,
	"./az.js": 387,
	"./be": 388,
	"./be.js": 388,
	"./bg": 389,
	"./bg.js": 389,
	"./bm": 390,
	"./bm.js": 390,
	"./bn": 392,
	"./bn-bd": 391,
	"./bn-bd.js": 391,
	"./bn.js": 392,
	"./bo": 393,
	"./bo.js": 393,
	"./br": 394,
	"./br.js": 394,
	"./bs": 395,
	"./bs.js": 395,
	"./ca": 396,
	"./ca.js": 396,
	"./cs": 397,
	"./cs.js": 397,
	"./cv": 398,
	"./cv.js": 398,
	"./cy": 399,
	"./cy.js": 399,
	"./da": 400,
	"./da.js": 400,
	"./de": 403,
	"./de-at": 401,
	"./de-at.js": 401,
	"./de-ch": 402,
	"./de-ch.js": 402,
	"./de.js": 403,
	"./dv": 404,
	"./dv.js": 404,
	"./el": 405,
	"./el.js": 405,
	"./en-au": 406,
	"./en-au.js": 406,
	"./en-ca": 407,
	"./en-ca.js": 407,
	"./en-gb": 408,
	"./en-gb.js": 408,
	"./en-ie": 409,
	"./en-ie.js": 409,
	"./en-il": 410,
	"./en-il.js": 410,
	"./en-in": 411,
	"./en-in.js": 411,
	"./en-nz": 412,
	"./en-nz.js": 412,
	"./en-sg": 413,
	"./en-sg.js": 413,
	"./eo": 414,
	"./eo.js": 414,
	"./es": 418,
	"./es-do": 415,
	"./es-do.js": 415,
	"./es-mx": 416,
	"./es-mx.js": 416,
	"./es-us": 417,
	"./es-us.js": 417,
	"./es.js": 418,
	"./et": 419,
	"./et.js": 419,
	"./eu": 420,
	"./eu.js": 420,
	"./fa": 421,
	"./fa.js": 421,
	"./fi": 422,
	"./fi.js": 422,
	"./fil": 423,
	"./fil.js": 423,
	"./fo": 424,
	"./fo.js": 424,
	"./fr": 427,
	"./fr-ca": 425,
	"./fr-ca.js": 425,
	"./fr-ch": 426,
	"./fr-ch.js": 426,
	"./fr.js": 427,
	"./fy": 428,
	"./fy.js": 428,
	"./ga": 429,
	"./ga.js": 429,
	"./gd": 430,
	"./gd.js": 430,
	"./gl": 431,
	"./gl.js": 431,
	"./gom-deva": 432,
	"./gom-deva.js": 432,
	"./gom-latn": 433,
	"./gom-latn.js": 433,
	"./gu": 434,
	"./gu.js": 434,
	"./he": 435,
	"./he.js": 435,
	"./hi": 436,
	"./hi.js": 436,
	"./hr": 437,
	"./hr.js": 437,
	"./hu": 438,
	"./hu.js": 438,
	"./hy-am": 439,
	"./hy-am.js": 439,
	"./id": 440,
	"./id.js": 440,
	"./is": 441,
	"./is.js": 441,
	"./it": 443,
	"./it-ch": 442,
	"./it-ch.js": 442,
	"./it.js": 443,
	"./ja": 444,
	"./ja.js": 444,
	"./jv": 445,
	"./jv.js": 445,
	"./ka": 446,
	"./ka.js": 446,
	"./kk": 447,
	"./kk.js": 447,
	"./km": 448,
	"./km.js": 448,
	"./kn": 449,
	"./kn.js": 449,
	"./ko": 450,
	"./ko.js": 450,
	"./ku": 452,
	"./ku-kmr": 451,
	"./ku-kmr.js": 451,
	"./ku.js": 452,
	"./ky": 453,
	"./ky.js": 453,
	"./lb": 454,
	"./lb.js": 454,
	"./lo": 455,
	"./lo.js": 455,
	"./lt": 456,
	"./lt.js": 456,
	"./lv": 457,
	"./lv.js": 457,
	"./me": 458,
	"./me.js": 458,
	"./mi": 459,
	"./mi.js": 459,
	"./mk": 460,
	"./mk.js": 460,
	"./ml": 461,
	"./ml.js": 461,
	"./mn": 462,
	"./mn.js": 462,
	"./mr": 463,
	"./mr.js": 463,
	"./ms": 465,
	"./ms-my": 464,
	"./ms-my.js": 464,
	"./ms.js": 465,
	"./mt": 466,
	"./mt.js": 466,
	"./my": 467,
	"./my.js": 467,
	"./nb": 468,
	"./nb.js": 468,
	"./ne": 469,
	"./ne.js": 469,
	"./nl": 471,
	"./nl-be": 470,
	"./nl-be.js": 470,
	"./nl.js": 471,
	"./nn": 472,
	"./nn.js": 472,
	"./oc-lnc": 473,
	"./oc-lnc.js": 473,
	"./pa-in": 474,
	"./pa-in.js": 474,
	"./pl": 475,
	"./pl.js": 475,
	"./pt": 477,
	"./pt-br": 476,
	"./pt-br.js": 476,
	"./pt.js": 477,
	"./ro": 478,
	"./ro.js": 478,
	"./ru": 479,
	"./ru.js": 479,
	"./sd": 480,
	"./sd.js": 480,
	"./se": 481,
	"./se.js": 481,
	"./si": 482,
	"./si.js": 482,
	"./sk": 483,
	"./sk.js": 483,
	"./sl": 484,
	"./sl.js": 484,
	"./sq": 485,
	"./sq.js": 485,
	"./sr": 487,
	"./sr-cyrl": 486,
	"./sr-cyrl.js": 486,
	"./sr.js": 487,
	"./ss": 488,
	"./ss.js": 488,
	"./sv": 489,
	"./sv.js": 489,
	"./sw": 490,
	"./sw.js": 490,
	"./ta": 491,
	"./ta.js": 491,
	"./te": 492,
	"./te.js": 492,
	"./tet": 493,
	"./tet.js": 493,
	"./tg": 494,
	"./tg.js": 494,
	"./th": 495,
	"./th.js": 495,
	"./tk": 496,
	"./tk.js": 496,
	"./tl-ph": 497,
	"./tl-ph.js": 497,
	"./tlh": 498,
	"./tlh.js": 498,
	"./tr": 499,
	"./tr.js": 499,
	"./tzl": 500,
	"./tzl.js": 500,
	"./tzm": 502,
	"./tzm-latn": 501,
	"./tzm-latn.js": 501,
	"./tzm.js": 502,
	"./ug-cn": 503,
	"./ug-cn.js": 503,
	"./uk": 504,
	"./uk.js": 504,
	"./ur": 505,
	"./ur.js": 505,
	"./uz": 507,
	"./uz-latn": 506,
	"./uz-latn.js": 506,
	"./uz.js": 507,
	"./vi": 508,
	"./vi.js": 508,
	"./x-pseudo": 509,
	"./x-pseudo.js": 509,
	"./yo": 510,
	"./yo.js": 510,
	"./zh-cn": 511,
	"./zh-cn.js": 511,
	"./zh-hk": 512,
	"./zh-hk.js": 512,
	"./zh-mo": 513,
	"./zh-mo.js": 513,
	"./zh-tw": 514,
	"./zh-tw.js": 514
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1325;

/***/ }),

/***/ 1326:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 1376:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1380:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(869)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(563),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1381:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(877)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(564),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(893)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(565),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(881)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(566),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1384:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(866)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(567),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1385:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(878)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1452),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1448),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(900)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1474),
  /* scopeId */
  "data-v-f1abbee2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1388:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1464),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1389:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(880)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1454),
  /* scopeId */
  "data-v-5e808fba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1390:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(892)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1467),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(879)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1453),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1392:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(867)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(1440),
  /* scopeId */
  "data-v-2c9be824",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(874)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1449),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(885)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1459),
  /* scopeId */
  "data-v-75eb0f36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1395:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(884)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1458),
  /* scopeId */
  "data-v-70b883af",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(890)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1465),
  /* scopeId */
  "data-v-acf6c342",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(856)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1429),
  /* scopeId */
  "data-v-07fc31fb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1398:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(875)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1450),
  /* scopeId */
  "data-v-52d9716e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1399:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(898)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1472),
  /* scopeId */
  "data-v-e5aba69a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1400:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(897)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1471),
  /* scopeId */
  "data-v-d935c0e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1401:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(901)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1475),
  /* scopeId */
  "data-v-f25acf70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(882)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(589),
  /* template */
  __webpack_require__(1456),
  /* scopeId */
  "data-v-67d75959",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1403:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(862)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(1436),
  /* scopeId */
  "data-v-188957f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(591),
  /* template */
  __webpack_require__(1428),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1405:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(891)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(592),
  /* template */
  __webpack_require__(1466),
  /* scopeId */
  "data-v-ae2d4ebc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(860)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(1434),
  /* scopeId */
  "data-v-12fb48ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1407:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(889)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(594),
  /* template */
  __webpack_require__(1463),
  /* scopeId */
  "data-v-9989ed26",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1408:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(858)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(595),
  /* template */
  __webpack_require__(1431),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1409:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(895)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(1469),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(865)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(597),
  /* template */
  __webpack_require__(1439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(864)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(598),
  /* template */
  __webpack_require__(1438),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1412:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(873)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(1447),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1413:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(861)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(600),
  /* template */
  __webpack_require__(1435),
  /* scopeId */
  "data-v-13b89d25",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1414:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(887)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(601),
  /* template */
  __webpack_require__(1461),
  /* scopeId */
  "data-v-7995ef9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(863)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(1437),
  /* scopeId */
  "data-v-19039b59",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1416:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(859)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(603),
  /* template */
  __webpack_require__(1432),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1417:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(604),
  /* template */
  __webpack_require__(1433),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1418:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(870)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(1444),
  /* scopeId */
  "data-v-44d2ff38",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1419:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(894)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(606),
  /* template */
  __webpack_require__(1468),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1420:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(876)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(607),
  /* template */
  __webpack_require__(1451),
  /* scopeId */
  "data-v-54d66340",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(857)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(1430),
  /* scopeId */
  "data-v-0af5d4a1",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(872)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(610),
  /* template */
  __webpack_require__(1446),
  /* scopeId */
  "data-v-49eeac3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(613),
  /* template */
  __webpack_require__(1455),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1424:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(888)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(1462),
  /* scopeId */
  "data-v-87b9f016",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1425:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(871)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1445),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1426:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1443),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(868)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1441),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Tipo de Requisição")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.name),
      expression: "requestType.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.requestType.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.description),
      expression: "requestType.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.requestType.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.active),
      expression: "requestType.active"
    }],
    attrs: {
      "id": "active",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.requestType.active) ? _vm._i(_vm.requestType.active, null) > -1 : (_vm.requestType.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.requestType.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.requestType, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.requestType, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.requestType, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.requestType.owner && _vm.requestType.owner.username) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "owner"
    }
  }, [_vm._v("Proprietário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType.owner.username),
      expression: "requestType.owner.username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "owner",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.requestType.owner.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requestType.owner, "username", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")]), _vm._v(" "), (_vm.requestType.objectId) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "btn-remove"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        Remover\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n        Cancelar\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.requestType.objectId) ? _c('form-section-list', {
    attrs: {
      "reqType": _vm.requestType.objectId
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1429:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('steps', {
    attrs: {
      "steps": _vm.steps,
      "request": _vm.request,
      "editable": false,
      "groups": _vm.groups
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "info col-sm-9"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('request-metadata', {
    attrs: {
      "request": _vm.request
    }
  }), _vm._v(" "), _c('request-user-linked', {
    attrs: {
      "linked": _vm.otherRequests,
      "request": _vm.request
    }
  }), _vm._v(" "), _vm._l((_vm.fieldsGroups), function(fields, sectionId, i) {
    return _c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "alert alert-info"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [(sectionId) ? _c('span', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.getSection(sectionId).name))]) : _c('span', [_vm._v("Dados")])])])]), _vm._v(" "), _c('tbody', _vm._l((fields), function(field) {
      return (!field.newerVersion) ? _c('tr', {
        key: field.objectId,
        staticClass: "edit-button"
      }, [_c('td', [_c('strong', [_vm._v(_vm._s(field.name))])]), _vm._v(" "), _c('td', [(_vm.showEditField && field.type !== 'computed') ? _c('span', {
        staticClass: "edit-icon pull-right glyphicon glyphicon-edit",
        staticStyle: {
          "padding-left": "5px"
        },
        on: {
          "click": function($event) {
            return _vm.openEditModal(field)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('dynamic-view-field', {
        attrs: {
          "showVersions": true,
          "field": field,
          "sectionOrder": i,
          "sectionId": sectionId,
          "fields": fields
        }
      })], 1)]) : _vm._e()
    }), 0)])
  }), _vm._v(" "), _vm._l((_vm.additionalFields), function(info) {
    return _c('table', {
      staticClass: "table table-bordered table-striped",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "step-title"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Passo: " + _vm._s(info.step.name))])])]), _vm._v(" "), _c('tbody', _vm._l((info.fields), function(field) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('td', [_c('dynamic-view-field', {
        attrs: {
          "field": field,
          "sectionOrder": _vm.i,
          "sectionId": _vm.sectionId
        }
      })], 1)])
    }), 0)])
  })], 2), _vm._v(" "), _c('div', [_c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comments"
  }, _vm._l((_vm.comments), function(comment) {
    return (comment.message) ? _c('div', {
      staticClass: "row comment"
    }, [_c('div', {
      staticClass: "comment-timeline",
      class: comment.event
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-11"
    }, [_c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading",
      class: comment.event
    }, [(comment.private) ? _c('span', {
      staticClass: "glyphicon glyphicon-lock",
      attrs: {
        "title": "Comentário privado"
      }
    }) : _vm._e(), _vm._v(" "), (comment.owner) ? _c('span', {
      staticClass: "comment-user-name"
    }, [_vm._v(_vm._s(comment.owner.name))]) : _c('span', {
      staticClass: "comment-user-name"
    }, [_vm._v("Anônimo")]), _vm._v(" "), _c('span', {
      staticClass: "comment-date"
    }, [_vm._v(_vm._s(_vm.formatDate(comment.createdAt)))]), _vm._v(" "), _c('span', {
      staticClass: "react-box pull-right"
    }, [_c('button', {
      staticClass: "btn btn-default btn-xs btn-like glyphicon glyphicon-thumbs-up",
      class: {
        liked: comment.likes.indexOf(_vm.user.id) >= 0
      },
      attrs: {
        "disabled": comment.dislikes.indexOf(_vm.user.id) >= 0
      },
      on: {
        "click": function($event) {
          return _vm.like(comment)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "like-count"
    }, [_vm._v(_vm._s(comment.likes.length))]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs btn-dislike glyphicon glyphicon-thumbs-down",
      class: {
        disliked: comment.dislikes.indexOf(_vm.user.id) >= 0
      },
      attrs: {
        "disabled": comment.likes.indexOf(_vm.user.id) >= 0
      },
      on: {
        "click": function($event) {
          return _vm.dislike(comment)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dislike-count"
    }, [_vm._v(_vm._s(comment.dislikes.length))])])]), _vm._v(" "), (comment.message) ? _c('div', {
      staticClass: "panel-body comment-message"
    }, [_c('span', {
      staticClass: "react-box pull-right"
    }, [(comment.owner.objectId === _vm.user.id && comment.event === 'note') ? _c('button', {
      staticClass: "btn btn-default btn-xs glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          return _vm.deleteComment(comment)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "speech-bubble-arrow",
      class: comment.event
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(comment.message || '<i>Sem observações</i>')
      }
    })]) : _vm._e()])])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.privateComment),
      expression: "privateComment"
    }],
    attrs: {
      "type": "checkbox",
      "name": "private-comment"
    },
    domProps: {
      "checked": Array.isArray(_vm.privateComment) ? _vm._i(_vm.privateComment, null) > -1 : (_vm.privateComment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.privateComment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.privateComment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.privateComment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.privateComment = $$c
        }
      }
    }
  }), _vm._v(" Tornar o comentário privado.\n              ")])])], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.saveComment('note')
      }
    }
  }, [_vm._v("Enviar")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-3"
  }, [(_vm.request.status == 'processing') ? _c('div', [(!_vm.isLastStep && _vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary control",
    attrs: {
      "id": "btn-trammit"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('processing')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-arrow-right"
  }), _vm._v(" "), (!_vm.customizations.trammitButton) ? _c('span', [_vm._v("Tramitar")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.trammitButton))])])]) : _vm._e(), _vm._v(" "), (!_vm.seeMore && _vm.canTrammit) ? _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.seeMore = true
      }
    }
  }, [_vm._v("\n          Ver mais opções\n        ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.seeMore) ? _c('div', {
    staticClass: "row"
  }, [(_vm.canTrammit) ? _c('button', {
    staticClass: "btn btn-success control",
    attrs: {
      "id": "btn-grant"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('grant')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-up"
  }), _vm._v(" "), (!_vm.customizations.grantButton) ? _c('span', [_vm._v("Finalizar com Sucesso")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.grantButton))])]) : _vm._e(), _vm._v(" "), ((_vm.seeMore || _vm.isFirstStep) && _vm.canTrammit) ? _c('button', {
    staticClass: "btn btn-danger control",
    attrs: {
      "id": "btn-deny"
    },
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('deny')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-thumbs-down"
  }), _vm._v(" "), (!_vm.customizations.denyButton) ? _c('span', [_vm._v("Rejeitar")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.denyButton))])]) : _vm._e(), _vm._v(" "), (_vm.seeMore && !_vm.isFirstStep && _vm.canRevert) ? _c('button', {
    staticClass: "btn btn-primary control",
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('revert')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon glyphicon-erase"
  }), _vm._v(" Reverter\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.currentStepActions.length) ? _c('hr') : _vm._e(), _vm._v(" "), _vm._l((_vm.currentStepActions), function(action) {
    return _c('div', {
      staticClass: "row"
    }, [(action.type === 'form') ? _c('button', {
      staticClass: "btn btn-primary control",
      on: {
        "click": function($event) {
          return _vm.openActionModal(action)
        }
      }
    }, [_vm._v(_vm._s(action.name))]) : (action.type === 'link') ? _c('a', {
      staticClass: "btn btn-primary control",
      attrs: {
        "href": action.value,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-new-window"
    }), _vm._v(" " + _vm._s(action.name) + "\n          ")]) : _vm._e()])
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default control",
    attrs: {
      "id": "btn-deny"
    },
    on: {
      "click": _vm.inviteUser
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-share"
  }), _vm._v("\n            Convites\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default control",
    attrs: {
      "id": "btn-email"
    },
    on: {
      "click": function($event) {
        return _vm.sendEmail()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-envelope"
  }), _vm._v("\n            Contactar por email\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.canTrammit) ? _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary control",
    attrs: {
      "id": "btn-email",
      "disabled": _vm.ownerInvite !== undefined
    },
    on: {
      "click": _vm.inviteOwner
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-pencil"
  }), _vm._v("\n            Solicitar Correção\n          ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ownerInvite),
      expression: "ownerInvite"
    }],
    staticStyle: {
      "font-size": "10px",
      "color": "gray"
    }
  }, [_vm._v("Requisitante já foi notificado.")])]) : _vm._e()], 2) : _c('div', {
    staticClass: "result text-center"
  }, [(_vm.request.status == 'grant') ? _c('span', {
    staticClass: "glyphicon glyphicon-ok ok"
  }) : _vm._e(), _vm._v(" "), (_vm.request.status == 'deny') ? _c('span', {
    staticClass: "glyphicon glyphicon-remove notOk"
  }) : _vm._e(), _vm._v(" "), (_vm.request.status == 'processing') ? _c('span', {
    staticClass: "glyphicon glyphicon-hourglass wait"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [(_vm.canReopen) ? _c('button', {
    staticClass: "btn btn-primary control",
    on: {
      "click": function($event) {
        return _vm.openTrammitModal('reopen')
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-open"
  }), _vm._v(" Reabrir\n        ")]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('comment-timeline-overview', {
    attrs: {
      "comments": _vm.comments
    }
  })], 1), _vm._v(" "), (_vm.actionFormValues.length) ? _c('div', {
    staticClass: "info col-sm-9"
  }, _vm._l((_vm.actionValuesGroups), function(fields, actionId, i) {
    return _c('table', {
      key: _vm.action,
      staticClass: "table table-bordered table-striped request-table action-fields-table",
      staticStyle: {
        "table-layout": "fixed"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "title"
    }, [_c('th', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(_vm.getActionName(actionId)))])])]), _vm._v(" "), _vm._l((fields), function(field) {
      return _c('tbody', {
        key: field.objectId
      }, [_c('tr', {
        class: {
          'user-evaluation': field.type == 'user'
        }
      }, [_c('td', [_vm._v(_vm._s(field.name))]), _vm._v(" "), _c('td', [_c('dynamic-view-field', {
        attrs: {
          "field": field,
          "sectionOrder": i,
          "sectionId": _vm.sectionId
        }
      })], 1)])])
    })], 2)
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.commentEvent == 'processing') ? _c('span', [(!_vm.customizations.trammitButton) ? _c('span', [_vm._v("Tramitar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.trammitButton))])]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'grant') ? _c('span', [(!_vm.customizations.grantButton) ? _c('span', [_vm._v("Aprovar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.grantButton))])]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'deny') ? _c('span', [(!_vm.customizations.denyButton) ? _c('span', [_vm._v("Rejeitar Requisição")]) : _c('span', [_vm._v(_vm._s(_vm.customizations.denyButton))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Atenção: ")]), _vm._v("\n          Tem certeza que deseja \n          "), (_vm.commentEvent == 'processing') ? _c('span', [_vm._v("tramitar a requisição para o próximo passo ("), _c('strong', [_vm._v(_vm._s(_vm.getNextStep()))]), _vm._v(")?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'grant') ? _c('span', [_vm._v("finalizar o processamento com "), _c('strong', {
    staticClass: "grant"
  }, [_vm._v("sucesso")]), _vm._v("?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'deny') ? _c('span', [_c('strong', {
    staticClass: "deny"
  }, [_vm._v("rejeitar")]), _vm._v(" a requisição e finalizar o processo?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'reopen') ? _c('span', [_vm._v("reabrir a requisição?")]) : _vm._e(), _vm._v(" "), (_vm.commentEvent == 'revert') ? _c('span', [_vm._v("reverter a requisição para o passo anterior?")]) : _vm._e()]), _vm._v(" "), (_vm.privateStepFields.length > 0) ? _c('fieldset', [_c('legend', [_vm._v("Informações Privadas")]), _vm._v(" "), _vm._l((_vm.privateStepFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.publicStepFields.length > 0) ? _c('fieldset', [_c('legend', [_vm._v("Informações Públicas")]), _vm._v(" "), _vm._l((_vm.publicStepFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e()], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Comentário")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.contentModal),
      callback: function($$v) {
        _vm.contentModal = $$v
      },
      expression: "contentModal"
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": function($event) {
        return _vm.prepareFieldsToSave()
      }
    },
    slot: "footer"
  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showActionModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.currentAction.name))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.loadingAction) ? _c('div', [_c('loader')], 1) : _c('div', {
    staticClass: "form"
  }, [(!_vm.actionFields.length) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n            Nenhum campo para avaliação foi cadastrado.\n          ")]) : _vm._l((_vm.actionFields), function(formField) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "field-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n              " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-muted field-desc"
    }, [_vm._v(_vm._s(formField.description))]), _vm._v(" "), (formField.type === 'text') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "4",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'link') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "url",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'number') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "required": "",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId
      },
      domProps: {
        "value": (formField.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(formField, "value", $event.target.value)
        }
      }
    }) : (formField.type === 'date') ? _c('datepicker', {
      attrs: {
        "type": "date",
        "clear-button": true,
        "required": "",
        "format": "dd/MM/yyyy",
        "placeholder": 'Entre com o(a) ' + formField.name,
        "id": formField.objectId,
        "language": "pt-br",
        "input-class": "form-control field-date"
      },
      model: {
        value: (formField.value),
        callback: function($$v) {
          _vm.$set(formField, "value", $$v)
        },
        expression: "formField.value"
      }
    }) : (formField.type === 'select') ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (formField.value),
        expression: "formField.value"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": 'Entre com o(a) ' + formField.name
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((formField.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option
        }
      }, [_vm._v(_vm._s(option.name))])
    }), 0) : (formField.type === 'file') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "file",
        "required": "",
        "id": formField.objectId
      },
      on: {
        "change": function($event) {
          return _vm.onChange(formField, $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (formField.type === 'user') ? _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": formField.objectId,
        "readonly": ""
      },
      domProps: {
        "value": _vm.user.get('name')
      }
    }) : _vm._e()], 1)
  })], 2)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm",
      "disabled": !_vm.actionFields.length
    },
    on: {
      "click": function($event) {
        return _vm.processStepActions()
      }
    },
    slot: "footer"
  }, [_vm._v("Confirmar")])]) : _vm._e(), _vm._v(" "), (_vm.showEditModal) ? _c('modal', {
    on: {
      "close": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("EDIÇÃO")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Valor Atual:")]), _vm._v(" "), _c('dynamic-view-field', {
    attrs: {
      "field": _vm.currentEditField
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Novo Valor:")]), _vm._v(" "), _c('dynamic-form-field', {
    attrs: {
      "onChange": _vm.onChange,
      "formField": _vm.newEditField
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": function($event) {
        return _vm.saveNewFieldVersion(_vm.currentEditField.objectId, _vm.newEditField)
      }
    },
    slot: "footer"
  }, [_vm._v("Salvar")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Comentários mais recentes")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px"
    }
  }, [_vm._v("(Mensagens)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-user profile"
  })])])
}]}

/***/ }),

/***/ 1430:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.objectId,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 left"
    }, [_c('comment-icon', {
      staticClass: "icon",
      attrs: {
        "event": comment.event
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-comment"
    }, [_c('comment-event', {
      attrs: {
        "event": comment.event
      }
    }), _vm._v(" (" + _vm._s(comment.owner.name) + ")")], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 right"
    }, [_c('b', [_vm._v(_vm._s(_vm.format(comment.createdAt)))])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('b', [_vm._v("Eventos")])])
}]}

/***/ }),

/***/ 1431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Adicionar Ação")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.name),
      expression: "newAction.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newAction.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.description),
      expression: "newAction.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newAction.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.type),
      expression: "newAction.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Tipo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAction, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change()
      }]
    }
  }, _vm._l((_vm.fieldTypes), function(fieldType) {
    return _c('option', {
      domProps: {
        "value": fieldType
      }
    }, [_vm._v(_vm._s(fieldType))])
  }), 0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAction.value),
      expression: "newAction.value"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "link",
      "placeholder": "URL do link",
      "type": "url"
    },
    domProps: {
      "value": (_vm.newAction.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAction, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Workflow")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n          Já existem requisições vinculadas a este fluxo. Tomar cuidado com modificações nas "), _c('b', [_vm._v("Zonas de Perigo")]), _vm._v(".\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.name),
      expression: "workflow.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.workflow.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.workflow, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "description",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.workflow.description),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "description", $$v)
      },
      expression: "workflow.description"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'panel-danger': _vm.hasLinkedRequests
    }
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('b', [_vm._v("Zona de Perigo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "target-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "target"
    }
  }, [_vm._v("Grupo Alvo")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "target",
      "label": "description",
      "track-by": "objectId",
      "options": _vm.groups,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.target),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "target", $$v)
      },
      expression: "workflow.target"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "target-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "responsible"
    }
  }, [_vm._v("Grupo Responsável")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "responsible",
      "label": "description",
      "track-by": "objectId",
      "options": _vm.groups,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.responsible),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "responsible", $$v)
      },
      expression: "workflow.responsible"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "reqtype-group"
    }
  }, [_c('label', {
    attrs: {
      "for": "reqType"
    }
  }, [_vm._v("Tipo de Requisição")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "reqType",
      "label": "name",
      "track-by": "objectId",
      "options": _vm.reqTypes,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.workflow.reqType),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "reqType", $$v)
      },
      expression: "workflow.reqType"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "startdate-group"
    }
  }, [_c('label', [_vm._v("Início de Vigência")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "type": "date",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "clear-button": true,
      "input-class": "form-control field-date"
    },
    on: {
      "cleared": _vm.onStartDateCleared
    },
    model: {
      value: (_vm.workflow.startDate),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "startDate", $$v)
      },
      expression: "workflow.startDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "enddate-group"
    }
  }, [_c('label', [_vm._v("Fim de Vigência")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "type": "date",
      "format": "dd/MM/yyyy",
      "language": "pt-br",
      "clear-button": true,
      "input-class": "form-control field-date"
    },
    on: {
      "cleared": _vm.onEndDateCleared
    },
    model: {
      value: (_vm.workflow.endDate),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "endDate", $$v)
      },
      expression: "workflow.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "active"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.active),
      expression: "workflow.active"
    }],
    attrs: {
      "id": "active",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.workflow.active) ? _vm._i(_vm.workflow.active, null) > -1 : (_vm.workflow.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.workflow.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.workflow, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.workflow, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.workflow, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "feedback"
    }
  }, [_vm._v("Permitir acompanhamento do usuário")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workflow.feedback),
      expression: "workflow.feedback"
    }],
    attrs: {
      "id": "feedback",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.workflow.feedback) ? _vm._i(_vm.workflow.feedback, null) > -1 : (_vm.workflow.feedback)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.workflow.feedback,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.workflow, "feedback", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.workflow, "feedback", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.workflow, "feedback", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Define se o usuário alvo do workflow poderá acompanhar o processo passo a passo.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('a', {
    staticClass: "more-options",
    on: {
      "click": function($event) {
        _vm.viewMoreOptions = !_vm.viewMoreOptions
      }
    }
  }, [_vm._v("Outras Opções")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewMoreOptions) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "trammitButton"
    }
  }, [_vm._v("Texto do Botão \"Tramitar\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.trammitButton),
      expression: "customizations.trammitButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "trammitButton",
      "type": "text",
      "placeholder": "Ex. Tramitar"
    },
    domProps: {
      "value": (_vm.customizations.trammitButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "trammitButton", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "grantButton"
    }
  }, [_vm._v("Texto do Botão \"Deferir\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.grantButton),
      expression: "customizations.grantButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "grantButton",
      "type": "text",
      "placeholder": "Ex. Deferir"
    },
    domProps: {
      "value": (_vm.customizations.grantButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "grantButton", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "denyButton"
    }
  }, [_vm._v("Texto do Botão \"Indeferir\"")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.denyButton),
      expression: "customizations.denyButton"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "denyButton",
      "type": "text",
      "placeholder": "Ex. Indeferir"
    },
    domProps: {
      "value": (_vm.customizations.denyButton)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "denyButton", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canSendInvites"
    }
  }, [_vm._v("Pode enviar Convites?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.canSendInvites),
      expression: "customizations.canSendInvites"
    }],
    attrs: {
      "id": "canSendInvites",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.canSendInvites) ? _vm._i(_vm.customizations.canSendInvites, null) > -1 : (_vm.customizations.canSendInvites)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.canSendInvites,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "canSendInvites", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "canSendInvites", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "canSendInvites", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canEdit"
    }
  }, [_vm._v("Pode editar a inscrição?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.canEdit),
      expression: "customizations.canEdit"
    }],
    attrs: {
      "id": "canEdit",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.canEdit) ? _vm._i(_vm.customizations.canEdit, null) > -1 : (_vm.customizations.canEdit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.canEdit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "canEdit", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "canEdit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "canEdit", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "mailContact"
    }
  }, [_vm._v("Email para contato")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.mailContact),
      expression: "customizations.mailContact"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "mailContact",
      "type": "email"
    },
    domProps: {
      "value": (_vm.customizations.mailContact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "mailContact", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inviteEmailText"
    }
  }, [_vm._v("Texto do Email de Convites")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "inviteEmailText",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.customizations.inviteEmail),
      callback: function($$v) {
        _vm.$set(_vm.customizations, "inviteEmail", $$v)
      },
      expression: "customizations.inviteEmail"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "requestEndMessage"
    }
  }, [_vm._v("Texto da requisição submetida")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "requestEndMessage",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.customizations.requestEndMessage),
      callback: function($$v) {
        _vm.$set(_vm.customizations, "requestEndMessage", $$v)
      },
      expression: "customizations.requestEndMessage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "limit_user_requests"
    }
  }, [_vm._v("Limitar Número de Requisições")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.hasUserRequestsLimit),
      expression: "customizations.hasUserRequestsLimit"
    }],
    attrs: {
      "id": "limit_user_requests",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.customizations.hasUserRequestsLimit) ? _vm._i(_vm.customizations.hasUserRequestsLimit, null) > -1 : (_vm.customizations.hasUserRequestsLimit)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.customizations.hasUserRequestsLimit,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.customizations, "hasUserRequestsLimit", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.customizations, "hasUserRequestsLimit", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.customizations, "hasUserRequestsLimit", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Deve existir um limite de requisições por usuário?")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "limit_user_requests"
    }
  }, [_vm._v("Limite do Número de Requisições")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customizations.userRequestsLimit),
      expression: "customizations.userRequestsLimit"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "limit_user_requests",
      "type": "number"
    },
    domProps: {
      "value": (_vm.customizations.userRequestsLimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customizations, "userRequestsLimit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Quantidade de requisições por usuário. (Depende do campo \"Limitar Número de Requisições\")")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "advanced"
    }
  }, [_vm._v("Informações Compartilhadas")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Se não especificado, todos campos serão visíveis",
      "label": "name",
      "track-by": "objectId"
    },
    model: {
      value: (_vm.workflow.defaultSharedFields),
      callback: function($$v) {
        _vm.$set(_vm.workflow, "defaultSharedFields", $$v)
      },
      expression: "workflow.defaultSharedFields"
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tags"
    }
  }, [_vm._v("Tags")]), _vm._v(" "), _c('input-tag', {
    attrs: {
      "tags": _vm.workflow.tags
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Categorias do Workflow na página inicial.")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "panel",
    class: {
      'panel-danger': _vm.hasLinkedRequests
    }
  }, [(_vm.hasLinkedRequests) ? _c('div', {
    staticClass: "panel-heading"
  }, [_c('b', [_vm._v("Zona de Perigo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h3', [_vm._v("Fluxo de processamento")]), _vm._v(" "), _c('steps', {
    attrs: {
      "steps": _vm.steps,
      "editable": true,
      "linked-requests": _vm.hasLinkedRequests,
      "events": {
        addStep: _vm.addStep,
        removeStep: _vm.removeStep,
        addFieldsToTrammit: _vm.addFieldsToTrammit,
        addExtraActions: _vm.addExtraActions
      },
      "groups": _vm.groups
    }
  })], 1)])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")])])
},staticRenderFns: []}

/***/ }),

/***/ 1433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Workflows")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-new-workflow",
      "to": {
        name: 'WorkflowDetail'
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Novo")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('b-form-select', {
    staticClass: "input-sm",
    attrs: {
      "options": [{
        text: 5,
        value: 5
      }, {
        text: 10,
        value: 10
      }, {
        text: 15,
        value: 15
      }]
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "workflow-table",
      "items": _vm.workflows,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(item.value ? 'Ativo' : 'Inativo') + "\n      ")])
      }
    }, {
      key: "target",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(item.value ? item.value.description : '') + "\n      ")])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [_c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'WorkflowDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-edit"
        }), _vm._v(" Editar\n          ")])], 1)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": this.workflows.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Outras requisições\n          "), (_vm.hasNewer(_vm.sortedItems, _vm.request.objectId)) ? _c('span', {
    staticClass: "glyphicon glyphicon-warning-sign",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "title": "Existem requisições mais novas!"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right clickable show-more",
    on: {
      "click": function($event) {
        _vm.showRequestData = !_vm.showRequestData
      }
    }
  }, [_vm._v(_vm._s(!_vm.showRequestData ? 'Mostrar' : 'Esconder'))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRequestData) ? _c('tbody', [_c('tr', [_c('th', [_vm._v("Requisição")]), _vm._v(" "), _c('th', [_vm._v("Data")])]), _vm._v(" "), _vm._l((_vm.linked), function(element) {
    return _c('tr', {
      key: element.objectId
    }, [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          path: '/request/' + element.objectId
        },
        "replace": "",
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(element.objectId) + " ")]), _vm._v(" "), (_vm.hasNewer(_vm.sortedItems, element.objectId)) ? _c('span', {
      staticClass: "glyphicon glyphicon-warning-sign",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "title": "Existem requisições mais novas!"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatDate(element.createdAt)))])])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Adicionar Usuários")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "select-items"
    }
  }, [_vm._v("Opções do select")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.csv),
      expression: "csv"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-items",
      "rows": "6",
      "placeholder": "Insira os dados dos usuários"
    },
    domProps: {
      "value": (_vm.csv)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.csv = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Resultado - " + _vm._s(_vm.users.length) + " Usuário(s) identificado(s)")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Verifique se os itens foram reconhecidos corretamente.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sprited"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(user) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', [_c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((user.tags), function(tag) {
      return _c('li', [_c('span', {
        staticClass: "label label-primary text-capitalize"
      }, [_vm._v(_vm._s(tag))])])
    }), 0)])])
  }), 0)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.users.length
    },
    on: {
      "click": _vm.importUsers
    }
  }, [_vm._v("Importar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Adicione os usuários como linhas, com suas colunas separadas por \";\" (ponto e vírgula) e os dados adicionais separados por \",\" (vírgula) no seguinte formato "), _c('b', [_vm._v("login; nome; email; dados1, dado2, dado3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Ex: josedasilva@email.com; josedasilva@email.com; José da Silva; Professor, Ciências Naturais, Matemática")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Username")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Tags")])])])
}]}

/***/ }),

/***/ 1436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Requisições Disponíveis")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "col-md-3 sidebar"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      staticClass: "col-sm-6 col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "panel panel-default panel-heading clickable",
      class: {
        'selected': tag === _vm.selectedTag
      },
      on: {
        "click": function($event) {
          _vm.selectedTag = tag
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-center"
    }, [_c('div', [_c('span', {
      staticClass: "huge"
    }, [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('span', {
      staticClass: "badge pull-right"
    }, [_vm._v(_vm._s(_vm.tagCount(tag)))])]), _vm._v(" "), _c('div')])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar..."
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.workflows.length > 0) ? _c('div', {
    staticClass: "list-group",
    attrs: {
      "id": "request-types-list"
    }
  }, _vm._l((_vm.filteredWorkflows), function(workflow) {
    return _c('router-link', {
      key: workflow.objectId,
      staticClass: "list-group-item",
      attrs: {
        "to": {
          name: 'RequestForm',
          params: {
            workflowId: workflow.objectId
          }
        }
      }
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v(_vm._s(workflow.name))]), _vm._v(" "), (workflow.reqType) ? _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(workflow.reqType.name))]) : _vm._e()])
  }), 1) : _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n            Não há fluxos cadastrados no sistema.\n        ")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1437:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_c('span', {
    staticClass: "glyphicon glyphicon-user"
  }), _vm._v(" " + _vm._s(_vm.loggedUser.get('name')))]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-request",
      "to": {
        name: 'RequestOpen'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Abrir Requisição\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'mine')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('mine')
      }
    }
  }, [_c('a', [_vm._v("Minhas Requisições "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.userRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'linked')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('linked')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "linked-requests-panel-link"
    }
  }, [_vm._v("Requisições Vinculadas em Aberto "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.linkedRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'invites')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('invites')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "linked-requests-panel-link"
    }
  }, [_vm._v("Convites de Requisições "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.invitedRequestsCount))])])]), _vm._v(" "), _c('li', {
    staticClass: "tab",
    class: {
      active: (_vm.tabs.active == 'workflows')
    },
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        return _vm.changeTab('workflows')
      }
    }
  }, [_c('a', {
    attrs: {
      "id": "workflows-panel-link"
    }
  }, [_vm._v("Fluxos que sou responsável "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.reponsibleWorkflowsCount))])])])]), _vm._v(" "), (_vm.tabs.active == 'mine') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userRequestsPerPage),
      expression: "userRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.userRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUserRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUserRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.userRequestsFilter),
      callback: function($$v) {
        _vm.userRequestsFilter = $$v
      },
      expression: "userRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "user-requests",
      "items": _vm.userRequests,
      "fields": _vm.userRequestsfields,
      "striped": "",
      "hover": "",
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {
          staticClass: "glyphicon glyphicon-file"
        })
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [_vm._v(" " + _vm._s(item.value.get('name')))])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [(item.item.workflow.get('feedback')) ? _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search",
          attrs: {
            "title": "Ver Requisição"
          }
        }), _vm._v(" Ver/Editar\n              ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestConfirmation',
              params: {
                requestId: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-ok",
          attrs: {
            "title": "Ver Confirmação"
          }
        }), _vm._v(" Confirmação\n              ")])], 1)
      }
    }], null, false, 486712661)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "empty"
    },
    slot: "empty"
  })]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.userRequestsCount,
      "per-page": _vm.userRequestsPerPage
    },
    on: {
      "input": _vm.getUserRequests
    },
    model: {
      value: (_vm.userRequestsCurrentPage),
      callback: function($$v) {
        _vm.userRequestsCurrentPage = $$v
      },
      expression: "userRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'linked') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linkedRequestsPerPage),
      expression: "linkedRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.linkedRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getLinkedRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getLinkedRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.linkedRequestsFilter),
      callback: function($$v) {
        _vm.linkedRequestsFilter = $$v
      },
      expression: "linkedRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "linked-requests",
      "items": _vm.linkedRequests,
      "fields": _vm.linkedRequestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 1359373302)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.linkedRequestsCount,
      "per-page": _vm.linkedRequestsPerPage
    },
    on: {
      "input": _vm.getLinkedRequests
    },
    model: {
      value: (_vm.linkedRequestsCurrentPage),
      callback: function($$v) {
        _vm.linkedRequestsCurrentPage = $$v
      },
      expression: "linkedRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'invites') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invitedRequestsPerPage),
      expression: "invitedRequestsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.invitedRequestsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getInvitedRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getInvitedRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.invitedRequestsFilter),
      callback: function($$v) {
        _vm.invitedRequestsFilter = $$v
      },
      expression: "invitedRequestsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "linked-requests",
      "items": _vm.invitedRequests,
      "fields": _vm.invitedRequestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 2922140410)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.invitedRequestsCount,
      "per-page": _vm.invitedRequestsPerPage
    },
    on: {
      "input": _vm.getInvitedRequests
    },
    model: {
      value: (_vm.invitedRequestsCurrentPage),
      callback: function($$v) {
        _vm.invitedRequestsCurrentPage = $$v
      },
      expression: "invitedRequestsCurrentPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.tabs.active == 'workflows') ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reponsibleWorkflowsPerPage),
      expression: "reponsibleWorkflowsPerPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reponsibleWorkflowsPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getResponsibleWorkflows]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getResponsibleWorkflows.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.reponsibleWorkflowsFilter),
      callback: function($$v) {
        _vm.reponsibleWorkflowsFilter = $$v
      },
      expression: "reponsibleWorkflowsFilter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "workflows-table",
      "items": _vm.reponsibleWorkflows,
      "fields": _vm.reponsibleWorkflowsFields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-log-out"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "name",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'WorkflowRequests',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }], null, false, 1234916202)
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.reponsibleWorkflowsCount,
      "per-page": _vm.reponsibleWorkflowsPerPage
    },
    on: {
      "input": _vm.getResponsibleWorkflows
    },
    model: {
      value: (_vm.reponsibleWorkflowsCurrentPage),
      callback: function($$v) {
        _vm.reponsibleWorkflowsCurrentPage = $$v
      },
      expression: "reponsibleWorkflowsCurrentPage"
    }
  })], 1) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1438:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Campos do Formulário do Passo \"" + _vm._s(_vm.step.name) + "\"")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'StepFieldDetail',
        params: {
          stepId: _vm.$route.params.stepId,
          actionId: _vm.$route.params.actionId
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Campo\n    ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.fields.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n      O passo ainda não possui campos de preenchimento.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, _vm._l((_vm.fields), function(f, index) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('span', [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'text') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'number') ? _c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }) : _vm._e(), _vm._v(" "), (f.type == 'date') ? _c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }) : _vm._e(), _vm._v(" "), (f.type == 'file') ? _c('span', {
      staticClass: "glyphicon glyphicon-file"
    }) : _vm._e(), _vm._v(" "), (f.type == 'select') ? _c('span', {
      staticClass: "glyphicon glyphicon-list"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v(" "), (f.type == 'textarea') ? _c('span', {
      staticClass: "glyphicon glyphicon-font"
    }) : _vm._e(), _vm._v(" "), (f.type == 'user') ? _c('span', {
      staticClass: "glyphicon glyphicon-user"
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(f.name) + "\n                    "), (f.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("(Obrigatório)")]) : _vm._e(), _vm._v(" "), (f.private) ? _c('span', {
      staticClass: "private"
    }, [_vm._v("(Campo Privado)")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'StepFieldDetail',
          params: {
            stepId: _vm.$route.params.stepId,
            actionId: _vm.$route.params.actionId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar campo"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover campo"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n                      ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1439:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Adicionar Campo")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.name),
      expression: "newField.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newField.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.description),
      expression: "newField.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "type": "text",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newField.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.type),
      expression: "newField.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Tipo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newField, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change()
      }]
    }
  }, _vm._l((_vm.fieldTypes), function(fieldType) {
    return _c('option', {
      domProps: {
        "value": fieldType
      }
    }, [_vm._v(_vm._s(fieldType))])
  }), 0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "select-items"
    }
  }, [_vm._v("Opções do select")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Adicione os items como linhas, com duas colunas separadas por \";\" (ponto e vírgula). "), _c('b', [_vm._v("Ex: 12345; Item de Exemplo")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionsCSV),
      expression: "optionsCSV"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-items",
      "rows": "6",
      "placeholder": "Opções"
    },
    domProps: {
      "value": (_vm.optionsCSV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.optionsCSV = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Resultado")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Verifique se os itens foram reconhecidos corretamente.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sprited"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Identificador")]), _vm._v(" "), _c('th', [_vm._v("Descrição")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.newField.options), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "required"
    }
  }, [_vm._v("Obrigatório")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.required),
      expression: "newField.required"
    }],
    attrs: {
      "id": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newField.required) ? _vm._i(_vm.newField.required, null) > -1 : (_vm.newField.required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newField.required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newField, "required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newField, "required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newField, "required", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "required"
    }
  }, [_vm._v("Campo Privado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.private),
      expression: "newField.private"
    }],
    attrs: {
      "id": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newField.private) ? _vm._i(_vm.newField.private, null) > -1 : (_vm.newField.private)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newField.private,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newField, "private", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newField, "private", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newField, "private", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1440:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(!_vm.showCustomLogin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("Sou Servidor do IFPE")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Para todos os servidores do IFPE com acesso unificado")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.askAuthIFPE
    }
  }, [_vm._v("Entrar com minha conta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("Demais Usuários")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Para todos os estudantes e usuários externos")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCustomLogin = true
      }
    }
  }, [_vm._v("Entrar/Cadastrar")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showCustomLogin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-signin"
  }, [_c('h2', {
    staticClass: "form-signin-heading"
  }, [_vm._v("Acesso ao Sistema")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputLogin"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputLogin",
      "placeholder": "Email",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Senha",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-primary col-sm-6",
    attrs: {
      "id": "bntLogin"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("Entrar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "extraActions"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Não possui conta? Cadastre-se")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/password-reset"
    }
  }, [_vm._v("Esqueci a senha")])], 1), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void()"
    },
    on: {
      "click": function($event) {
        _vm.showCustomLogin = false
      }
    }
  }, [_vm._v("Voltar")])])])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1441:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-clip",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('clip-loader', {
    attrs: {
      "loading": _vm.loading,
      "color": "#337ab7"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quill-editor"
  })
},staticRenderFns: []}

/***/ }),

/***/ 1444:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Requisições associadas a \""), _c('b', [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v("\"")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "tab",
    class: 'active',
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', [_vm._v("Requisições "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    staticStyle: {
      "margin": "10px"
    },
    on: {
      "click": _vm.addFilterField
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Filtro\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.fieldFilters.length) ? _c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Nenhum filtro adicional aplicado.")]) : _vm._l((_vm.fieldFilters), function(fieldFilter, index) {
    return _c('div', {
      key: fieldFilter.field.objectId,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4 form-group"
    }, [_c('multiselect', {
      attrs: {
        "id": "formSelect",
        "label": "name",
        "track-by": "name",
        "options": _vm.formFields,
        "placeholder": "Selecione uma opção",
        "selectLabel": 'Pressione enter',
        "hide-selected": true
      },
      model: {
        value: (fieldFilter.field),
        callback: function($$v) {
          _vm.$set(fieldFilter, "field", $$v)
        },
        expression: "fieldFilter.field"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(fieldFilter.operator))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5 form-group"
    }, [_c('dynamic-form-field', {
      attrs: {
        "onChange": function () {},
        "formField": fieldFilter.field
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 text-center"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm btn-danger glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          return _vm.removeFilter(index)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "title": "Download de Todas as Requisições"
    },
    on: {
      "click": _vm.downloadWorkflowRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download"
  }), _vm._v(" Download de Todas as Requisições\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": _vm.getRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v(" Aplicar Filtros\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('span', {
      key: status.value,
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.statusFilter),
        expression: "statusFilter"
      }],
      attrs: {
        "type": "checkbox",
        "id": status.value
      },
      domProps: {
        "value": status.value,
        "checked": Array.isArray(_vm.statusFilter) ? _vm._i(_vm.statusFilter, status.value) > -1 : (_vm.statusFilter)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.statusFilter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = status.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.statusFilter = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.statusFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.statusFilter = $$c
          }
        }, _vm.getRequests]
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "for": status.value
      }
    }, [_vm._v(_vm._s(status.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), (_vm.requests.length > 0) ? _c('b-table', {
    attrs: {
      "id": "user-requests",
      "items": _vm.requests,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "currentStep",
      fn: function(item) {
        return [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")]
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n            ")])
      }
    }], null, false, 1953540879)
  }) : _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n              Nenhuma requisição. "), (_vm.filter) ? _c('span', [_vm._v("(Tente remover o filtro e listar novamente)")]) : _vm._e()])]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getRequests
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1445:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-input-tag-wrapper",
    class: {
      'read-only': _vm.readOnly
    },
    on: {
      "click": function($event) {
        return _vm.focusNewTag()
      }
    }
  }, [_vm._l((_vm.tags), function(tag, index) {
    return _c('span', {
      key: index,
      staticClass: "input-tag"
    }, [_c('span', [_vm._v(_vm._s(tag))]), _vm._v(" "), (!_vm.readOnly) ? _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.remove(index)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.readOnly) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTag),
      expression: "newTag"
    }],
    staticClass: "new-tag",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "text"
    },
    domProps: {
      "value": (_vm.newTag)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) { return null; }
        $event.stopPropagation();
        return _vm.removeLastTag()
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 188 && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addNew(_vm.newTag)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTag = $event.target.value
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1446:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.hasVersions) ? _c('span', {
    staticClass: "pull-right history",
    on: {
      "click": function($event) {
        _vm.showHistory = !_vm.showHistory
      }
    }
  }, [_vm._v("\n    Alterado " + _vm._s(_vm.hasVersions) + " vez"), (_vm.hasVersions > 1) ? _c('span', [_vm._v("es")]) : _vm._e(), _vm._v(".\n\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return _c('div', [(version.type == 'text' || version.type == 'textarea' || version.type == 'cpf' || version.type == 'cnpj' || version.type == 'phone') ? _c('span', [_vm._v("\n      " + _vm._s(version.stringField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'computed') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.compute(version.stringField, _vm.fields.filter(function (f) { return !f.newerVersion && _vm.isSameSection(f, _vm.sectionOrder + 1, _vm.sectionId); }))) + " "), _c('span', {
      staticClass: "pull-right",
      staticStyle: {
        "color": "gray"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-info-sign",
      attrs: {
        "title": version.stringField
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("Computado automaticamente")])])]) : _vm._e(), _vm._v(" "), (version.type == 'date' && version.dateField) ? _c('span', [_c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }), _vm._v(" " + _vm._s(new Date(version.dateField.iso).toLocaleString('pt-BR')) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'number') ? _c('span', [_vm._v("\n      " + _vm._s(version.numField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'money') ? _c('span', [_vm._v("\n      " + _vm._s(version.numField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'checkbox') ? _c('span', [_c('ul', {
      staticClass: "list-inline"
    }, _vm._l((version.checkboxField), function(option) {
      return _c('li', [_c('span', {
        staticClass: "glyphicon glyphicon-ok"
      }), _vm._v("\n        " + _vm._s(option.name))])
    }), 0)]) : _vm._e(), _vm._v(" "), (version.type == 'link') ? _c('a', {
      attrs: {
        "href": version.stringField,
        "target": "_blank"
      }
    }, [(version.stringField) ? _c('span', {
      staticClass: "glyphicon glyphicon-new-window"
    }) : _vm._e(), _vm._v("\n      " + _vm._s(version.stringField) + "\n    ")]) : _vm._e(), _vm._v(" "), (version.type == 'file') ? _c('span', [(!version.fileField) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Nenhum arquivo anexado.")]) : _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-paperclip"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": version.fileField.url,
        "target": "_blank"
      }
    }, [_vm._v("Visualizar")])])]) : _vm._e(), _vm._v(" "), (version.type == 'document') ? _c('span', [(!version.fileField) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Nenhum arquivo anexado.")]) : _c('div', [_c('span', {
      staticClass: "glyphicon glyphicon-paperclip"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": version.fileField.url,
        "target": "_blank"
      }
    }, [_vm._v("Visualizar")])])]) : _vm._e(), _vm._v(" "), (version.type === 'select' && version.selectField) ? _c('span', [_vm._v("\n      " + _vm._s(version.selectField.name) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.showHistory) ? _c('span', [_vm._v("por "), _c('span', {
      staticClass: "version-owner"
    }, [_vm._v(_vm._s(version.owner.username))]), _vm._v(" "), _c('span', {
      staticClass: "version-date"
    }, [_vm._v(_vm._s(_vm.formatDate(version.createdAt)))])]) : _vm._e()])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1447:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', [_vm._v("Regras para definição dinâmica de grupo")]), _vm._v(" "), (_vm.step.name) ? _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v(_vm._s(_vm.step.workflow.name))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.step.name))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.step.target.description))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.rules.length === 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Nenhuma regra de redirecionamento")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rules), function(rule, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Operação")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.operation),
        expression: "rule.operation"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "operation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.fieldRules), function(opt) {
      return _c('option', [_vm._v(_vm._s(opt))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', [_vm._v("Nome do Campo")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.fieldName),
        expression: "rule.fieldName"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (rule.fieldName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "fieldName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Argumento")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.argument),
        expression: "rule.argument"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (rule.argument)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "argument", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', [_vm._v("Grupo Alvo")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "label": "description",
        "track-by": "objectId",
        "options": _vm.subGroups,
        "showLabels": false,
        "placeholder": "Selecione uma opção"
      },
      model: {
        value: (rule.target),
        callback: function($$v) {
          _vm.$set(rule, "target", $$v)
        },
        expression: "rule.target"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Ações")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm form-control btn-danger",
      on: {
        "click": function($event) {
          return _vm.rules.splice(index, 1)
        }
      }
    }, [_vm._v("Remover")])])])
  })], 2)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-default pull-right",
    on: {
      "click": function($event) {
        return _vm.rules.push({})
      }
    }
  }, [_vm._v("Adicionar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1448:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.name),
      expression: "newField.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newField.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.description),
      expression: "newField.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newField.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), (!_vm.hideRequired) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "required"
    }
  }, [_vm._v("Obrigatório")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.required),
      expression: "newField.required"
    }],
    attrs: {
      "id": "required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newField.required) ? _vm._i(_vm.newField.required, null) > -1 : (_vm.newField.required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newField.required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newField, "required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newField, "required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newField, "required", $$c)
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.type),
      expression: "newField.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Tipo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newField, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.change()
      }]
    }
  }, _vm._l((_vm.fieldTypes), function(fieldType) {
    return _c('option', {
      domProps: {
        "value": fieldType
      }
    }, [_vm._v(_vm._s(fieldType))])
  }), 0)]), _vm._v(" "), (_vm.showFormula) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "formula"
    }
  }, [_vm._v("Fórmula")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newField.formula),
      expression: "newField.formula"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "formula",
      "rows": "2",
      "placeholder": "Adicione uma fórmula aqui, considerando o NOME dos outros campos. Exemplo: concat( (Idade do Requisitante + 65).toString(), \"anos\"). Mais detalhes sobre as formulas http://mathjs.org/docs/index.html"
    },
    domProps: {
      "value": (_vm.newField.formula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newField, "formula", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Regras")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.rules.length === 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("Nenhuma regra de redirecionamento")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rules), function(rule, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Operação")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.operation),
        expression: "rule.operation"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(rule, "operation", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.fieldRules), function(opt) {
      return _c('option', [_vm._v(_vm._s(opt))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', [_vm._v("Argumento")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (rule.argument),
        expression: "rule.argument"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (rule.argument)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(rule, "argument", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('label', [_vm._v("Ir para seção")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "label": "name",
        "track-by": "objectId",
        "options": _vm.sections,
        "showLabels": false,
        "placeholder": "Selecione uma opção"
      },
      model: {
        value: (rule.goto),
        callback: function($$v) {
          _vm.$set(rule, "goto", $$v)
        },
        expression: "rule.goto"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', [_vm._v("Ações")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm form-control btn-danger",
      on: {
        "click": function($event) {
          return _vm.rules.splice(index, 1)
        }
      }
    }, [_vm._v("Remover")])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        return _vm.rules.push({})
      }
    }
  }, [_vm._v("Adicionar Regra")])]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "select-items"
    }
  }, [_vm._v("Opções do select")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.optionsCSV),
      expression: "optionsCSV"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "select-items",
      "rows": "6",
      "placeholder": "Opções"
    },
    domProps: {
      "value": (_vm.optionsCSV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.optionsCSV = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Resultado")]), _vm._v(" "), _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Verifique se os itens foram reconhecidos corretamente.")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sprited"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.newField.options), function(item) {
    return _c('tr', {
      key: item.code
    }, [_c('td', [_vm._v(_vm._s(item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))])])
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("Adicione os items como linhas, com duas colunas separadas por \";\" (ponto e vírgula). "), _c('b', [_vm._v("Ex: 12345; Item de Exemplo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Identificador")]), _vm._v(" "), _c('th', [_vm._v("Descrição")])])])
}]}

/***/ }),

/***/ 1449:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Administração")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.isAdminRequests) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/requests",
      "id": "admin-requests"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-duplicate"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Requisições")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminRequestTypes) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/requestTypes",
      "id": "admin-request-types"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-list-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Tipos de Requisição")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminWorkflows) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/workflows",
      "id": "admin-workflows"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-log-in"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Workflows")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminGroups) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/groups",
      "id": "admin-groups"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-th-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Grupos")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isAdminUsers) ? _c('div', {
    staticClass: "col-lg-3 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('router-link', {
    attrs: {
      "to": "/users",
      "id": "admin-users"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-user"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 text-right"
  }, [_c('div', {
    staticClass: "huge"
  }, [_vm._v("Usuários")]), _vm._v(" "), _c('div')])])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.isAdminRequests && !_vm.isAdminRequestTypes && !_vm.isAdminWorkflows && !_vm.isAdminGroups) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      Nenhum privilégio de administrador encontrado.\n  ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1450:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', [_vm._v("Requisição")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v(" "), (_vm.workflow.customizations.mailContact) ? _c('h5', [_vm._v("Caso haja dúvidas entrar em contato com o e-mail "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.workflow.customizations.mailContact
    }
  }, [_vm._v(_vm._s(_vm.workflow.customizations.mailContact))]), _vm._v(".")]) : _vm._e(), _vm._v(" "), (_vm.showRequestsButton) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.seeRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-eye-open"
  }), _vm._v(" Ver Requisições Associadas")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.workflow.description)
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('loader')], 1), _vm._v(" "), _c('steps', {
    attrs: {
      "steps": _vm.steps,
      "editable": false,
      "icons": false,
      "groups": []
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sections.length > 0),
      expression: "sections.length > 0"
    }]
  }, [_c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentFormFields.length > 0),
      expression: "currentFormFields.length > 0"
    }]
  }, [_vm._l((_vm.summary), function(fields, sectionId, i) {
    return (_vm.showSummary) ? _c('div', {
      key: sectionId,
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('h4', [_vm._v(_vm._s(i + 1) + ". " + _vm._s(_vm.getSection(sectionId).name))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((fields), function(formField) {
      return _c('div', {
        key: formField.objectId,
        staticClass: "form-group"
      }, [(formField.type !== 'separator') ? _c('label', {
        staticClass: "control-label",
        attrs: {
          "for": formField.objectId
        }
      }, [_vm._v("\n                  " + _vm._s(formField.name)), (formField.required) ? _c('span', {
        staticClass: "required"
      }, [_vm._v(" *")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (formField.description) ? _c('p', {
        staticClass: "text-muted field-desc",
        domProps: {
          "innerHTML": _vm._s(formField.description)
        }
      }) : _vm._e(), _vm._v(" "), _c('dynamic-form-field', {
        attrs: {
          "formField": formField,
          "showSummary": true
        }
      })], 1)
    }), 0)]) : _vm._e()
  }), _vm._v(" "), (!_vm.showSummary) ? _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "form-fields"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.currentFormFields), function(formField) {
    return _c('div', {
      key: formField.objectId,
      staticClass: "form-group",
      class: {
        'has-error': formField.invalid
      }
    }, [(formField.type !== 'separator') ? _c('label', {
      staticClass: "control-label",
      attrs: {
        "for": formField.objectId
      }
    }, [_vm._v("\n                  " + _vm._s(formField.name)), (formField.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), (formField.type === 'file' && formField.type === 'document') ? _c('span', {
      staticClass: "upload-limit"
    }, [_vm._v("(tamanho máx. 50mb)")]) : _vm._e()]) : _c('h3', [_vm._v(_vm._s(formField.name))]), _vm._v(" "), (formField.description) ? _c('p', {
      staticClass: "text-muted field-desc",
      domProps: {
        "innerHTML": _vm._s(formField.description)
      }
    }) : _vm._e(), _vm._v(" "), _c('dynamic-form-field', {
      attrs: {
        "formField": formField,
        "showSummary": _vm.showSummary,
        "onChange": _vm.onChange
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (formField.invalid),
        expression: "formField.invalid"
      }],
      staticClass: "help-block"
    }, [_vm._v("O campo deve ser preenchido corretamente")])], 1)
  }), 0)]) : _vm._e()], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left"
  }), _vm._v(" Voltar")]), _vm._v(" "), (_vm.showSummary === false) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": !_vm.canReachNext
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Próximo "), _c('span', {
    staticClass: "glyphicon glyphicon-chevron-right"
  })]) : _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "id": "btn-open-request"
    },
    on: {
      "click": _vm.saveRequest
    }
  }, [_vm._v("Finalizar "), _c('span', {
    staticClass: "glyphicon glyphicon-ok"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldsInstances.length),
      expression: "!fieldsInstances.length"
    }]
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O Tipo de Requisição escolhido ainda não possui campos para preenchimento.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sections.length),
      expression: "!sections.length"
    }]
  }, [_c('p', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O Tipo de Requisição escolhido ainda não possui seções.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Voltar")])])])], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "ask-repeat",
      "height": 'auto'
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('h3', [_vm._v("Deseja continuar adicionando informações sobre " + _vm._s(_vm.currentSection() ? _vm.currentSection().name : '') + "?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.answerRepeat(true)
      }
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.answerRepeat(false)
      }
    }
  }, [_vm._v("Não, ir para próxima seção.")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1451:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'circle-container glyphicon ' + _vm.getIconClass()
  })
},staticRenderFns: []}

/***/ }),

/***/ 1452:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "btn btn-default btn-file",
    attrs: {
      "disabled": _vm.showSummary
    }
  }, [_vm._v("\n      Escolher...\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": _vm.images,
      "multiple": "",
      "accept": "image/*",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    on: {
      "change": _vm.imagesAdd
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted field-desc"
  }, [_vm._v("São aceitos apenas imagens. Ex: jpg, jpeg, png, bmp, gif")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formField.invalid),
      expression: "formField.invalid"
    }],
    staticClass: "help-block"
  }, [_vm._v("O campo deve ser preenchido corretamente")])]), _vm._v(" "), _vm._l((_vm.imageData), function(imgDatum) {
    return _c('div', {
      staticClass: "file-upload-form"
    }, [_c('img', {
      staticClass: "preview",
      attrs: {
        "src": imgDatum
      }
    })])
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1453:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Grupos de Requisição")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'GroupDetail'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar\n        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('b-form-select', {
    staticClass: "input-sm",
    attrs: {
      "options": [{
        text: 5,
        value: 5
      }, {
        text: 10,
        value: 10
      }, {
        text: 15,
        value: 15
      }]
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.roleList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "rolesList",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.join(', ')) + "\n            ")])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-sm",
          attrs: {
            "to": {
              name: 'GroupDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-edit"
        }), _vm._v(" Editar\n            ")])
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": this.roleList.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1454:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('legend', [_vm._v("Seções")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'FormSectionDetail',
        params: {
          reqType: _vm.reqType,
          id: null
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Seção\n  ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.sections.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-sections"
    }
  }, [_vm._v("\n            Formulário ainda não possui seções\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.sections),
      callback: function($$v) {
        _vm.sections = $$v
      },
      expression: "sections"
    }
  }, _vm._l((_vm.sections), function(s) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [_vm._v("\n            " + _vm._s(s.name) + "\n            "), _c('span', {
      staticClass: "pull-right"
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(_vm.counts[s.objectId]) + " campo(s)")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'FormSectionDetail',
          params: {
            reqType: _vm.reqType,
            id: s.objectId
          }
        },
        "type": "button",
        "title": "Editar Seção"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover Seção"
      },
      on: {
        "click": function($event) {
          return _vm.remove(s)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n              ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(s.description))])])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1455:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      " + _vm._s(_vm.message) + " "), (_vm.username) ? _c('strong', [_vm._v("[" + _vm._s(_vm.username) + "]")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1456:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-bordered table-striped",
    staticStyle: {
      "table-layout": "fixed"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("\n        Metadados\n        "), _c('span', {
    staticClass: "pull-right clickable show-more",
    on: {
      "click": function($event) {
        _vm.showRequestData = !_vm.showRequestData
      }
    }
  }, [_vm._v(_vm._s(!_vm.showRequestData ? 'Mostrar' : 'Esconder'))])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showRequestData) ? _c('tbody', [(!_vm.isInvited) ? _c('tr', [_c('td', [_vm._v("Nome do Requisitante")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.owner.name))])]) : _vm._e(), _vm._v(" "), (!_vm.isInvited) ? _c('tr', [_c('td', [_vm._v("Identificação")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.owner.username))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Tipo")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.reqType.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [_c('request-status', {
    attrs: {
      "status": _vm.request.status
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Última Atualização")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.request.updatedAt)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Criação")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(_vm.request.createdAt)))])])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1457:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.status === 'grant') ? _c('span', {
    staticClass: "grant"
  }, [_vm._v("Concluído")]) : _vm._e(), _vm._v(" "), (_vm.status === 'deny') ? _c('span', {
    staticClass: "deny"
  }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (_vm.status === 'processing') ? _c('span', {
    staticClass: "processing"
  }, [_vm._v("Em análise")]) : _vm._e(), _vm._v(" "), (_vm.status === 'pendency') ? _c('span', {
    staticClass: "pendency"
  }, [_vm._v("Sob correção")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1458:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.successMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        " + _vm._s(_vm.successMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.choosePassword) ? _c('fieldset', [_c('legend', [_vm._v("Recuperar Senha")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          Para recuperar a senha, precisamos do seu email. Será enviado um link para que você possa trocá-la.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.askReset
    }
  }, [_vm._v("Recuperar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])]) : _vm._e(), _vm._v(" "), (_vm.choosePassword) ? _c('fieldset', [_c('legend', [_vm._v("Escolher Senha")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          Escolha uma nova senha para sua conta\n        ")]), _vm._v(" "), _c('form', {
    staticClass: "form-group",
    attrs: {
      "action": _vm.passwordChangeURL,
      "method": "POST"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "new_password"
    }
  }, [_vm._v("Nova Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "new_password",
      "name": "new_password",
      "type": "password",
      "placeholder": "Nova Senha"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    staticClass: "sr-only",
    attrs: {
      "id": "token",
      "name": "token"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "sr-only",
    attrs: {
      "id": "username",
      "name": "username",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Confirmar")])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-inverse"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navmenu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/userProfile",
      "id": "menu-open-request"
    }
  }, [_vm._v("Minhas Requisições")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/openRequest",
      "id": "menu-open-request"
    }
  }, [_vm._v("Abrir Requisição")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser && _vm.adminUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/management",
      "id": "menu-admin"
    }
  }, [_vm._v("Administração")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(!_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-log-in"
  }), _vm._v(" Entrar")])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "id": "welcome-menu-item",
      "to": "/userProfile",
      "title": "Clique ver seu perfil"
    }
  }, [_vm._v("Bem-vindo, " + _vm._s(_vm.loggedUser.get('name')) + " "), _c('span', {
    staticClass: "badge badge-notifications"
  }, [_vm._v(_vm._s(_vm.numberOfLinkedRequests))])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedUser) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/login?ex=1",
      "id": "btn-logout"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off"
  }), _vm._v(" Sair")])], 1) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navmenu",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Trocar Modo de Navegação")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(1376)
    }
  })])])
}]}

/***/ }),

/***/ 1460:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "gap"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1461:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-request-type",
      "to": {
        name: 'UserImport'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Usuários\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUsers]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUsers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.users,
      "fields": _vm.fields,
      "striped": "",
      "hover": ""
    }
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getUsers
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1462:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", function() {
    return [_vm._v("\n            Título\n          ")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_vm._v("\n            Corpo\n          ")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _vm._t("footer", function() {
    return [_vm._v("\n            Rodapé\n            "), _c('button', {
      staticClass: "modal-default-button",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n              OK\n            ")])]
  })], 2)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1463:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n        Cadastro realizado com sucesso. \n        "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Clique aqui para realizar o login")])], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Meus Dados")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "Ex: maria@barreiros.ifpe.edu.br"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmEmail),
      expression: "confirmEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "emailConf",
      "type": "email"
    },
    domProps: {
      "value": (_vm.confirmEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "passwordConf",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.signup
    }
  }, [_vm._v("Cadastrar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Voltar")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome Completo "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" (de preferência o institucional)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Confirmar Email "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Senha "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Confirmar Senha "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])])
}]}

/***/ }),

/***/ 1464:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.name),
      expression: "newSection.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.newSection.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.description),
      expression: "newSection.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "placeholder": "Descrição"
    },
    domProps: {
      "value": (_vm.newSection.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Repetição")]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("A seção pode se repetir?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.active),
      expression: "newSection.repeat.active"
    }],
    attrs: {
      "id": "repeat",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newSection.repeat.active) ? _vm._i(_vm.newSection.repeat.active, null) > -1 : (_vm.newSection.repeat.active)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newSection.repeat.active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.newSection.repeat, "active", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.newSection.repeat, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.newSection.repeat, "active", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newSection.repeat.active),
      expression: "newSection.repeat.active"
    }]
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repeatMin"
    }
  }, [_vm._v("Mínimo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.min),
      expression: "newSection.repeat.min"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repeatMin",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newSection.repeat.min)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection.repeat, "min", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "repeatMax"
    }
  }, [_vm._v("Máximo")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.repeat.max),
      expression: "newSection.repeat.max"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "repeatMax",
      "type": "number"
    },
    domProps: {
      "value": (_vm.newSection.repeat.max)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSection.repeat, "max", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Ação")]), _vm._v(" "), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("Ação ao submeter dados da seção:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSection.action),
      expression: "newSection.action"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type",
      "placeholder": "Comportamento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newSection, "action", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.sectionActions), function(sectionAction) {
    return _c('option', {
      key: sectionAction.objectId,
      domProps: {
        "value": sectionAction
      }
    }, [_vm._v(_vm._s(sectionAction))])
  }), 0)]), _vm._v(" "), (_vm.newSection.action === 'goto') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "objectId",
      "options": _vm.sections,
      "showLabels": false,
      "placeholder": "Selecione uma opção"
    },
    model: {
      value: (_vm.newSection.goto),
      callback: function($$v) {
        _vm.$set(_vm.newSection, "goto", $$v)
      },
      expression: "newSection.goto"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-save-field",
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancelar")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.requestTypeId && _vm.sectionId) ? _c('form-field-list', {
    attrs: {
      "reqType": _vm.requestTypeId,
      "sectionId": _vm.sectionId
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1465:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "jumbotron text-xs-center"
  }, [(_vm.isConfirmed) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Pronto!")]), _vm._v(" "), _c('h3', {
    staticClass: "display-5"
  }, [_vm._v("Sua submissão "), _c('strong', [_vm._v(_vm._s(_vm.requestId))]), _vm._v(" foi recebida com sucesso!")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.requestEndMessage) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.requestEndMessage)
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n              Encontrou problemas? Entre em contato com o email especificado na requisição\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button",
      "to": {
        name: 'UserProfile'
      }
    }
  }, [_vm._v("Ir para a página inicial")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-danger",
    attrs: {
      "role": "button",
      "to": "/login?ex=1"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("Sair do sistema")])], 1)]), _vm._v(" "), _vm._m(1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Ops")]), _vm._v(" "), _c('h3', {
    staticClass: "display-5"
  }, [_vm._v("Algo deu errado e não foi possível confirmar a submissão!")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n              Encontrou problemas? Entre em contato com o email especificado na requisição\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button",
      "to": {
        name: 'UserProfile'
      }
    }
  }, [_vm._v("Ir para a página inicial")])], 1)]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v("Favor checar seu e-mail")]), _vm._v(" com os detalhes da sua inscrição.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-ok-circle success"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v("Favor tentar novamente.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-remove-circle fail"
  })])
}]}

/***/ }),

/***/ 1466:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Tipos de Requisição")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-add-request-type",
      "to": {
        name: 'RequestTypeDetail'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-default btn-file"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-upload"
  }), _vm._v(" Upload\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".json, application/json"
    },
    on: {
      "change": function($event) {
        return _vm.importReqType($event)
      }
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('b-form-select', {
    staticClass: "input-sm",
    attrs: {
      "options": [{
        text: 5,
        value: 5
      }, {
        text: 10,
        value: 10
      }, {
        text: 15,
        value: 15
      }]
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite para pesquisar"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "id": "request-types-table",
      "items": _vm.requestTypes,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.name))]) : _vm._e()])
      }
    }, {
      key: "active",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n            " + _vm._s(item.value ? 'Ativo' : 'Inativo') + "\n        ")])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('span', {}, [_c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestTypeDetail',
              params: {
                id: item.item.objectId
              }
            },
            "title": "Editar Tipo de Requisição"
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-edit"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "title": "Criar uma cópia do Tipo de Requisição"
          },
          on: {
            "click": function($event) {
              return _vm.duplicate(item.item.objectId)
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-duplicate"
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "title": "Exportar o tipo de requisição para JSON"
          },
          on: {
            "click": function($event) {
              return _vm.exportReqType(item.item.objectId)
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-download"
        })])], 1)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": this.requestTypes.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1467:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.role.description),
      expression: "role.description"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.role.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.role, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Grupos Filhos")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "label": "description",
      "track-by": "objectId",
      "multiple": true,
      "show-labels": false,
      "allow-empty": false,
      "options": _vm.options,
      "placeholder": "Selecione um ou mais grupos"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', [_vm._v("Usuários Diponíveis")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAdditionalInfo.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.leftSelected),
      expression: "leftSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "10",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.leftSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('option', {
      domProps: {
        "value": user
      }
    }, [_vm._v(_vm._s(user.name) + " ("), (user.username) ? _c('span', [_vm._v(_vm._s(user.username))]) : _c('span', [_vm._v("<Sem Identificação>")]), _vm._v(")")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('ul', {
    staticClass: "picklist-control"
  }, [_c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Adicionar selecionados"
    },
    on: {
      "click": function($event) {
        return _vm.addSelected()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-forward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Adicionar todos"
    },
    on: {
      "click": function($event) {
        return _vm.addAll()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-fast-forward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Remover selecionados"
    },
    on: {
      "click": function($event) {
        return _vm.removeSelected()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-backward"
  })])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Remover todos"
    },
    on: {
      "click": function($event) {
        return _vm.removeAll()
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-fast-backward"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('label', [_vm._v("Usuários Vinculados")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterFinal),
      expression: "filterFinal"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Filtrar"
    },
    domProps: {
      "value": (_vm.filterFinal)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getRoleAndAdditionalInfo(_vm.id)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterFinal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rightSelected),
      expression: "rightSelected"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "10",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.rightSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.finalUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user
      }
    }, [_vm._v(_vm._s(user.name) + " ("), (user.username) ? _c('span', [_vm._v(_vm._s(user.username))]) : _c('span', [_vm._v("<Sem Identificação>")]), _vm._v(")")])
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Salvar\n      ")]), _vm._v(" "), (_vm.role.objectId) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("\n        Excluir\n      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/groups"
    }
  }, [_vm._v("Cancelar")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1468:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}

/***/ }),

/***/ 1469:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('loader') : _c('div', [_c('h1', [_vm._v("Ações Extras do Passo \"" + _vm._s(_vm.step.name) + "\"")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'StepActionDetail',
        params: {
          stepId: _vm.$route.params.stepId
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Ação\n    ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.actions.length) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n      O passo ainda não possui ações cadastradas.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.actions),
      callback: function($$v) {
        _vm.actions = $$v
      },
      expression: "actions"
    }
  }, _vm._l((_vm.actions), function(f, index) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('span', [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'form') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v("\n                    " + _vm._s(f.name) + "\n                    "), _c('span', {
      staticClass: "pull-right"
    }, [(f.type == 'form') ? _c('router-link', {
      staticClass: "btn btn-xs btn-success",
      attrs: {
        "to": {
          name: 'StepFieldList',
          params: {
            stepId: _vm.$route.params.stepId,
            actionId: f.objectId
          }
        },
        "type": "button",
        "title": "Adicionar/Editar Campos do Formulário"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }), _vm._v(" Campos do Formulário\n                      ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'StepActionDetail',
          params: {
            stepId: _vm.$route.params.stepId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar Ação"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n                      ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover Ação"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n                      ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Voltar")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1470:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formField),
      expression: "formField"
    }]
  }, [(_vm.formField.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'date') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.dateValue),
      callback: function($$v) {
        _vm.$set(_vm.formField, "dateValue", $$v)
      },
      expression: "formField.dateValue"
    }
  }) : (_vm.formField.type === 'file') ? _c('div', [_c('span', {
    staticClass: "btn btn-default btn-file",
    attrs: {
      "disabled": _vm.showSummary
    }
  }, [_vm._v("\n      Escolher...\n      "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".pdf, .doc, .dwg, .zip, .rar, application/pdf, image/*",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    on: {
      "change": function($event) {
        return _vm.callOnChange(_vm.formField, $event);
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formField.filename))])]) : (_vm.formField.type === 'document') ? _c('div', [_c('document-input-preview', {
    attrs: {
      "formField": _vm.formField,
      "showSummary": _vm.showSummary
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.formField.filename))])], 1) : (_vm.formField.type === 'select') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.showSummary
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formField, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formField.options), function(option) {
    return _c('option', {
      key: option.code,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(option.code) + " - " + _vm._s(option.name))])
  }), 0) : (_vm.formField.type === 'link') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "url",
      "placeholder": "http:// ou https://",
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formField.value),
      expression: "formField.value"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    domProps: {
      "value": (_vm.formField.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formField, "value", $event.target.value)
      }
    }
  }) : (_vm.formField.type === 'cpf') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'cnpj') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'phone') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'number') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name,
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'money') ? _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": _vm.currencyMask,
      "guide": false,
      "placeholder": 'Entre com o(a) ' + _vm.formField.name + ' em R$',
      "id": _vm.formField.objectId,
      "disabled": _vm.showSummary
    },
    model: {
      value: (_vm.formField.value),
      callback: function($$v) {
        _vm.$set(_vm.formField, "value", $$v)
      },
      expression: "formField.value"
    }
  }) : (_vm.formField.type === 'checkbox') ? _c('div', _vm._l((_vm.formField.options), function(option) {
    return _c('label', {
      key: option.code,
      staticClass: "checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formField.value),
        expression: "formField.value"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.showSummary
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.formField.value) ? _vm._i(_vm.formField.value, option) > -1 : (_vm.formField.value)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formField.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.formField, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.formField, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.formField, "value", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(option.name) + "\n    ")])
  }), 0) : (_vm.formField.type === 'computed') ? _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": _vm.formField.objectId,
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.formField.value
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1471:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [(_vm.ownerEditInvite) ? _c('div', [_vm._m(1)]) : _c('div', [_c('p', [_vm._v("Selecione um usuário abaixo. Um email será enviado para formalizar o convite.")]), _vm._v(" "), _c('div', {
    staticClass: "users-table"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getUsers]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getUsers.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1), _vm._v(" "), _c('b-table', {
    staticClass: "users-table",
    attrs: {
      "items": _vm.users,
      "fields": _vm.userFields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(item) {
        return _c('div', {
          staticClass: "text-center"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.invite.users),
            expression: "invite.users"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": item.item,
            "checked": Array.isArray(_vm.invite.users) ? _vm._i(_vm.invite.users, item.item) > -1 : (_vm.invite.users)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.invite.users,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = item.item,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.invite, "users", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.invite, "users", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.invite, "users", $$c)
              }
            }
          }
        })])
      }
    }, {
      key: "tags",
      fn: function(item) {
        return _c('ul', {
          staticClass: "list-inline"
        }, _vm._l((item.value), function(tag) {
          return _c('li', [_c('span', {
            staticClass: "label label-primary text-capitalize"
          }, [_vm._v(_vm._s(tag))])])
        }), 0)
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "size": "sm",
      "total-rows": _vm.usersCount,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getUsers
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "canComment"
    }
  }, [_vm._v("Pode comentar?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite.canComment),
      expression: "invite.canComment"
    }],
    attrs: {
      "type": "checkbox",
      "id": "canComment"
    },
    domProps: {
      "checked": Array.isArray(_vm.invite.canComment) ? _vm._i(_vm.invite.canComment, null) > -1 : (_vm.invite.canComment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invite.canComment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.invite, "canComment", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.invite, "canComment", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.invite, "canComment", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "expires"
    }
  }, [_vm._v("Expira?")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invite.expires),
      expression: "invite.expires"
    }],
    attrs: {
      "type": "checkbox",
      "id": "expires"
    },
    domProps: {
      "checked": Array.isArray(_vm.invite.expires) ? _vm._i(_vm.invite.expires, null) > -1 : (_vm.invite.expires)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.invite.expires,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.invite, "expires", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.invite, "expires", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.invite, "expires", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('masked-input', {
    staticClass: "form-control",
    attrs: {
      "mask": [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
      "guide": false,
      "disabled": !_vm.invite.expires
    },
    model: {
      value: (_vm.invite.expiration),
      callback: function($$v) {
        _vm.$set(_vm.invite, "expiration", $$v)
      },
      expression: "invite.expiration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', {
    attrs: {
      "for": "advanced"
    }
  }, [_vm._v("Informações Compartilhadas")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.fields,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": true,
      "placeholder": "Se não especificado, todos campos serão visíveis",
      "label": "name",
      "track-by": "objectId"
    },
    model: {
      value: (_vm.invite.sharedFields),
      callback: function($$v) {
        _vm.$set(_vm.invite, "sharedFields", $$v)
      },
      expression: "invite.sharedFields"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inviteEmailText"
    }
  }, [_vm._v("Texto do Email de Convites")]), _vm._v(" "), _c('quill-editor', {
    staticClass: "comment_editor",
    attrs: {
      "id": "inviteEmailText",
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.emailText),
      callback: function($$v) {
        _vm.emailText = $$v
      },
      expression: "emailText"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Você pode usar os parâmetros {NOME_CONVIDADO}, {NOME_WORKFLOW} e {DATA_EXPIRACAO} dentro do texto de E-mail.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go('-1')
      }
    }
  }, [_vm._v("Voltar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "slot": "footer",
      "id": "btn-confirm"
    },
    on: {
      "click": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Convidar")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Convidar")]), _vm._v(" "), _c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n          O requisitante será notificado. "), _c('b', [_vm._v("Ele poderá modificar as informações do formulário.")])])
}]}

/***/ }),

/***/ 1472:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('nav', {
    attrs: {
      "aria-label": "breadcrumb"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item",
    attrs: {
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(_vm.request.objectId))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item",
    attrs: {
      "aria-current": "page"
    }
  }, [_vm._v(_vm._s(_vm.step.name))])])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v("Convites ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-sm btn-primary",
    staticStyle: {
      "margin-top": "-10px"
    },
    attrs: {
      "to": {
        name: 'RequestInviteSelect'
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Convidado\n      ")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.invites || _vm.invites.length === 0) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n      Nenhum convite criado.\n    ")]) : _c('b-table', {
    attrs: {
      "items": _vm.invites,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "user",
      fn: function(item) {
        return _c('span', {}, [(item.value.get) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "expiration",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', {
          class: {
            danger: new Date(item.value) < new Date()
          }
        }, [_vm._v(_vm._s(_vm.formatExpirationDate(item.value)))]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "canComment",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v("Sim")]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "canEdit",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v("Sim")]) : _c('span', [_vm._v("Não")])])
      }
    }, {
      key: "createdAt",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n          " + _vm._s(_vm.formatDate(item.value)) + "\n      ")])
      }
    }, {
      key: "actions",
      fn: function(item) {
        return _c('span', {}, [_c('button', {
          staticClass: "btn btn-danger btn-xs",
          on: {
            "click": function($event) {
              return _vm.remove(item.item.objectId)
            }
          }
        }, [_vm._v("Remover")])])
      }
    }])
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go('-1')
      }
    }
  }, [_vm._v("Voltar")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "steps"
  }, [(_vm.editable) ? _c('div', {
    staticClass: "addStep0"
  }, [_c('button', {
    staticClass: "glyphicon glyphicon-plus add",
    attrs: {
      "id": "btn-add-step"
    },
    on: {
      "click": function($event) {
        return _vm.events.addStep(0)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.steps), function(step, index) {
    return _c('div', {
      staticClass: "step",
      class: {
        'active': step.active
      }
    }, [(_vm.icons) ? _c('span', {
      staticClass: "glyphicon icon",
      class: {
        'glyphicon-ok': step.completed,
        'glyphicon-cog': !step.completed && !step.active,
        'glyphicon-refresh': step.active
      }
    }) : _c('span', {
      staticStyle: {
        "font-size": "36px",
        "margin-right": "10px"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(_vm.editable) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.name),
        expression: "step.name"
      }],
      staticClass: "form-control field-name",
      attrs: {
        "type": "text",
        "placeholder": "Nome"
      },
      domProps: {
        "value": (step.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (step.description),
        expression: "step.description"
      }],
      staticClass: "form-control field-description",
      attrs: {
        "type": "text",
        "placeholder": "Descrição"
      },
      domProps: {
        "value": (step.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(step, "description", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('multiselect', {
      attrs: {
        "id": "target",
        "label": "description",
        "track-by": "objectId",
        "options": _vm.groups,
        "showLabels": false,
        "placeholder": "Selecione o grupo"
      },
      model: {
        value: (step.target),
        callback: function($$v) {
          _vm.$set(step, "target", $$v)
        },
        expression: "step.target"
      }
    }), _vm._v(" "), (step.objectId) ? _c('div', {
      staticClass: "message"
    }, [_vm._v("\n            Para selecionar o grupo dinamicamente, "), _c('router-link', {
      attrs: {
        "to": {
          name: 'StepGroupRuleList',
          params: {
            stepId: step.objectId
          }
        }
      }
    }, [_vm._v(" clique aqui")]), _vm._v(".\n          ")], 1) : _c('div', {
      staticClass: "message"
    }, [_vm._v("\n            Salve o passo antes para definir as regras de grupo.\n          ")])], 1) : _c('div', [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(step.name))]), _vm._v(" "), _c('div', {
      staticClass: "step-resume"
    }, [(step.description) ? _c('div', {
      staticClass: "step-description"
    }, [_vm._v(_vm._s(step.description))]) : _vm._e(), _vm._v(" "), (step.target) ? _c('div', [_c('label', [_vm._v("Grupo Alvo:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(step.target.description))]), (_vm.request && _vm.request.dynamicStepGroup && _vm.request.currentStep.objectId === step.objectId) ? _c('span', [_vm._v(", mas dinamicamente alocado para "), _c('b', [_vm._v(_vm._s(_vm.request.dynamicStepGroup.description))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.editable) ? _c('div', {
      staticClass: "step-options"
    }, [_c('button', {
      staticClass: "glyphicon glyphicon-remove remove btn-remove-step",
      attrs: {
        "title": "Excluir passo"
      },
      on: {
        "click": function($event) {
          return _vm.events.removeStep(index)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-plus add",
      attrs: {
        "title": "Adicionar passo"
      },
      on: {
        "click": function($event) {
          return _vm.events.addStep(index)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-transfer add-trammit-fields",
      attrs: {
        "title": "Adicionar campos de Tramitação"
      },
      on: {
        "click": function($event) {
          return _vm.events.addFieldsToTrammit(step)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "glyphicon glyphicon-expand add-evaluate-fields",
      attrs: {
        "title": "Adicionar Ações Extras"
      },
      on: {
        "click": function($event) {
          return _vm.events.addExtraActions(step)
        }
      }
    })]) : _vm._e()])
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1474:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', [_c('legend', [_vm._v("Campos")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "btn-add-field",
      "to": {
        name: 'FormFieldDetail',
        params: {
          reqType: _vm.reqType,
          section: _vm.sectionId,
          id: null
        }
      },
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Campo\n  ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.updating) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.fields.length == 0) ? _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "id": "msg-no-fields"
    }
  }, [_vm._v("\n            Formulário ainda não possui campos de preenchimento.\n    ")]) : _c('draggable', {
    staticClass: "list-group",
    on: {
      "end": _vm.checkMove
    },
    model: {
      value: (_vm.fields),
      callback: function($$v) {
        _vm.fields = $$v
      },
      expression: "fields"
    }
  }, _vm._l((_vm.fields), function(f) {
    return _c('div', {
      staticClass: "list-group-item"
    }, [_c('h4', {
      staticClass: "list-group-item-heading"
    }, [(f.type == 'text' || f.type == 'cpf' || f.type == 'cnpj') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-size"
    }) : _vm._e(), _vm._v(" "), (f.type == 'number') ? _c('span', {
      staticClass: "glyphicon glyphicon-plus"
    }) : _vm._e(), _vm._v(" "), (f.type == 'date') ? _c('span', {
      staticClass: "glyphicon glyphicon-calendar"
    }) : _vm._e(), _vm._v(" "), (f.type == 'document') ? _c('span', {
      staticClass: "glyphicon glyphicon-picture"
    }) : _vm._e(), _vm._v(" "), (f.type == 'file') ? _c('span', {
      staticClass: "glyphicon glyphicon-file"
    }) : _vm._e(), _vm._v(" "), (f.type == 'select') ? _c('span', {
      staticClass: "glyphicon glyphicon-list"
    }) : _vm._e(), _vm._v(" "), (f.type == 'link') ? _c('span', {
      staticClass: "glyphicon glyphicon-link"
    }) : _vm._e(), _vm._v(" "), (f.type == 'textarea') ? _c('span', {
      staticClass: "glyphicon glyphicon-font"
    }) : _vm._e(), _vm._v(" "), (f.type == 'separator') ? _c('span', {
      staticClass: "glyphicon glyphicon-text-color"
    }) : _vm._e(), _vm._v(" "), (f.type == 'checkbox') ? _c('span', {
      staticClass: "glyphicon glyphicon-check"
    }) : _vm._e(), _vm._v(" "), (f.type == 'phone') ? _c('span', {
      staticClass: "glyphicon glyphicon-phone"
    }) : _vm._e(), _vm._v("\n            " + _vm._s(f.name) + "\n            "), (f.required) ? _c('span', {
      staticClass: "required"
    }, [_vm._v("(Obrigatório)")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-right"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.counts[f.objectId] > 0),
        expression: "counts[f.objectId] > 0"
      }],
      staticClass: "badge"
    }, [_vm._v(_vm._s(_vm.counts[f.objectId]) + " redirecionamento(s)")]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-xs btn-primary",
      attrs: {
        "to": {
          name: 'FormFieldDetail',
          params: {
            reqType: _vm.reqType,
            section: _vm.sectionId,
            id: f.objectId
          }
        },
        "type": "button",
        "title": "Editar campo"
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-edit"
    }), _vm._v(" Editar\n              ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs btn-danger",
      attrs: {
        "title": "Remover campo"
      },
      on: {
        "click": function($event) {
          return _vm.remove(f)
        }
      }
    }, [_c('span', {
      staticClass: "glyphicon glyphicon-remove"
    }), _vm._v(" Remover\n              ")])], 1)]), _vm._v(" "), _c('p', {
      staticClass: "list-group-item-text"
    }, [_vm._v(_vm._s(f.description))])])
  }), 0)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1475:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Requisições")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getList]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.requests,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "name",
      fn: function(item) {
        return _c('span', {}, [(item.item.workflow) ? _c('span', [_vm._v(_vm._s(item.item.workflow.get('name')))]) : _vm._e()])
      }
    }, {
      key: "currentStep",
      fn: function(item) {
        return [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()]
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getList
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1482:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1483:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1484:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1485:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1486:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1487:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(612),
  /* template */
  __webpack_require__(1442),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(611),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(896)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(609),
  /* template */
  __webpack_require__(1470),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(899)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(616),
  /* template */
  __webpack_require__(1473),
  /* scopeId */
  "data-v-e7f5d922",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  NODE_ENV: '"production"',
  APP_ID: JSON.stringify("eadflow"),
  SERVER_URL: JSON.stringify("https://eadflow.ifpe.edu.br/parse"),
  PUBLIC_URL: JSON.stringify("https://eadflow.ifpe.edu.br")
}


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RequestTypeList__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_RequestTypeList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_RequestTypeList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RequestTypeDetail__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_RequestTypeDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_RequestTypeDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_GroupList__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_GroupList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_GroupList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_GroupDetail__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_GroupDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_GroupDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_FormFieldDetail__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_FormFieldDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_FormFieldDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FormSectionDetail__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_FormSectionDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_FormSectionDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_WorkflowList__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_WorkflowList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_WorkflowList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_WorkflowDetail__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_WorkflowDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_WorkflowDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_WorkflowRequests__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_WorkflowRequests___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_WorkflowRequests__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Login__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Signup__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_PasswordReset__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_PasswordReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_PasswordReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_RequestConfirmation__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_RequestConfirmation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_RequestConfirmation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_RequestDetail__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_RequestDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_RequestDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_RequestInvite__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_RequestInvite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_RequestInvite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_RequestInviteSelect__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_RequestInviteSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_RequestInviteSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_RequestList__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_RequestList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_RequestList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_RequestForm__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_RequestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_RequestForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_UserProfile__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_UserProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_UserProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_RequestOpen__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_components_RequestOpen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_components_RequestOpen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Management__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_components_Management___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_components_Management__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_util_Message__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_components_util_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_components_util_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_StepFieldList__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_components_StepFieldList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_components_StepFieldList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_StepFieldDetail__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_components_StepFieldDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_components_StepFieldDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_UserList__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_components_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_components_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_UserImport__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_components_UserImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_components_UserImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_StepActionList__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_components_StepActionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_components_StepActionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_StepActionDetail__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_components_StepActionDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_components_StepActionDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_StepGroupRuleList__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_components_StepGroupRuleList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_components_StepGroupRuleList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Global__ = __webpack_require__(10);


































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/requestTypes',
    name: 'RequestTypeList',
    component: __WEBPACK_IMPORTED_MODULE_2_components_RequestTypeList___default.a
  }, {
    path: '/requestType/:id',
    name: 'RequestTypeDetail',
    component: __WEBPACK_IMPORTED_MODULE_3_components_RequestTypeDetail___default.a
  }, {
    path: '/groups',
    name: 'GroupList',
    component: __WEBPACK_IMPORTED_MODULE_4_components_GroupList___default.a
  }, {
    path: '/group/:id',
    name: 'GroupDetail',
    component: __WEBPACK_IMPORTED_MODULE_5_components_GroupDetail___default.a
  }, {
    path: '/formField/:reqType/:section/:id?',
    name: 'FormFieldDetail',
    component: __WEBPACK_IMPORTED_MODULE_6_components_FormFieldDetail___default.a
  }, {
    path: '/formSection/:reqType/:id?',
    name: 'FormSectionDetail',
    component: __WEBPACK_IMPORTED_MODULE_7_components_FormSectionDetail___default.a
  }, {
    path: '/workflows',
    name: 'WorkflowList',
    component: __WEBPACK_IMPORTED_MODULE_8_components_WorkflowList___default.a
  }, {
    path: '/workflow/:id?',
    name: 'WorkflowDetail',
    component: __WEBPACK_IMPORTED_MODULE_9_components_WorkflowDetail___default.a
  }, {
    path: '/workflow/:id/requests',
    name: 'WorkflowRequests',
    component: __WEBPACK_IMPORTED_MODULE_10_components_WorkflowRequests___default.a
  }, {
    path: '/login/:access_token?',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_11_components_Login___default.a,
    meta: { allowAnonymous: true }
  }, {
    path: '/signup/',
    name: 'Signup',
    component: __WEBPACK_IMPORTED_MODULE_12_components_Signup___default.a,
    meta: { allowAnonymous: true }
  }, {
    path: '/password-reset/',
    name: 'PasswordReset',
    component: __WEBPACK_IMPORTED_MODULE_13_components_PasswordReset___default.a,
    meta: { allowAnonymous: true }
  }, {
    path: '/request/:id',
    name: 'RequestDetail',
    component: __WEBPACK_IMPORTED_MODULE_15_components_RequestDetail___default.a
  }, {
    path: '/invite/:requestId/:stepId',
    name: 'RequestInvite',
    component: __WEBPACK_IMPORTED_MODULE_16_components_RequestInvite___default.a
  }, {
    path: '/invite/:requestId/:stepId/select',
    name: 'RequestInviteSelect',
    component: __WEBPACK_IMPORTED_MODULE_17_components_RequestInviteSelect___default.a
  }, {
    path: '/requests',
    name: 'RequestList',
    component: __WEBPACK_IMPORTED_MODULE_18_components_RequestList___default.a
  }, {
    path: '/requestConfirmation/:requestId',
    name: 'RequestConfirmation',
    component: __WEBPACK_IMPORTED_MODULE_14_components_RequestConfirmation___default.a
  }, {
    path: '/requestForm/:workflowId',
    name: 'RequestForm',
    component: __WEBPACK_IMPORTED_MODULE_19_components_RequestForm___default.a
  }, {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_21_components_RequestOpen___default.a
  }, {
    path: '/openRequest/:tag?',
    name: 'RequestOpen',
    component: __WEBPACK_IMPORTED_MODULE_21_components_RequestOpen___default.a
  }, {
    path: '/management',
    name: 'Management',
    component: __WEBPACK_IMPORTED_MODULE_22_components_Management___default.a
  }, {
    path: '/userProfile',
    name: 'UserProfile',
    component: __WEBPACK_IMPORTED_MODULE_20_components_UserProfile___default.a
  }, {
    path: '/message/:message',
    name: 'Message',
    component: __WEBPACK_IMPORTED_MODULE_23_components_util_Message___default.a,
    meta: { allowAnonymous: true }
  }, {
    path: '/stepFieldList/:stepId/:actionId?',
    name: 'StepFieldList',
    component: __WEBPACK_IMPORTED_MODULE_24_components_StepFieldList___default.a
  }, {
    path: '/stepFieldDetail/:stepId/:id?/:actionId?',
    name: 'StepFieldDetail',
    component: __WEBPACK_IMPORTED_MODULE_25_components_StepFieldDetail___default.a
  }, {
    path: '/users',
    name: 'UserList',
    component: __WEBPACK_IMPORTED_MODULE_26_components_UserList___default.a
  }, {
    path: '/users/import',
    name: 'UserImport',
    component: __WEBPACK_IMPORTED_MODULE_27_components_UserImport___default.a
  }, {
    path: '/stepActionList/:stepId',
    name: 'StepActionList',
    component: __WEBPACK_IMPORTED_MODULE_28_components_StepActionList___default.a
  }, {
    path: '/stepActionDetail/:stepId/:id?',
    name: 'StepActionDetail',
    component: __WEBPACK_IMPORTED_MODULE_29_components_StepActionDetail___default.a
  }, {
    path: '/stepGroupRuleList/:stepId',
    name: 'StepGroupRuleList',
    component: __WEBPACK_IMPORTED_MODULE_30_components_StepGroupRuleList___default.a
  }]
});

var getQueryString = function getQueryString(field, to) {
  var href = to.path;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
};

router.beforeEach(function (to, from, next) {
  var accessToken = getQueryString('access_token', to);
  if (accessToken) {
    next('/login/' + accessToken);
  } else {
    var user = __WEBPACK_IMPORTED_MODULE_31__Global__["a" /* Parse */].User.current();
    if (!to.meta.allowAnonymous && !user) {
      next('/login?next=' + (to.query.next || ''));
    } else if (to.query.next && user) {
      next(to.query.next);
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(886)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1460),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_js_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiselect_dist_vue_multiselect_min_css__);












__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_js_modal___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(652);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(657);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(685);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(704);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(707);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(49);

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = __webpack_require__(80);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  email: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  url: new RegExp(/^(https?|ftp|rmtp|mms):\/\/(([A-Z0-9][A-Z0-9_-]*)(\.[A-Z0-9][A-Z0-9_-]*)+)(:(\d+))?\/?/i),
  text: new RegExp(/^[a-zA-Z]+$/),
  digits: new RegExp(/^[\d() \.\:\-\+#]+$/),
  isodate: new RegExp(/^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/)
};
exports.default = {
  name: 'InputTag',

  props: {
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validate: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      newTag: ''
    };
  },

  methods: {
    focusNewTag: function focusNewTag() {
      if (this.readOnly) {
        return;
      }
      this.$el.querySelector('.new-tag').focus();
    },
    addNew: function addNew(tag) {
      if (tag && !this.tags.includes(tag) && this.validateIfNeeded(tag)) {
        this.tags.push(tag);
        this.tagChange();
      }
      this.newTag = '';
    },
    validateIfNeeded: function validateIfNeeded(tagValue) {
      if (this.validate === '' || this.validate === undefined) {
        return true;
      } else if ((0, _keys2.default)(validators).indexOf(this.validate) > -1) {
        return validators[this.validate].test(tagValue);
      }
      return true;
    },
    remove: function remove(index) {
      this.tags.splice(index, 1);
      this.tagChange();
    },
    removeLastTag: function removeLastTag() {
      if (this.newTag) {
        return;
      }
      this.tags.pop();
      this.tagChange();
    },
    tagChange: function tagChange() {
      if (this.onChange) {
        this.onChange(JSON.parse((0, _stringify2.default)(this.tags)));
      }
    }
  }
};

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);



__webpack_require__(855);
__webpack_require__(853);
__webpack_require__(854);
if (!window.Quill) {
  window.Quill = __webpack_require__(533);
}
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },

  props: {
    content: String,
    value: String,
    config: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quillEditor = null;
  },

  methods: {
    initialize: function initialize() {
      if (this.$el) {
        var self = this;
        self.quillEditor = new Quill(self.$el, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
          modules: self.defaultModules,
          placeholder: 'Insert text here ...',
          readOnly: false,
          theme: 'snow',
          boundary: document.body
        }, self.config || {}));

        if (self.value || self.content) {
          self.quillEditor.pasteHTML(self.value || self.content);
        }

        self.quillEditor.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quillEditor);
          } else {
            self.$emit('focus', self.quillEditor);
          }
        });

        self.quillEditor.on('text-change', function (delta, oldDelta, source) {
          var html = self.$el.children[0].innerHTML;
          var text = self.quillEditor.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quillEditor,
            html: html,
            text: text
          });
        });

        self.$emit('ready', self.quillEditor);
      }
    }
  },
  watch: {
    'content': function content(newVal, oldVal) {
      if (this.quillEditor) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quillEditor.pasteHTML(newVal);
        } else if (!newVal) {
          this.quillEditor.setText('');
        }
      }
    },
    'value': function value(newVal, oldVal) {
      if (this.quillEditor) {
        if (newVal !== this._content) {
          this._content = newVal;
          this.quillEditor.pasteHTML(newVal);
        } else if (!newVal) {
          this.quillEditor.setText('');
        }
      }
    }
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent'
      };
    }
  }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default.a
  }
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['formField', 'showSummary'],
  data: function data() {
    this.updatedByComponent = true;

    return {
      images: [],
      imageData: []
    };
  },
  updated: function updated() {
    if (!this.updatedByComponent) {
      this.imageData = [];
      this.updatedByComponent = true;
    } else {
      this.updatedByComponent = false;
    }
  },

  methods: {
    imagesAdd: function imagesAdd(event) {
      this.images = event.target.files || event.dataTransfer.files;
      this.imageData = [];
      this.updatedByComponent = true;
      this.createImages(event);
    },
    createImages: function createImages(event) {
      var _this = this;

      for (var i = 0; i < this.images.length; i++) {
        var reader = new FileReader();
        var vm = this;
        reader.onload = function (e) {
          vm.imageData.push(e.target.result);
          _this.updatedByComponent = true;
        };
        reader.readAsDataURL(this.images[i]);
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Global__["f" /* createDocumentFile */])(this.formField, event);
    },
    removeImage: function removeImage(key) {
      this.imageData.splice(key, 1);
    }
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      loading: false,
      show: false,
      showFormula: false,
      hideRequired: false,
      newField: { options: [], formula: '' },
      optionsCSV: '',
      fieldTypes: ['text', 'number', 'date', 'file', 'document', 'select', 'link', 'textarea', 'separator', 'checkbox', 'cpf', 'cnpj', 'phone', 'computed', 'money'],
      fieldRules: ['equals'],
      rules: [],
      sections: []
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    if (id) {
      this.getById(id);
    } else {
      this.getFormSections();
    }
  },

  watch: {
    optionsCSV: function optionsCSV(newValue) {
      var list = [];
      var lines = newValue.split('\n');
      lines.forEach(function (line) {
        if (line) {
          var columns = line.split(';');
          list.push({ code: columns[0], name: columns[1] });
        }
      });
      this.newField.options = list;
    }
  },
  methods: {
    change: function change() {
      this.show = this.newField.type === 'select' || this.newField.type === 'checkbox';
      this.showFormula = this.newField.type === 'computed';
      this.hideRequired = this.newField.type === 'separator';
      if (this.hideRequired) {
        this.newField.required = false;
      }
    },
    addNewField: function addNewField() {
      __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$emit('new_form_field');
    },
    getById: function getById(id) {
      var self = this;
      self.loading = true;
      var params = {
        formId: id
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('getFormField', params).then(function (data) {
        var formField = data.formField;
        self.rules = data.rules.map(function (r) {
          return r.toJSON();
        });
        var props = ['name', 'description', 'type', 'required', 'options', 'formula'];
        props.forEach(function (attr) {
          self.newField[attr] = formField.get(attr);
        });
        self.show = self.newField.type === 'select';
        self.hideRequired = self.newField.type === 'separator';
        if (self.hideRequired) {
          self.newField.required = false;
        }
        var options = formField.get('options');
        var builder = [];
        options.forEach(function (opt, i) {
          if (i > 0) builder.push('\n');
          builder.push(opt.code);
          builder.push(';');
          builder.push(opt.name);
        });
        self.optionsCSV = builder.join('');
        return self.getFormSections();
      }).fail(function (error) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(error.message);
      });
    },
    getFormSections: function getFormSections() {
      var self = this;
      var params = {
        requestId: self.$route.params.reqType
      };
      self.loading = true;
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listFormSections', params).then(function (results) {
        self.sections = results.data.map(function (r) {
          return r.toJSON();
        });
        self.loading = false;
        self.change();
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    save: function save() {
      if (this.newField.type === undefined) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].warn('Informe o tipo do campo.');
        return;
      }
      var self = this;
      self.loading = true;
      var params = {
        requestId: self.$route.params.reqType,
        sectionId: self.$route.params.section,
        fieldId: self.$route.params.id,
        fieldData: self.newField,
        rulesData: self.rules
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('saveFormField', params).then(function (results) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        self.loading = false;
        self.$router.go(-1);
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);
var _this = this;





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  props: ['reqType', 'sectionId'],
  data: function data() {
    return {
      sections: [],
      positions: [],
      fields: [],
      fieldsParse: [],
      updating: false
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$on('new_form_field', function () {
      self.refresh();
    });
    this.refresh();
  },

  methods: {
    refresh: function refresh() {
      if (this.reqType) {
        var self = this;
        self.loading = true;
        var params = { requestId: self.reqType, sectionId: self.sectionId };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listFormFields', params).then(function (data) {
          self.fieldsParse = data.formFields;
          self.fields = data.formFields.map(function (r) {
            return r.toJSON();
          });
          self.counts = data.counts;
          self.loading = false;
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    remove: function remove(field) {
      if (confirm('Deseja realmente remover o item?')) {
        var self = this;
        self.loading = true;
        var params = { formId: field.objectId };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('removeFormField', params).then(function (results) {
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Excluído com sucesso.');
          self.refresh();
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    checkMove: function checkMove(evt) {
      if (evt.newIndex !== evt.oldIndex) {
        var self = this;
        self.updating = true;
        var params = {
          requestId: self.reqType,
          formFields: self.fields
        };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('reorderFormFields', params).then(function (list) {
          self.fieldsParse = list;
          self.updating = false;
        }).fail(function (error) {
          self.updating = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    }
  },
  watch: {
    'reqType': function reqType(val, oldValue) {
      _this.refresh();
    }
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldList__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFieldList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FormFieldList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    FormFieldList: __WEBPACK_IMPORTED_MODULE_2__FormFieldList___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_3_vue_multiselect___default.a
  },
  data: function data() {
    return {
      loading: false,
      show: false,
      newSection: { action: '', goto: {}, repeat: { active: false } },
      requestTypeId: '',
      sectionId: '',
      sectionActions: ['next', 'goto', 'end'],
      sections: []
    };
  },
  mounted: function mounted() {
    this.sectionId = this.$route.params.id;
    this.requestTypeId = this.$route.params.reqType;
    if (this.sectionId) {
      this.getById(this.sectionId, this.requestTypeId);
    } else {
      this.getFormSections(this.requestTypeId);
    }
  },

  methods: {
    getById: function getById(id, requestTypeId) {
      var _this = this;

      var self = this;
      self.loading = true;
      var params = {
        formId: id,
        requestId: requestTypeId
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('getFormSection', params).then(function (formSection) {
        self.newSection = formSection.toJSON();

        if (!_this.newSection.action) {
          _this.newSection.action = _this.sectionActions[0];
        }
        self.loading = false;
        return self.getFormSections(requestTypeId);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    getFormSections: function getFormSections(requestTypeId) {
      var self = this;
      self.loading = true;
      var params = {
        requestId: requestTypeId
      };
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listFormSections', params).then(function (results) {
        self.sections = results.data.map(function (r) {
          return r.toJSON();
        });
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    save: function save() {
      var self = this;
      self.loading = true;
      var params = {
        requestId: self.$route.params.reqType,
        sectionId: self.$route.params.id,
        sectionData: self.newSection
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('saveFormSection', params).then(function (results) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        self.loading = false;
        self.$router.go(-1);
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);
var _this = this;






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  props: ['reqType'],
  data: function data() {
    return {
      positions: [],
      sections: [],
      sectionsParse: [],
      counts: [],
      updating: false
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$on('new_form_section', function () {
      self.refresh();
    });
    this.refresh();
  },

  methods: {
    refresh: function refresh() {
      if (this.reqType) {
        var self = this;
        self.loading = true;
        var params = { requestId: self.reqType, sectionId: self.sectionId };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listFormSections', params).then(function (results) {
          self.sectionsParse = results.data;
          self.sections = results.data.map(function (r) {
            return r.toJSON();
          });
          self.counts = results.counts;
          self.loading = false;
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    checkMove: function checkMove(evt) {
      if (evt.newIndex !== evt.oldIndex) {
        var self = this;
        self.updating = true;
        var updateList = [];
        self.sections.forEach(function (section, i) {
          var sectionParse = self.sectionsParse.find(function (item) {
            return item.id === section.objectId;
          });
          sectionParse.set('order', i);
          updateList.push(sectionParse);
        });
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.saveAll(updateList).then(function (results) {
          self.sectionsParse = results;
          self.updating = false;
        }).fail(function (error) {
          self.updating = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    remove: function remove(section) {
      if (confirm('Deseja realmente remover o item?')) {
        var self = this;
        self.loading = true;
        var params = { sectionId: section.objectId };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('removeFormSection', params).then(function (results) {
          self.loading = false;
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Removido com sucesso.');
          self.refresh();
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    }
  },
  watch: {
    'reqType': function reqType(val, oldValue) {
      _this.refresh();
    }
  }
});

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      role: {},
      roleParse: null,
      loading: false,
      value: null,
      options: [],
      leftSelected: [],
      rightSelected: [],
      users: [],
      finalUsers: []
    };
  },
  mounted: function mounted() {
    this.loading = true;
    var id = this.$route.params.id;
    if (id) {
      this.getRoleAndAdditionalInfo(id);
    } else {
      this.getAdditionalInfo();
    }
  },

  methods: {
    getRoleAndAdditionalInfo: function getRoleAndAdditionalInfo(id) {
      var self = this;
      self.loading = true;
      if (!id) {
        id = this.$route.params.id;
      }
      var params = {
        id: id,
        filter: self.filter,
        filterFinal: self.filterFinal
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('getRoleAndAdditionalInfoGroup', params).then(function (response) {
        self.users = response.users;
        self.finalUsers = response.finalUsers;
        self.options = response.options;
        self.roleParse = response.roleParse;
        self.role = response.role;
        self.value = response.value;
        self.loading = false;
      }, function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    getAdditionalInfo: function getAdditionalInfo() {
      var self = this;
      self.loading = true;
      var params = {
        filter: self.filter
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('getAdditionalInfoGroup', params).then(function (response) {
        self.users = response.users;
        self.options = response.options;
        self.loading = false;
      }, function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    save: function save() {
      var self = this;
      if (!self.role.description) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].warn('Informe o nome do Grupo.');
        return;
      }
      var roleParseId = void 0;
      if (self.roleParse) {
        roleParseId = self.roleParse.id;
      }
      var params = {
        objectId: roleParseId,
        roleDescription: self.role.description,
        value: self.value,
        finalUsers: self.finalUsers,
        newObjectId: self.newObjectId()
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('saveListUsers', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        self.$router.go(-1);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    remove: function remove() {
      var self = this;
      var params = {
        objectId: self.role.objectId
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('removeGroup', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Grupo excluído com sucesso');
        self.$router.go(-1);
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    addSelected: function addSelected() {
      var _this = this;

      this.leftSelected.forEach(function (user) {
        _this.finalUsers.push(user);
        var index = _this.users.indexOf(user);
        if (index >= 0) {
          _this.users.splice(index, 1);
        }
      });
      this.leftSelected = [];
      this.finalUsers.sort(this.sortComparator);
    },
    removeSelected: function removeSelected() {
      var _this2 = this;

      this.rightSelected.forEach(function (user) {
        _this2.users.push(user);
        var index = _this2.finalUsers.indexOf(user);
        if (index >= 0) {
          _this2.finalUsers.splice(index, 1);
        }
      });
      this.rightSelected = [];
      this.users.sort(this.sortComparator);
    },
    addAll: function addAll() {
      var _this3 = this;

      this.users.forEach(function (user) {
        _this3.finalUsers.push(user);
      });
      this.users = [];
      this.finalUsers.sort(this.sortComparator);
    },
    removeAll: function removeAll() {
      var _this4 = this;

      this.finalUsers.forEach(function (user) {
        _this4.users.push(user);
      });
      this.finalUsers = [];
      this.users.sort(this.sortComparator);
    },
    sortComparator: function sortComparator(a, b) {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    },
    newObjectId: function newObjectId() {
      var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789';
      var objectId = '';
      var bytes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_crypto__["randomBytes"])(10);
      for (var i = 0; i < bytes.length; ++i) {
        objectId += chars[bytes.readUInt8(i) % chars.length];
      }
      return objectId;
    }
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      roleList: [],
      loading: false,
      fields: {
        description: { label: 'Nome', sortable: true },
        rolesList: { label: 'Grupos Filhos', sortable: true },
        createdAtFmt: { label: 'Data de Criação', sortable: true },
        updatedAtFmt: { label: 'Última Atualização', sortable: true },
        options: { label: 'Opções' }
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    };
  },
  mounted: function mounted() {
    this.getRoles();
  },

  methods: {
    getRoles: function getRoles() {
      var self = this;
      self.loading = true;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role);
      query.include('roles');
      query.ascending('description');
      query.limit(10000);
      query.find({
        success: function success(results) {
          self.roleList = results.map(function (r) {
            var json = r.toJSON();
            if (json.createdAt) {
              var dtFormat = new Date(json.createdAt);
              json.createdAtFmt = dtFormat.toLocaleString('pt-BR');
            }
            if (json.updatedAt) {
              var _dtFormat = new Date(json.updatedAt);
              json.updatedAtFmt = _dtFormat.toLocaleString('pt-BR');
            }
            json.rolesList = [];
            r.relation('roles').query().each(function (role) {
              json.rolesList.push(role.get('description'));
            });
            return json;
          });
          self.loading = false;
        },
        error: function error(_error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, _error);
          self.loading = false;
        }
      });
    }
  }
});

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      login: null,
      password: null,
      loading: false,
      errorMessage: null,
      showCustomLogin: false
    };
  },
  mounted: function mounted() {
    this.errorMessage = 'Atenção: Este tipo de login não listará os editais voltados exclusivamente para os servidores do IFPE.';
    var accessToken = this.$route.params.access_token;
    if (accessToken) {
      this.loginTokenIfpe(accessToken);
    }
  },

  methods: {
    doLogin: function doLogin() {
      var self = this;
      if (!self.login || !self.password) {
        return;
      }
      self.loading = true;
      self.errorMessage = null;
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.logIn(self.login.toLowerCase(), self.password).then(function (user) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$emit('loginSuccess', self);
      }).fail(function (error) {
        self.loading = false;
        self.errorMessage = error.message;
      });
    },
    askAuthIFPE: function askAuthIFPE() {
      window.location.href = __WEBPACK_IMPORTED_MODULE_0__Global__["h" /* ifpeAuth */].token.getUri() + '&nonce=' + Math.random().toString(36).substring(7);
    },
    loginTokenIfpe: function loginTokenIfpe(accessToken) {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('loginOauthIfpe', { accessToken: accessToken }).then(function (token) {
        return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.become(token);
      }).then(function () {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$emit('loginSuccess', self);
      }).fail(function (error) {
        console.log(error);
        self.errorMessage = 'Erro ao autenticar';
      });
    }
  }
});

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      loading: false,
      isAdminRequests: false,
      isAdminRequestTypes: false,
      isAdminWorkflows: false,
      isAdminGroups: false,
      isAdminUsers: false
    };
  },
  mounted: function mounted() {
    this.checkPermissions();
  },

  methods: {
    checkPermissions: function checkPermissions() {
      var self = this;
      self.loading = true;
      var user = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.current();
      var queryRole = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role);
      queryRole.equalTo('users', user);
      queryRole.find().then(function (roles) {
        self.isAdminRequests = self.hasHole(roles, 'ADMIN_REQUESTS');
        self.isAdminRequestTypes = self.hasHole(roles, 'ADMIN_REQTYPE');
        self.isAdminWorkflows = self.hasHole(roles, 'ADMIN_WORKFLOW');
        self.isAdminGroups = self.hasHole(roles, 'ADMIN_GROUPS');
        self.isAdminUsers = self.hasHole(roles, 'ADMIN_USERS');
        self.loading = false;
      }, function (error) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(error.message);
        self.loading = false;
      });
    },
    hasHole: function hasHole(roles, roleName) {
      var role = roles.find(function (r) {
        return r.get('name') === roleName;
      });
      if (role) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_ErrorHandling__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_prod_env__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_prod_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_prod_env__);






var publicURL = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__config_prod_env__["PUBLIC_URL"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      adminUser: false,
      loggedUser: __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.current(),
      numberOfLinkedRequests: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0__Global__["b" /* GlobalChannel */].$on('loginSuccess', function () {
      self.loggedUser = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.current();
      self.loadNavbarAttributes();
    });
    self.loadNavbarAttributes();
  },

  methods: {
    logout: function logout() {
      var self = this;
      if (self.loggedUser.getEmail() !== self.loggedUser.getUsername()) {
        var id_hint = self.loggedUser.get('id_token_hint');
        location.href = 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/logout?post_logout_redirect_uri=' + publicURL + '&id_token_hint=' + id_hint;
      }
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.logOut();
      this.loggedUser = null;
      this.adminUser = false;
      this.numberOfLinkedRequests = 0;
    },
    loadNavbarAttributes: function loadNavbarAttributes() {
      if (__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.current()) {
        var self = this;
        var params = {
          currentPage: 1,
          perPage: 1,
          filter: ''
        };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listInvitedRequests', params).then(function (results) {
          self.numberOfLinkedRequests = results.total;
          var queryRole = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role);
          queryRole.equalTo('users', self.loggedUser);
          queryRole.containedIn('name', ['ADMIN_REQUESTS', 'ADMIN_REQTYPE', 'ADMIN_WORKFLOW', 'ADMIN_GROUPS', 'ADMIN_USERS']);
          return queryRole.count();
        }).then(function (count) {
          self.adminUser = count > 0;
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    }
  }
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      user: {
        email: '',
        username: '',
        new_password: ''
      },
      errorMessage: '',
      successMessage: '',
      choosePassword: false,
      passwordChangeURL: __WEBPACK_IMPORTED_MODULE_0__Global__["g" /* properties */].passwordChangeURL,
      token: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.loading = false;
    this.choosePassword = false;
    this.token = this.$route.query.token;
    if (this.token) {
      this.choosePassword = true;
      this.user.username = this.$route.query.username;
    }
  },

  methods: {
    askReset: function askReset() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.requestPasswordReset(self.user.email).then(function () {
        self.successMessage = 'Link para recuperação de senha foi enviado ao seu email.';
        self.user.email = '';
      }, function () {
        self.errorMessage = 'Ocorreu um erro na requisição. Por favor, conferir seu email.';
      }).then(function () {
        self.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);






__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].User.current(),
      requestId: undefined,
      isConfirmed: undefined,
      mailContact: 'cadt@reitoria.ifpe.edu.br',
      requestEndMessage: ''
    };
  },
  mounted: function mounted() {
    this.requestId = this.$route.params.requestId;
    this.getConfirmation(this.$route.params.requestId);
  },

  methods: {
    getConfirmation: function getConfirmation(requestId) {
      var self = this;
      self.loading = true;
      var params = {
        requestId: requestId
      };
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('isRequestConfirmed', params).then(function (res) {
        self.loading = false;
        self.isConfirmed = true;
        if (res.mailContact) {
          self.requestEndMessage = res.requestEndMessage;
          self.mailContact = res.mailContact;
        }
      }).fail(function (error) {
        self.loading = false;
        self.isConfirmed = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    logout: function logout() {
      var self = this;
      if (self.user.getEmail() !== self.user.getUsername()) {
        location.href = 'https://acesso.ifpe.edu.br/realms/master/protocol/openid-connect/logout?post_logout_redirect_uri=https://workflow.ifpe.edu.br';
      }
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].User.logOut();
      this.loggedUser = null;
      this.adminUser = false;
      this.numberOfLinkedRequests = 0;
    }
  }
});

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Steps__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_Steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Modal__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_RequestStatus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__util_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DynamicViewField__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DynamicViewField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__util_DynamicViewField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DynamicFormField__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_DynamicFormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__util_DynamicFormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RequestUserLinked__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RequestUserLinked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__RequestUserLinked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RequestMetadata__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__RequestMetadata___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__RequestMetadata__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_CommentTimelineOverview__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_CommentTimelineOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__util_CommentTimelineOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__);


















__WEBPACK_IMPORTED_MODULE_8_moment___default.a.locale('pt-br');
var Step = __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Object.extend('Step');
var StepAction = __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Object.extend('StepAction');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a,
    Steps: __WEBPACK_IMPORTED_MODULE_3__util_Steps___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_4_vue_quill_editor__["quillEditor"],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_7__util_Modal___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_9__util_RequestStatus___default.a,
    RequestMetadata: __WEBPACK_IMPORTED_MODULE_13__RequestMetadata___default.a,
    RequestUserLinked: __WEBPACK_IMPORTED_MODULE_12__RequestUserLinked___default.a,
    DynamicViewField: __WEBPACK_IMPORTED_MODULE_10__util_DynamicViewField___default.a,
    DynamicFormField: __WEBPACK_IMPORTED_MODULE_11__util_DynamicFormField___default.a,
    CommentTimelineOverview: __WEBPACK_IMPORTED_MODULE_14__util_CommentTimelineOverview___default.a
  },
  data: function data() {
    return {
      content: '',
      contentModal: '',
      user: __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].User.current(),
      cloudResponse: null,
      privateComment: true,
      loading: false,
      advanced: false,
      isLastStep: false,
      isFirstStep: false,
      canTrammit: false,
      canReopen: false,
      canRevert: false,
      showEditField: false,
      isInvited: false,
      showActionModal: false,
      loadingAction: false,
      seeMore: false,
      showRequestData: false,
      showEditModal: false,
      customizations: {},
      editorConfig: {
        placeholder: 'Digite um comentário aqui...',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'color': [] }, { 'background': [] }], ['link', 'image']]
        }
      },
      commentEvent: 'note',
      showModal: false,
      steps: [],
      stepCurrentIndex: 0,
      stepFields: [],
      actionFields: [],
      actionFormValues: [],
      currentAction: null,
      currentStepActions: [],
      groups: [{ objectId: '1', name: 'Grupo Test' }],
      newEditField: {},
      request: {
        owner: {
          name: 'Carregando... ',
          group: {
            name: ''
          }
        },
        reqType: {
          name: ''
        }
      },
      otherRequests: [],
      comments: [],
      fields: [],
      additionalFields: [],
      formSections: []
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getById(id);
  },

  computed: {
    privateStepFields: function privateStepFields() {
      return this.stepFields.filter(function (f) {
        return f.private;
      });
    },
    publicStepFields: function publicStepFields() {
      return this.stepFields.filter(function (f) {
        return !f.private;
      });
    },
    fieldsGroups: function fieldsGroups() {
      var groups = {};
      this.fields.filter(function (i) {
        return i.section;
      }).forEach(function (item) {
        var key = item.sectionOrder + '-' + item.section.objectId;
        var list = groups[key];
        if (list) {
          list.push(item);
        } else {
          groups[key] = [item];
        }
      });
      this.fields.filter(function (i) {
        return !i.section;
      }).forEach(function (item) {
        if (!groups['*']) {
          groups['*'] = [];
        }
        groups['*'].push(item);
      });
      return groups;
    },
    actionValuesGroups: function actionValuesGroups() {
      var groups = {};
      this.actionFormValues.forEach(function (item) {
        var list = groups[item.stepAction.objectId];
        if (list) {
          list.push(item);
        } else {
          groups[item.stepAction.objectId] = [item];
        }
      });
      return groups;
    }
  },
  methods: {
    onChange: function onChange(formField, event) {
      if (formField.type === 'file') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Global__["d" /* createParseFile */])(formField, event);
      }
    },
    openEditModal: function openEditModal(field) {
      var self = this;
      self.findFormField(field).then(function (formField) {
        self.currentEditField = field;
        self.newEditField = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(field));
        self.newEditField.options = formField.get('options');
        if (self.newEditField.type === 'checkbox') {
          self.newEditField.value = [];
        }
        delete self.newEditField['objectId'];
        self.showEditModal = true;
      });
    },
    findFormField: function findFormField(fieldValue) {
      var reqType = new __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Object('RequestType');
      reqType.set('objectId', fieldValue.request.reqType.objectId);
      var formFieldQuery = new __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Query('FormField');
      formFieldQuery.equalTo('reqType', reqType);
      formFieldQuery.equalTo('name', fieldValue.name);
      return formFieldQuery.first();
    },
    saveNewFieldVersion: function saveNewFieldVersion(oldId, newFieldVersion) {
      var self = this;
      var promiseField = __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Promise.as('');
      if (newFieldVersion.type === 'date') {
        newFieldVersion.value = newFieldVersion.dateValue ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(newFieldVersion.dateValue, 'DD/MM/YYYY').toDate() : undefined;
      } else if (newFieldVersion.type === 'money') {
        newFieldVersion.value = parseFloat(newFieldVersion.value);
      } else if (newFieldVersion.type === 'file' || newFieldVersion.type === 'document') {
        promiseField = newFieldVersion.value.save();
      }
      promiseField.then(function () {
        return __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('newFieldValueVersion', { olderFieldValueId: oldId, newVersion: newFieldVersion });
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Valor atualizado');
        self.closeModal();
        self.getById(self.request.objectId);
      }).fail(function (error) {
        error.message = 'Erro na atualização do valor: ' + error.message;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date(date)).fromNow();
    },
    getNextStep: function getNextStep() {
      return this.steps[this.stepCurrentIndex + 1].name;
    },
    getById: function getById(id) {
      var self = this;
      self.loading = true;
      var params = {
        id: id
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('request', params).then(function (res) {
        self.cloudResponse = res;
        var jsonResponse = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(res));
        self.request = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, jsonResponse.request);
        self.otherRequests = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], jsonResponse.otherRequests);
        self.fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], jsonResponse.fields);
        self.comments = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], jsonResponse.comments);
        self.steps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], jsonResponse.steps);
        self.canTrammit = jsonResponse.canTrammit;
        self.isInvited = jsonResponse.isInvited;
        self.canReopen = jsonResponse.canReopen;
        self.canRevert = jsonResponse.canRevert;
        self.showEditField = jsonResponse.showEditField;
        self.additionalFields = jsonResponse.additionalFields;
        self.actionFormValues = jsonResponse.actionFormValues;
        self.customizations = jsonResponse.customizations;
        self.currentStepActions = jsonResponse.currentStepActions;
        self.formSections = jsonResponse.formSections;
        self.ownerInvite = jsonResponse.ownerInvite;
        var isCompleted = false;
        var stepsReversed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], self.steps).reverse();
        var i = stepsReversed.length - 1;
        var stepIndex = i;
        stepsReversed.forEach(function (s) {
          if (isCompleted) {
            s.completed = true;
          }
          if (self.request.currentStep !== undefined && self.request.currentStep.objectId === s.objectId) {
            isCompleted = true;
            s.active = true;
            stepIndex = i;
            self.stepCurrentIndex = stepIndex;
          } else {
            i--;
          }
        });
        self.isLastStep = stepIndex === stepsReversed.length - 1;
        self.isFirstStep = stepIndex === 0;
        self.loading = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    formFieldIsValid: function formFieldIsValid(field) {
      var valid = true;
      if (field.required && (field.value === undefined || field.value === '') && field.type !== 'user') {
        valid = false;
      }
      return valid;
    },
    prepareFieldsToSave: function prepareFieldsToSave() {
      var self = this;
      if (self.contentModal && self.contentModal.length) {
        self.content = self.contentModal;
        self.contentModal = '';
      }
      if (self.commentEvent === 'reopen') {
        self.reopen();
        return;
      }
      if (self.commentEvent === 'revert') {
        self.revert();
        return;
      }
      if (!self.stepFields.every(function (f) {
        return self.formFieldIsValid(f);
      })) {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Todos os campos obrigatórios devem ser preenchidos corretamente.');
        return;
      }
      var promises = self.stepFields.filter(function (f) {
        return f.type === 'file' && f.value;
      }).map(function (f) {
        return f.value.save();
      });
      if (promises.length > 0) {
        __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Promise.when(promises).then(function (results) {
          self.updateStatus();
        }, function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
        });
      } else {
        self.updateStatus();
      }
    },
    reopen: function reopen() {
      var self = this;
      var params = {
        id: self.request.objectId,
        event: self.commentEvent,
        comment: self.content
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('reopenRequest', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Requisição reaberta.');
        self.content = '';
        self.showModal = false;
        self.getById(self.request.objectId);
      }).fail(function (error) {
        error.message = 'Erro na atualização da requisição: ' + error.message;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    revert: function revert() {
      var self = this;
      var params = {
        id: self.request.objectId,
        event: self.commentEvent,
        comment: self.content
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('revertRequestStep', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Requisição revertida ao passo anterior.');
        self.content = '';
        self.showModal = false;
        self.getById(self.request.objectId);
      }).fail(function (error) {
        error.message = 'Erro na atualização da requisição: ' + error.message;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    updateStatus: function updateStatus() {
      var self = this;
      var params = {
        request: self.request,
        event: self.commentEvent,
        comment: self.content,
        formFields: self.stepFields
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('updateRequestStatus', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Requisição atualizada.');
        self.content = '';
        self.showModal = false;
        self.getById(self.request.objectId);
      }).fail(function (error) {
        error.message = 'Erro na atualização da requisição: ' + error.message;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    saveComment: function saveComment(event) {
      var self = this;
      self.commentEvent = event;
      var activeStep = self.getActiveStep();
      var params = {
        requestId: self.request.objectId,
        stepId: activeStep ? activeStep.objectId : null,
        comment: self.content,
        event: self.commentEvent,
        privateComment: self.privateComment
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('saveComment', params).then(function (results) {
        self.loading = false;
        self.privateComment = true;
        self.content = '';
        self.commentEvent = 'note';
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Comentário enviado');
        self.getById(self.request.objectId);
      }).fail(function (error) {
        self.commentEvent = 'note';
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    deleteComment: function deleteComment(json) {
      var self = this;
      var params = {
        commentId: json.objectId
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('deleteComment', params).then(function (results) {
        self.loading = false;
        var id = self.$route.params.id;
        self.getById(id);
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Comentário excluído');
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    openTrammitModal: function openTrammitModal(eventType) {
      var self = this;
      if (eventType === 'deny' || eventType === 'reopen') {
        self.stepFields = [];
        self.commentEvent = eventType;
        self.showModal = true;
      } else {
        var step = new Step();
        step.id = self.request.currentStep.objectId;
        var queryFields = new __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Query('StepField');
        queryFields.equalTo('step', step);
        queryFields.doesNotExist('stepAction');
        queryFields.find().then(function (results) {
          self.stepFields = results.map(function (f) {
            return f.toJSON();
          });
          self.commentEvent = eventType;
          self.showModal = true;
        }).fail(function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    openActionModal: function openActionModal(action) {
      var self = this;
      self.currentAction = action;
      self.loadingAction = true;
      self.showActionModal = true;
      var step = new Step();
      step.id = self.request.currentStep.objectId;
      var stepAction = new StepAction();
      stepAction.id = action.objectId;
      var queryFields = new __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Query('StepField');
      queryFields.equalTo('step', step);
      queryFields.equalTo('stepAction', stepAction);
      queryFields.ascending('order');
      queryFields.find().then(function (results) {
        self.actionFields = results.map(function (f) {
          return f.toJSON();
        });
        self.loadingAction = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    processStepActions: function processStepActions() {
      var self = this;
      if (!self.actionFields.every(function (f) {
        return self.formFieldIsValid(f);
      })) {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Todos os campos obrigatórios devem ser preenchidos corretamente.');
        return;
      }
      if (confirm('Confirma o preenchimento dos campos? Esta ação não poderá ser desfeita.')) {
        var promises = self.actionFields.filter(function (f) {
          return f.type === 'file' && f.value;
        }).map(function (f) {
          return f.value.save();
        });
        if (promises.length > 0) {
          __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Promise.when(promises).then(function (results) {
            self.saveActionFields();
          }, function (error) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
          });
        } else {
          self.saveActionFields();
        }
      }
    },
    saveActionFields: function saveActionFields() {
      var self = this;
      var params = {
        fields: self.actionFields,
        requestId: self.request.objectId,
        stepActionId: self.currentAction.objectId
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('saveActionFields', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Avaliação aplicada.');
        self.showActionModal = false;
        self.getById(self.request.objectId);
      }).fail(function (error) {
        error.message = 'Erro na atualização da requisição: ' + error.message;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    sendEmail: function sendEmail() {
      var self = this;
      window.open('mailto:' + self.request.owner.email);
    },
    getActiveStep: function getActiveStep() {
      return this.steps.find(function (s) {
        return s.active;
      });
    },
    like: function like(json) {
      var self = this;
      var params = {
        commentId: json.objectId
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('likeComment', params).then(function () {
        self.loading = false;
        var id = self.$route.params.id;
        self.getById(id);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    dislike: function dislike(json) {
      var self = this;
      var params = {
        commentId: json.objectId
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('dislikeComment', params).then(function () {
        self.loading = false;
        var id = self.$route.params.id;
        self.getById(id);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    inviteUser: function inviteUser() {
      this.$router.push('/invite/' + this.request.objectId + '/' + this.getActiveStep().objectId);
    },
    inviteOwner: function inviteOwner() {
      this.$router.push('/invite/' + this.request.objectId + '/' + this.getActiveStep().objectId + '/select?ownerEditInvite=true');
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.showActionModal = false;
      this.showEditModal = false;
      this.stepFields = [];
    },
    getActionName: function getActionName(actionId) {
      return this.actionFormValues.find(function (item) {
        return item.stepAction.objectId === actionId;
      }).stepAction.name;
    },
    getSection: function getSection(objectId) {
      objectId = objectId.substring(objectId.indexOf('-') + 1, objectId.length);
      return this.formSections.find(function (s) {
        return s.objectId === objectId;
      }) || {};
    }
  }
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Steps__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__util_Steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__);











__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('pt-br');

var FormField = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('FormField');
var RequestType = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('RequestType');
var FormFieldRule = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('FormFieldRule');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a,
    Steps: __WEBPACK_IMPORTED_MODULE_4__util_Steps___default.a,
    DynamicFormField: __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField___default.a
  },
  data: function data() {
    return {
      loading: false,
      saved: false,
      workflow: { reqType: {} },
      fieldsInstances: [],
      allFormFields: [],
      allFieldsInstances: [],
      sectionStack: [],
      sections: [],
      showSummary: false,
      showRequestsButton: false,
      rules: [],
      repeatQuestion: {
        asked: false,
        answer: false
      }
    };
  },
  mounted: function mounted() {
    this.workflowId = this.$route.params.workflowId;
    this.load(this.workflowId);
  },

  methods: {
    onChange: function onChange(formField, event) {
      if (formField.type === 'file') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Global__["d" /* createParseFile */])(formField, event);
      }
      formField.invalid = !this.formFieldIsValid(formField);
    },
    load: function load(id) {
      this.loading = true;
      var self = this;
      var Workflow = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('Workflow');
      var queryWorkflow = new __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Query(Workflow);
      queryWorkflow.include('reqType');
      queryWorkflow.get(id).then(function (obj) {
        self.workflow = obj.toJSON();
        return self.getFormFieldsAndSections(self.workflow.reqType.objectId);
      }).then(function () {
        self.loading = false;
        return self.checkShowRequestsButton();
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    },
    back: function back() {
      var _this = this;

      if (this.showSummary) {
        this.showSummary = false;
      } else if (this.sectionStack.length > 1) {
        this.allFieldsInstances = this.allFieldsInstances.filter(function (f) {
          return f.sectionOrder !== _this.sectionStack.length;
        });
        this.sectionStack.pop();
        this.fieldsInstances = this.allFieldsInstances.filter(function (f) {
          return f.sectionOrder === _this.sectionStack.length;
        });
      } else {
        this.$router.push('/openRequest');
      }
    },
    repeat: function repeat() {
      var self = this;
      if (!self.validateFields()) {
        __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].warn('Alguns itens não foram preenchidos corretamente. Corrija-os');
      } else {
        self.sectionStack.push(self.currentSection());
        self.loadSectionFields();
      }
    },
    answerRepeat: function answerRepeat(answer) {
      this.repeatQuestion = { 'asked': true, 'answer': answer };
      this.next();
      this.$modal.hide('ask-repeat');
    },
    next: function next() {
      var self = this;
      if (self.sectionStack.length === 0) {
        self.sectionStack.push(self.sections[0]);
        self.loadSectionFields();
      } else {
        var currentSection = self.currentSection();
        if (!self.validateFields()) {
          __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].warn('Alguns itens não foram preenchidos corretamente. Corrija-os');
        } else {
          var action = currentSection.action;
          var nextSectionByRule = self.checkAppliedRules();
          var waitingForQuestion = false;
          if (nextSectionByRule !== undefined) {
            self.sectionStack.push(nextSectionByRule);
          } else if (!this.repeatQuestion.asked && this.canAddRepeated) {
            this.$modal.show('ask-repeat');
            waitingForQuestion = true;
          } else if (this.repeatQuestion.asked && this.repeatQuestion.answer) {
            this.repeat();
          } else if (action === 'next') {
            var currentIndex = self.sections.findIndex(function (s) {
              return s.objectId === currentSection.objectId;
            });
            self.sectionStack.push(self.sections[currentIndex + 1]);
          } else if (action === 'goto') {
            self.sectionStack.push(self.sections.find(function (s) {
              return s.objectId === currentSection.goto.objectId;
            }));
          } else {
            self.showSummary = true;
          }

          if (!waitingForQuestion && self.showSummary === false && !this.repeatQuestion.answer) {
            self.loadSectionFields();
          }
          this.repeatQuestion.asked = false;
          this.repeatQuestion.answer = false;
        }
      }
      self.scrollTo(document.body, 0, 100);
    },
    checkAppliedRules: function checkAppliedRules() {
      var self = this;
      var rulesThatCouldApply = self.rules.filter(function (r) {
        return self.fieldsInstances.find(function (f) {
          return f.objectId === r.formField.objectId;
        }) !== undefined;
      });
      var nextSection = void 0;
      rulesThatCouldApply.forEach(function (rule) {
        if (rule.operation === 'equals') {
          var formField = self.fieldsInstances.find(function (field) {
            return field.objectId === rule.formField.objectId;
          });
          if (formField) {
            var ruleApplies = formField.type === 'select' && formField.value.code === rule.argument || formField.type === 'number' && formField.value + '' === rule.argument || formField.value === rule.argument;
            if (ruleApplies) {
              nextSection = self.sections.find(function (section) {
                return section.objectId === rule.goto.objectId;
              });
            }
          }
        }
      });
      return nextSection;
    },
    getSubmissionFormFields: function getSubmissionFormFields() {
      var self = this;

      return self.allFieldsInstances.filter(function (f) {
        return self.sectionStack.find(function (s) {
          return s.objectId === f.section.objectId;
        }) !== undefined;
      });
    },
    validateFields: function validateFields() {
      var self = this;
      var invalids = self.fieldsInstances.filter(function (f) {
        f.invalid = !self.formFieldIsValid(f);
        return f.invalid;
      });
      return invalids.length === 0;
    },
    loadSectionFields: function loadSectionFields() {
      var self = this;
      var newCurrentSection = self.currentSection();
      self.fieldsInstances = self.allFormFields.filter(function (f) {
        return f.section.objectId === newCurrentSection.objectId;
      }).map(function (f) {
        f.sectionOrder = self.sectionStack.length;return f;
      }).map(function (f) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(f));
      });
      self.fieldsInstances.forEach(function (f) {
        self.$watch(function () {
          return f.value;
        }, self.computedFields);
      });
      this.allFieldsInstances = this.allFieldsInstances.concat(this.fieldsInstances);
    },
    currentSection: function currentSection() {
      var self = this;
      return self.sectionStack.length ? self.sectionStack[self.sectionStack.length - 1] : undefined;
    },
    getSection: function getSection(objectId) {
      return this.sectionStack.find(function (s) {
        return s.objectId === objectId;
      }) || {};
    },
    getFormFieldsAndSections: function getFormFieldsAndSections(id) {
      var query = new __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Query(FormField);
      var reqType = new RequestType();
      reqType.id = id;
      query.ascending('order');
      query.limit(1000);
      query.equalTo('reqType', reqType);
      var self = this;
      var data = {};
      return query.find().then(function (results) {
        data.allFormFieldsParse = results;
        self.allFormFields = results.map(function (r) {
          var item = r.toJSON();
          item.invalid = false;
          item.value = item.type === 'checkbox' ? [] : null;
          item.dateValue = null;
          item.filename = null;
          return item;
        });
        return __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('listFormSections', { requestId: reqType.id });
      }).then(function (results) {
        self.sections = results.data.map(function (r) {
          return r.toJSON();
        });
        var queryRules = new __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Query(FormFieldRule);
        queryRules.containedIn('formField', data.allFormFieldsParse);
        return queryRules.find();
      }).then(function (results) {
        self.rules = results.map(function (r) {
          return r.toJSON();
        });
        self.next();
      });
    },
    formFieldIsValid: function formFieldIsValid(field) {
      var valid = true;
      if (field.type === 'date' && field.required && !__WEBPACK_IMPORTED_MODULE_3_moment___default()(field.dateValue, 'DD/MM/YYYY').isValid()) {
        valid = false;
      } else if (field.required && !field.value && field.type !== 'date') {
        valid = false;
      }
      return valid;
    },
    saveRequestOnCloud: function saveRequestOnCloud() {
      var self = this;
      self.allFieldsInstances.forEach(function (f) {
        f.originalId = f.objectId;
      });
      var params = {
        reqTypeId: self.workflow.reqType.objectId,
        workflowId: self.workflow.objectId,
        allFieldsInstances: self.allFieldsInstances
      };
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('openRequest', params).then(function (res) {
        self.loading = false;
        self.$router.push('/requestConfirmation/' + res.requestId);
        __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].success('Requisição aberta com sucesso.');
      }, function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    saveRequest: function saveRequest() {
      var self = this;
      self.loading = true;
      if (!self.validateFields()) {
        __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].warn('Alguns itens não foram preenchidos corretamente. Corrija-os');
        self.loading = false;
        return;
      }
      self.getSubmissionFormFields().filter(function (f) {
        return f.type === 'date';
      }).forEach(function (f) {
        f.value = f.dateValue ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(f.dateValue, 'DD/MM/YYYY').toDate() : undefined;
      });
      self.getSubmissionFormFields().filter(function (f) {
        return f.type === 'money';
      }).forEach(function (f) {
        f.value = parseFloat(f.value);
      });
      var promises = self.getSubmissionFormFields().filter(function (f) {
        return (f.type === 'file' || f.type === 'document') && f.value;
      }).map(function (f) {
        return f.value.save();
      });
      if (promises.length > 0) {
        __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Promise.when(promises).then(function (results) {
          self.saveRequestOnCloud();
        }).fail(function (errors) {
          self.loading = false;
          var error = errors[0];
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
        });
      } else {
        self.saveRequestOnCloud();
      }
    },
    seeRequests: function seeRequests() {
      this.$router.push('/workflow/' + this.workflow.objectId + '/requests');
    },
    checkShowRequestsButton: function checkShowRequestsButton() {
      var self = this;
      var responsibleId = this.workflow.responsible.objectId;
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('enableLinkedRequestButton', { responsibleId: responsibleId }).then(function (response) {
        self.showRequestsButton = response.showRequestsButton;
      });
    },
    computedFields: function computedFields() {
      var self = this;
      var computed = self.fieldsInstances.filter(function (f) {
        return f.type === 'computed';
      });
      computed.forEach(function (computedField) {
        var formula = computedField.formula;
        computedField.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__Global__["e" /* computeValue */])(formula, self.fieldsInstances);
      });
    },
    scrollTo: function scrollTo(element, to, duration) {
      var self = this;
      if (duration < 0) return;
      var difference = to - element.scrollTop;
      var perTick = difference / duration * 2;
      setTimeout(function () {
        element.scrollTop = element.scrollTop + perTick;
        self.scrollTo(element, to, duration - 2);
      }, 10);
    }
  },
  computed: {
    currentFormFields: function currentFormFields() {
      var self = this;
      if (self.showSummary) {
        return self.getSubmissionFormFields();
      } else {
        return self.fieldsInstances;
      }
    },
    steps: function steps() {
      var self = this;
      var steps = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.sectionStack));
      if (self.showSummary) {
        steps.push({ name: 'Resumo', description: 'Confira seus dados antes de finalizar' });
      }
      if (steps.length) {
        steps[steps.length - 1].active = true;
      }
      return steps;
    },
    canAddRepeated: function canAddRepeated() {
      return this.showSummary === false && this.repeatedInfo.active && this.repeatedInfo.total + 1 <= this.repeatedInfo.max;
    },
    canReachNext: function canReachNext() {
      if (this.repeatedInfo && this.repeatedInfo.active) {
        return this.repeatedInfo.total >= this.repeatedInfo.min || this.repeatedInfo.min === undefined;
      }
      return true;
    },
    repeatedInfo: function repeatedInfo() {
      var self = this;
      var info = { active: false };
      var current = self.currentSection();
      if (current && current.repeat && current.repeat.active) {
        info = current.repeat;
        info.total = 0;
        for (var i = self.sectionStack.length - 1; i >= 0; i--) {
          var item = self.sectionStack[i];
          if (item.objectId === current.objectId) {
            info.total++;
          } else {
            break;
          }
        }
      }
      return info;
    },
    summary: function summary() {
      var groups = {};
      this.getSubmissionFormFields().forEach(function (item) {
        var list = groups[item.section.objectId];
        if (list) {
          list.push(item);
        } else {
          groups[item.section.objectId] = [item];
        }
      });
      return groups;
    },
    updateComputedFields: function updateComputedFields() {}
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);






__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pt-br');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_0__util_Loader___default.a
  },
  data: function data() {
    return {
      loading: false,
      requestsfields: {
        user: { label: 'Usuário', sortable: true },
        expiration: { label: 'Expira', sortable: true },
        canComment: { label: 'Pode comentar?', sortable: true },
        canEdit: { label: 'Pode editar?', sortable: true },
        createdAt: { label: 'Criado', sortable: true },
        actions: { label: 'Ações' }
      },
      invites: [],
      request: {},
      step: {}
    };
  },
  mounted: function mounted() {
    var requestId = this.$route.params.requestId;
    var stepId = this.$route.params.stepId;
    this.load(requestId, stepId);
  },

  methods: {
    load: function load(requestId, stepId) {
      var self = this;
      self.loading = true;
      var params = {
        requestId: requestId,
        stepId: stepId
      };
      __WEBPACK_IMPORTED_MODULE_2__Global__["a" /* Parse */].Cloud.run('requestInviteInfo', params).then(function (results) {
        self.loading = false;
        self.request = results.request;
        self.step = results.step;
        self.invites = results.invites;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    formatExpirationDate: function formatExpirationDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).format('DD/MM/YYYY');
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).fromNow();
    },
    remove: function remove(item) {
      if (confirm('Deseja realmente remover o convite?')) {
        var self = this;
        self.loading = true;
        var params = { inviteId: item,
          requestId: self.request.objectId };
        __WEBPACK_IMPORTED_MODULE_2__Global__["a" /* Parse */].Cloud.run('cancelInvite', params).then(function () {
          __WEBPACK_IMPORTED_MODULE_2__Global__["c" /* miniToastr */].success('Removido com successo.');
        }).fail(function (error) {
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_2__Global__["c" /* miniToastr */].error('Erro ao remover convite.');
        }).always(function () {
          self.loading = false;
          self.load(self.request.objectId, self.step.objectId);
        });
      }
    }
  }
});

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_text_mask__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_prod_env__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_prod_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_prod_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__);










__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale('pt-br');

var publicURL = JSON.parse(__WEBPACK_IMPORTED_MODULE_6__config_prod_env__["PUBLIC_URL"]);

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_3_vue_quill_editor__["quillEditor"],
    MaskedInput: __WEBPACK_IMPORTED_MODULE_0_vue_text_mask___default.a
  },
  data: function data() {
    return {
      loading: false,
      userFields: {
        select: { label: 'Selecione' },
        name: { label: 'Nome', sortable: true },
        email: { label: 'Email', sortable: true },
        count: { label: 'Total Convites', sortable: true },
        tags: { label: 'Dados' }
      },
      ownerEditInvite: false,
      invite: { canEdit: false, expires: false, canComment: true, users: [], sharedFields: [], expiration: null },
      currentPage: 1,
      perPage: 5,
      filter: null,
      users: [],
      usersCount: 0,
      fields: [],
      request: null,
      step: null,
      emailText: '\n          </br>\n          <p><strong>Siga os seguintes passos acessar o Sistema:</strong></p>\n          <p><strong style="color:rgb(230,0,0)">1) Acesse a p\xE1gina das Requisi\xE7\xF5es:</strong></p>\n          <p>Acesse o sistema de submiss\xE3o eletr\xF4nica, atrav\xE9s da URL <a href="' + publicURL + '/#/?next=/userProfile?tb=invites" target="_blank">' + publicURL + '/#/?next=/userProfile?tb=invites</a>.</p>\n          <p><strong style="color:rgb(230,0,0)">2) Caso seja seu primeiro acesso ou n\xE3o lembre da senha:</strong></p>\n          <p>Para obter sua senha de acesso, informe seu e-mail na p\xE1gina <a href="' + publicURL + '/#/password-reset" target="_blank">' + publicURL + '/#/password-reset</a></p>\n      ',
      editorConfig: {
        placeholder: '',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'color': [] }, { 'background': [] }], ['link', 'image']]
        }
      }
    };
  },
  mounted: function mounted() {
    var requestId = this.$route.params.requestId;
    var stepId = this.$route.params.stepId;
    this.ownerEditInvite = this.$route.query.ownerEditInvite === 'true';
    this.invite.canEdit = this.ownerEditInvite;
    this.load(requestId, stepId);
  },

  methods: {
    load: function load(requestId, stepId) {
      var self = this;
      self.loading = true;
      var params = {
        requestId: requestId,
        stepId: stepId
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('requestInviteInfo', params).then(function (results) {
        self.request = results.request;
        self.step = results.step;
        self.fields = results.fields;
        self.invite.sharedFields = results.sharedFields;
        params = {
          currentPage: self.currentPage,
          perPage: self.perPage,
          filter: self.filter,
          workflowId: self.request.workflow.id
        };
        if (self.request.workflow) {
          var customizations = self.request.workflow.get('customizations');
          if (customizations.inviteEmail) {
            self.emailText = customizations.inviteEmail + self.emailText;
          }
        }
        if (self.ownerEditInvite) {
          self.invite.users = [self.request.owner.toJSON()];
        }
        return __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('listInviteUsers', params);
      }).then(function (results) {
        self.loading = false;
        self.users = results.users;
        self.usersCount = results.count;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    getUsers: function getUsers() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.request.workflow.id
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('listInviteUsers', params).then(function (results) {
        self.users = results.users;
        self.usersCount = results.count;
        self.loading = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
        self.modalLoading = false;
      });
    },
    save: function save() {
      var self = this;
      var invalid = false;
      if (!self.invite.users.length) {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Selecione ao menos um usuário.');
        invalid = true;
      }
      if (self.invite.expires) {
        if (!self.invite.expiration) {
          __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Informe a data de expiração.');
          invalid = true;
        } else if (!__WEBPACK_IMPORTED_MODULE_2_moment___default()(self.invite.expiration, 'DD-MM-YYYY').isValid()) {
          __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Informe uma data válida.');
          invalid = true;
        }
      }
      if (!self.emailText || !self.emailText.trim()) {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].warn('Preencha o corpo da mensagem de e-mail.');
        invalid = true;
      }
      if (invalid) {
        return;
      }
      if (self.invite.expiration) {
        self.invite.expiration = __WEBPACK_IMPORTED_MODULE_2_moment___default()(self.invite.expiration, 'DD-MM-YYYY').endOf('day').toDate();
      }
      var params = {
        requestId: self.request.objectId,
        stepId: self.step.objectId,
        invite: self.invite,
        emailText: self.emailText
      };
      __WEBPACK_IMPORTED_MODULE_5__Global__["a" /* Parse */].Cloud.run('saveInvites', params).then(function () {
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].success('Salvo com sucesso.');
        self.$router.go('-1');
      }).fail(function (error) {
        console.log(error);
        __WEBPACK_IMPORTED_MODULE_5__Global__["c" /* miniToastr */].error('Ocorreu um erro durante a operação');
      }).always(function () {
        self.invite = { expires: false, canComment: true, users: [], sharedFields: [] };
        self.loading = false;
        self.showModal = false;
        self.load(self.request.objectId, self.step.objectId);
      });
    }
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RequestStatus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_0__util_Loader___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_2__util_RequestStatus___default.a
  },
  data: function data() {
    return {
      loading: false,
      requests: [],
      count: 0,
      requestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador', sortable: true },
        reqType: { label: 'Tipo', sortable: true },
        name: { label: 'Workflow', sortable: true },
        currentStep: { label: 'Passo', sortable: true },
        status: { label: 'Status', sortable: true },
        owner: { label: 'Criador', sortable: true },
        createdAtFmt: { label: 'Data de Abertura', sortable: true },
        options: { label: 'Opções' }
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },

  methods: {
    getList: function getList() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter
      };
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('listRequests', params).then(function (results) {
        self.requests = results.requests;
        self.count = results.count;
        self.loading = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    }
  }
});

/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_RequestStatus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__util_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pt-br');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    RequestStatus: __WEBPACK_IMPORTED_MODULE_0__util_RequestStatus___default.a
  },
  props: ['request'],
  data: function data() {
    return {
      showRequestData: false
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).fromNow();
    }
  }
});

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a
  },
  data: function data() {
    return {
      workflows: [],
      loading: false,
      selectedTag: '',
      tagAll: 'Todas',
      filter: ''
    };
  },
  mounted: function mounted() {
    this.getWorkflows();
    var tag = this.$route.params.tag;
    if (tag) {
      this.selectedTag = tag;
    } else {
      this.selectedTag = this.tagAll;
    }
  },

  methods: {
    getWorkflows: function getWorkflows() {
      var self = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('listAvaliableWorkflows').then(function (results) {
        self.workflowsParse = results;
        self.workflows = results.map(function (r) {
          return r.toJSON();
        });
        self.loading = false;
      }, function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    tagCount: function tagCount(tag) {
      if (tag === this.tagAll) {
        return this.workflows.length;
      } else {
        return this.workflows.filter(function (w) {
          return w.tags.includes(tag);
        }).length;
      }
    }
  },
  computed: {
    filteredWorkflows: function filteredWorkflows() {
      var self = this;
      var filter = this.filter.toLowerCase();
      return this.workflows.filter(function (w) {
        return (w.tags.includes(self.selectedTag) || self.selectedTag === self.tagAll) && (w.name && w.name.toLowerCase().indexOf(filter) > -1 || w.description && w.description.toLowerCase().indexOf(filter) > -1);
      });
    },
    tags: function tags() {
      var self = this;
      var tags = {};
      self.workflows.forEach(function (w) {
        w.tags.forEach(function (t) {
          tags[t] = true;
        });
      });
      return [self.tagAll].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(tags));
    }
  }
});

/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormSectionList__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormSectionList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormSectionList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);







var RequestType = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('RequestType');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a,
    FormSectionList: __WEBPACK_IMPORTED_MODULE_1__FormSectionList___default.a
  },
  data: function data() {
    return {
      requestType: {
        owner: {}
      },
      requestTypeParse: {},
      name: '',
      loading: false
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    if (id) {
      this.getRequestType(id);
    } else {
      this.requestTypeParse = new RequestType();
    }
  },

  methods: {
    getRequestType: function getRequestType(id) {
      var self = this;
      self.loading = true;
      var params = { requestId: id };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('getRequestType', params).then(function (result) {
        self.requestTypeParse = result;
        self.requestType = result.toJSON();
        self.loading = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    },
    save: function save() {
      var self = this;
      var editing = self.requestTypeParse.id !== undefined;
      self.loading = true;
      var params = { requestType: self.requestType };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('saveRequestType', params).then(function (obj) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        if (editing) {
          self.$router.push('/requestTypes');
        } else {
          self.getRequestType(obj.id);
          self.$router.replace({ name: 'RequestTypeDetail', params: { id: obj.id } });
        }
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    },
    remove: function remove() {
      if (confirm('Deseja realmente remover o Tipo de Requisição e todos os seus Campos?')) {
        var self = this;
        self.loading = true;
        var params = { requestId: self.requestType.objectId };
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('removeRequestType', params).then(function (obj) {
          self.loading = false;
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Excluído com sucesso');
          self.$router.go('-1');
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a
  },
  data: function data() {
    return {
      requestTypesParse: [],
      requestTypes: [],
      loading: false,
      fields: {
        name: { label: 'Nome', sortable: true },
        description: { label: 'Descrição', sortable: true },
        owner: { label: 'Criador', sortable: true },
        active: { label: 'Status', sortable: true },
        createdAtFmt: { label: 'Data de Criação', sortable: true },
        updatedAtFmt: { label: 'Última Atualização', sortable: true },
        options: { label: 'Opções' }
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    };
  },
  mounted: function mounted() {
    this.getRequestTypes();
  },

  methods: {
    getRequestTypes: function getRequestTypes() {
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('listRequestTypes').then(function (results) {
        self.requestTypesParse = results;
        self.requestTypes = results.map(function (r) {
          var json = r.toJSON();
          if (json.createdAt) {
            var dtFormat = new Date(json.createdAt);
            json.createdAtFmt = dtFormat.toLocaleString('pt-BR');
          }
          if (json.updatedAt) {
            var _dtFormat = new Date(json.updatedAt);
            json.updatedAtFmt = _dtFormat.toLocaleString('pt-BR');
          }
          return json;
        });
        self.loading = false;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    },
    duplicate: function duplicate(id) {
      if (confirm('Deseja realmente duplicar o Tipo de Requisição e todos os seus Campos?')) {
        var _self = this;
        _self.loading = true;
        var params = { requestId: id };
        __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('duplicateRequestType', params).then(function (results) {
          _self.loading = false;
          _self.getRequestTypes();
        }).fail(function (error) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(_self, error);
          _self.loading = false;
        });
      }
    },
    exportReqType: function exportReqType(id) {
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('exportRequestType', { 'reqTypeId': id }).then(function (result) {
        self.loading = false;
        var blob = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result, '', 2)]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'reqType' + id + '.json';
        link.click();
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        self.loading = false;
      });
    },
    importReqType: function importReqType(event) {
      var self = this;
      var reader = new FileReader();
      reader.readAsText(event.target.files[0], 'UTF-8');
      reader.onload = function (evt) {
        var content = evt.target.result;
        self.loading = true;
        __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('importRequestType', { importJson: JSON.parse(content) }).then(function () {
          self.loading = false;
          __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].success('Importado com sucesso.');
          self.getRequestTypes();
        }).fail(function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      };
    }
  }
});

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('pt-br');
var self = {};
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['linked', 'request'],
  mounted: function mounted() {
    self = this;
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date(date)).fromNow();
    },
    hasNewer: function hasNewer(sortedItems, objectId) {
      return sortedItems && sortedItems.length > 0 && sortedItems[0].objectId !== objectId;
    }
  },
  data: function data() {
    return {
      showRequestData: false
    };
  },

  computed: {
    sortedItems: function sortedItems() {
      self = this;
      return self.linked.sort(function (b, a) {
        return new Date(a.createdAt) - new Date(b.createdAt);
      });
    }
  }
});

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      user: {
        name: '',
        email: '',
        password: ''
      },
      confirmPassword: '',
      confirmEmail: '',
      errorMessage: '',
      loading: false,
      success: false
    };
  },
  mounted: function mounted() {
    this.loading = false;
    this.success = false;
  },

  methods: {
    signup: function signup() {
      self.success = false;
      self.errorMessage = null;
      if (this.user.password !== this.confirmPassword || this.user.email !== this.confirmEmail) {
        this.errorMessage = 'Os campos de email e senha devem ser iguais.';
      } else {
        var _self = this;
        _self.loading = true;
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('signUp', this.user).then(function (token) {
          __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.become(token);
          _self.success = true;
          _self.loading = false;
          _self.errorMessage = null;
        }, function (error) {
          console.log(error);
          _self.errorMessage = 'Ocorreu um erro durante cadastro: ' + error.message;
          _self.loading = false;
        });
      }
    }
  }
});

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      loading: false,
      show: false,
      stepParse: null,
      newAction: {},
      newActionParse: {},
      fieldTypes: ['form', 'link']
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    var stepId = this.$route.params.stepId;
    this.getInformation(id, stepId);
  },

  methods: {
    getInformation: function getInformation(id, stepId) {
      var self = this;
      self.loading = true;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('Step');
      query.get(stepId).then(function (result) {
        self.stepParse = result;
        var queryAction = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('StepAction');
        return id ? queryAction.get(id) : __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Promise.as(false);
      }).then(function (result) {
        if (result) {
          self.newActionParse = result;
          self.newAction = result.toJSON();
        }
        self.show = self.newAction.type === 'link';
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    change: function change() {
      this.show = this.newAction.type === 'link';
      this.newAction.value = null;
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    save: function save() {
      var self = this;
      self.loading = true;
      var StepAction = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('StepAction');
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(StepAction);
      query.equalTo('step', self.stepParse);
      query.count().then(function (count) {
        var action = new StepAction();
        action.set('step', self.stepParse);
        if (self.$route.params.id) {
          action.set('id', self.newAction.objectId);
        } else {
          action.set('order', count);
        }
        var props = ['name', 'description', 'type', 'value'];
        props.forEach(function (attr) {
          action.set(attr, self.newAction[attr]);
        });
        return action.save();
      }).then(function (result) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        self.$router.go(-1);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }
});

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      loading: false,
      updating: false,
      actions: [],
      actionsParse: [],
      step: {}
    };
  },
  mounted: function mounted() {
    this.getActionsData();
  },

  methods: {
    getActionsData: function getActionsData() {
      var self = this;
      self.loading = true;
      var stepId = self.$route.params.stepId;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('Step');
      query.get(stepId).then(function (result) {
        self.step = result.toJSON();
        var queryActions = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('StepAction');
        queryActions.equalTo('step', result);
        return queryActions.find();
      }).then(function (results) {
        self.actionsParse = results;
        self.actions = results.map(function (f) {
          return f.toJSON();
        });
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    remove: function remove(action) {
      if (confirm('Deseja realmente esta ação?')) {
        var self = this;
        self.loading = true;
        var actionParse = self.actionsParse.find(function (f) {
          return f.id === action.objectId;
        });
        actionParse.destroy({
          success: function success() {
            __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Excluído com sucesso.');
            self.loading = false;
            self.getActionsData();
          },
          error: function error(obj) {
            self.loading = false;
            __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(obj.error);
          }
        });
      }
    },
    checkMove: function checkMove(evt) {
      if (evt.newIndex !== evt.oldIndex) {
        var self = this;
        var updateList = [];
        self.updating = true;
        self.actions.forEach(function (action, index) {
          var actionParse = self.actionsParse.find(function (f) {
            return f.id === action.objectId;
          });
          actionParse.set('order', index);
          updateList.push(actionParse);
        });
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.saveAll(updateList).then(function (list) {
          self.actionsParse = list;
          self.updating = false;
        }).fail(function (error) {
          self.updating = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    }
  }
});

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a
  },
  data: function data() {
    return {
      loading: false,
      show: false,
      stepParse: null,
      newField: { required: false, options: [] },
      optionsCSV: '',
      fieldTypes: ['text', 'date', 'number', 'file', 'select', 'link', 'textarea', 'user']
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    var stepId = this.$route.params.stepId;
    this.getInformation(id, stepId);
  },

  watch: {
    optionsCSV: function optionsCSV(newValue) {
      var list = [];
      var lines = newValue.split('\n');
      lines.forEach(function (line) {
        if (line) {
          var columns = line.split(';');
          list.push({ code: columns[0], name: columns[1] });
        }
      });
      this.newField.options = list;
    }
  },
  methods: {
    getInformation: function getInformation(id, stepId) {
      var self = this;
      self.loading = true;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('Step');
      query.get(stepId).then(function (result) {
        self.stepParse = result;
        var queryFields = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('StepField');
        return id ? queryFields.get(id) : __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Promise.as(false);
      }).then(function (result) {
        if (result) {
          self.newField = result.toJSON();
          var options = result.get('options');
          var builder = [];
          options.forEach(function (opt, i) {
            if (i > 0) builder.push('\n');
            builder.push(opt.code);
            builder.push(';');
            builder.push(opt.name);
          });
          self.optionsCSV = builder.join('');
          self.show = options.length > 0;
        } else {
          self.newField.private = true;
        }
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    change: function change() {
      this.show = this.newField.type === 'select';
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    save: function save() {
      var self = this;
      var StepField = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('StepField');
      var StepAction = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('StepAction');
      self.loading = true;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(StepField);
      query.equalTo('step', self.stepParse);
      if (self.$route.params.actionId) {
        var action = new StepAction();
        action.id = self.$route.params.actionId;
        query.equalTo('stepAction', action);
      }
      query.count().then(function (count) {
        var field = new StepField();
        field.set('step', self.stepParse);
        if (self.$route.params.actionId) {
          var _action = new StepAction();
          _action.set('id', self.$route.params.actionId);
          field.set('stepAction', _action);
        }
        if (self.$route.params.id) {
          field.set('id', self.newField.objectId);
        } else {
          field.set('order', count);
        }
        var props = ['name', 'description', 'type', 'required', 'private', 'options'];
        props.forEach(function (attr) {
          field.set(attr, self.newField[attr]);
        });
        return field.save();
      }).then(function (result) {
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Salvo com sucesso');
        self.$router.go(-1);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }
});

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default.a
  },
  data: function data() {
    return {
      loading: false,
      updating: false,
      fields: [],
      fieldsParse: [],
      step: {},
      title: null
    };
  },
  mounted: function mounted() {
    this.getFieldsData();
  },

  methods: {
    getFieldsData: function getFieldsData() {
      var self = this;
      self.loading = true;
      var stepId = self.$route.params.stepId;
      var actionId = self.$route.params.actionId;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('Step');
      query.get(stepId).then(function (result) {
        self.step = result.toJSON();
        var queryFields = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('StepField');
        queryFields.ascending('order');
        queryFields.equalTo('step', result);
        if (actionId) {
          var StepAction = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('StepAction');
          var action = new StepAction();
          action.id = actionId;
          queryFields.equalTo('stepAction', action);
        } else {
          queryFields.doesNotExist('stepAction');
        }
        return queryFields.find();
      }).then(function (results) {
        self.fieldsParse = results;
        self.fields = results.map(function (f) {
          return f.toJSON();
        });
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    remove: function remove(field) {
      if (confirm('Deseja realmente remover o campo?')) {
        var self = this;
        var fieldParse = self.fieldsParse.find(function (f) {
          return f.id === field.objectId;
        });
        fieldParse.destroy({
          success: function success() {
            __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Excluído com sucesso.');
            self.getFieldsData();
          },
          error: function error(obj) {
            __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(obj.error);
          }
        });
      }
    },
    checkMove: function checkMove(evt) {
      if (evt.newIndex !== evt.oldIndex) {
        var self = this;
        var updateList = [];
        self.updating = true;
        self.fields.forEach(function (field, index) {
          var fieldParse = self.fieldsParse.find(function (f) {
            return f.id === field.objectId;
          });
          fieldParse.set('order', index);
          updateList.push(fieldParse);
        });
        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.saveAll(updateList).then(function (list) {
          self.fieldsParse = list;
          self.updating = false;
        }).fail(function (error) {
          self.updating = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
        });
      }
    }
  }
});

/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);


var self = {};




var Step = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('Step');
var StepGroupRule = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('StepGroupRule');
var ADMIN_WORKFLOW = 'ADMIN_WORKFLOW';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_2_vue_multiselect___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      step: {},
      stepParse: {},
      rules: [],
      loading: false,
      fieldRules: ['equals'],
      subGroups: []
    };
  },
  mounted: function mounted() {
    self = this;
    var stepId = self.$route.params.stepId;
    self.load(stepId);
  },

  methods: {
    load: function load(stepId) {
      var stepQuery = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(Step);
      stepQuery.include('target');
      stepQuery.include('workflow');
      stepQuery.get(stepId).then(function (step) {
        self.step = step.toJSON();
        self.stepParse = step;
        var querySubGroups = step.get('target').relation('roles').query();
        return querySubGroups.find();
      }).then(function (subGroups) {
        self.subGroups = subGroups.map(function (g) {
          return g.toJSON();
        });
        var queryRules = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(StepGroupRule);
        var stepParse = new Step();
        stepParse.id = self.step.objectId;
        queryRules.equalTo('step', stepParse);
        return queryRules.find();
      }).then(function (roles) {
        self.rules = roles.map(function (r) {
          return r.toJSON();
        });
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    save: function save() {
      var fieldRulesParse = self.rules.map(function (ruleJson) {
        var stepGroupRuleParse = new StepGroupRule();
        var targetGroup = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role();
        targetGroup.id = ruleJson.target.objectId;
        var fieldKeys = ['operation', 'fieldName', 'argument'];
        fieldKeys.forEach(function (f) {
          stepGroupRuleParse.set(f, ruleJson[f]);
        });
        stepGroupRuleParse.set('target', targetGroup);
        stepGroupRuleParse.set('step', self.stepParse);
        var acl = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].ACL();
        acl.setRoleWriteAccess(ADMIN_WORKFLOW, true);
        acl.setRoleReadAccess(ADMIN_WORKFLOW, true);
        stepGroupRuleParse.setACL(acl);
        return stepGroupRuleParse;
      });
      var rulesToBeDeletedQuery = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(StepGroupRule);
      rulesToBeDeletedQuery.equalTo('step', self.stepParse);
      rulesToBeDeletedQuery.find().then(function (rulesToBeDeleted) {
        return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.destroyAll(rulesToBeDeleted);
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.saveAll(fieldRulesParse);
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Informações salvas');
        self.$router.go(-1);
      }, function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }

});

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      loading: false,
      users: [],
      csv: null
    };
  },

  watch: {
    csv: function csv(newValue) {
      var list = [];
      var lines = newValue.split('\n');
      lines.forEach(function (line) {
        if (line) {
          var columns = line.split(';');
          var u = {
            username: columns[0],
            email: columns[1],
            name: columns[2]
          };
          u.tags = [];
          if (columns[3]) {
            u.tags = columns[3].split(',').map(function (tag) {
              return tag.trim();
            });
          }
          if (u.name && u.email) {
            list.push(u);
          }
        }
      });
      this.users = list;
    }
  },
  methods: {
    importUsers: function importUsers() {
      var self = this;
      self.loading = true;
      var params = {
        users: self.users
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('importUsers', params).then(function (results) {
        self.users = [];
        self.csv = '';
        self.loading = false;
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Usuários importados com sucesso.');
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      loading: false,
      users: [],
      count: 0,
      fields: {
        username: { label: 'Login', sortable: true },
        name: { label: 'Nome', sortable: true },
        email: { label: 'E-mail', sortable: true },
        createdAtFmt: { label: 'Data de Criação', sortable: true },
        updatedAtFmt: { label: 'Última Atualização', sortable: true }
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    };
  },
  mounted: function mounted() {
    this.getUsers();
  },

  methods: {
    getUsers: function getUsers() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listUsers', params).then(function (results) {
        self.users = results.users;
        self.count = results.count;
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }
});

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RequestStatus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__);







/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_1__util_RequestStatus___default.a
  },
  mounted: function mounted() {
    this.getRequests();
    if (this.$route.query.tb) {
      this.tabs.active = this.$route.query.tb;
    }
  },
  data: function data() {
    return {
      loading: false,
      loggedUser: __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.current(),
      userRequests: [],
      userRequestsCount: 0,
      userRequestsCurrentPage: 1,
      userRequestsPerPage: 10,
      userRequestsFilter: '',
      userRequestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        workflow: { label: 'Workflow', sortable: true },
        status: { label: 'Status', sortable: true },
        createdAtFmt: { label: 'Data de Abertura', sortable: true },
        options: { label: 'Opções' }
      },
      linkedRequests: [],
      linkedRequestsCount: 0,
      linkedRequestsCurrentPage: 1,
      linkedRequestsPerPage: 10,
      linkedRequestsFilter: '',
      linkedRequestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        workflow: { label: 'Workflow', sortable: true },
        status: { label: 'Status', sortable: true },
        owner: { label: 'Criador', sortable: true },
        createdAtFmt: { label: 'Data de Abertura', sortable: true },
        options: { label: 'Opções' }
      },
      invitedRequests: [],
      invitedRequestsCount: 0,
      invitedRequestsCurrentPage: 1,
      invitedRequestsPerPage: 10,
      invitedRequestsFilter: '',
      invitedRequestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        workflow: { label: 'Workflow', sortable: true },
        status: { label: 'Status', sortable: true },
        createdAtFmt: { label: 'Data de Abertura', sortable: true },
        options: { label: 'Opções' }
      },
      reponsibleWorkflows: [],
      reponsibleWorkflowsCount: 0,
      reponsibleWorkflowsCurrentPage: 1,
      reponsibleWorkflowsPerPage: 10,
      reponsibleWorkflowsFilter: '',
      reponsibleWorkflowsFields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        name: { label: 'Nome', sortable: true },
        options: { label: 'Opções' }
      },
      tabs: {
        active: 'mine'
      }
    };
  },

  methods: {
    getRequests: function getRequests() {
      var self = this;
      self.loading = true;
      self.getUserRequests().then(function (data) {
        return self.getLinkedRequests();
      }).then(function (data) {
        return self.getInvitedRequests();
      }).then(function (data) {
        return self.getResponsibleWorkflows();
      }).then(function () {
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    getUserRequests: function getUserRequests() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.userRequestsCurrentPage,
        perPage: self.userRequestsPerPage,
        filter: self.userRequestsFilter
      };
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listUserRequests', params).then(function (data) {
        self.userRequestsCount = data.total;
        self.userRequests = data.requests;
        self.loading = false;
      });
    },
    getLinkedRequests: function getLinkedRequests() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.linkedRequestsCurrentPage,
        perPage: self.linkedRequestsPerPage,
        filter: self.linkedRequestsFilter
      };
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listLinkedRequests', params).then(function (data) {
        self.linkedRequestsCount = data.total;
        self.linkedRequests = data.requests;
        self.loading = false;
      });
    },
    getInvitedRequests: function getInvitedRequests() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.invitedRequestsCurrentPage,
        perPage: self.invitedRequestsPerPage,
        filter: self.invitedRequestsFilter
      };
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listInvitedRequests', params).then(function (data) {
        self.invitedRequestsCount = data.total;
        self.invitedRequests = data.requests;
        self.loading = false;
      });
    },
    getResponsibleWorkflows: function getResponsibleWorkflows() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.reponsibleWorkflowsCurrentPage,
        perPage: self.reponsibleWorkflowsPerPage,
        filter: self.reponsibleWorkflowsFilter
      };
      return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('listResponsibleWorkflows', params).then(function (data) {
        self.reponsibleWorkflowsCount = data.total;
        self.reponsibleWorkflows = data.workflows;
        self.loading = false;
      });
    },
    changeTab: function changeTab(tab) {
      this.tabs.active = tab;
    }
  }
});

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Steps__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_input_tag__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_input_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_input_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__);











var Workflow = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('Workflow');
var Step = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('Step');
var FormField = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('FormField');
var RequestType = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('RequestType');
var Request = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('Request');
var ADMIN_WORKFLOW = 'ADMIN_WORKFLOW';

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Steps: __WEBPACK_IMPORTED_MODULE_2__util_Steps___default.a,
    Loader: __WEBPACK_IMPORTED_MODULE_3__util_Loader___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a,
    quillEditor: __WEBPACK_IMPORTED_MODULE_1_vue_quill_editor__["quillEditor"],
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a,
    InputTag: __WEBPACK_IMPORTED_MODULE_6_vue_input_tag___default.a
  },
  data: function data() {
    return {
      workflow: { target: {}, tags: [], customizations: {}, defaultSharedFields: [] },
      workflowParse: {},
      loading: false,
      hasLinkedRequests: false,
      viewMoreOptions: false,
      customizations: {},
      steps: [],
      groups: [],
      reqTypes: [],
      selectedGroup: null,
      fields: [],
      editorConfig: {
        placeholder: '',
        modules: {
          toolbar: [['bold', 'italic', 'underline', 'strike'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'color': [] }, { 'background': [] }], ['link', 'image']]
        }
      }
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    if (id) {
      this.getById(id);
    } else {
      var self = this;
      self.workflowParse = new Workflow();
      self.steps = [{}];
      var queryGroup = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role);
      queryGroup.ascending('description');
      queryGroup.limit(10000);
      queryGroup.find().then(function (results) {
        self.groups = results.map(function (r) {
          return r.toJSON();
        });
        var queryReqType = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(RequestType);
        queryReqType.ascending('name');
        queryReqType.equalTo('active', true);
        queryReqType.limit(10000);
        return queryReqType.find();
      }).then(function (results) {
        self.reqTypes = results.map(function (r) {
          return r.toJSON();
        });
      }, function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  },

  methods: {
    loadFields: function loadFields(requestTypeId) {
      var self = this;
      self.loading = true;
      var params = {
        requestTypeId: requestTypeId
      };
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Cloud.run('requestFieldsInfo', params).then(function (results) {
        self.fields = results.fields;
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    onStartDateCleared: function onStartDateCleared() {
      this.workflow.startDate = null;
    },
    onEndDateCleared: function onEndDateCleared() {
      this.workflow.endDate = null;
    },
    getRoleName: function getRoleName(obj) {
      var acl = obj.getACL();
      if (acl) {
        for (var attr in acl.toJSON()) {
          var spl = attr.split(':');
          if (spl.length > 1) {
            return spl[1];
          }
        }
      }
      return null;
    },
    getById: function getById(id) {
      var _this = this;

      var queryGroup = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(__WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role);
      var querySteps = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(Step);
      var queryReqType = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(RequestType);
      var queryRequest = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(Request);
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(Workflow);
      query.include('reqType');
      query.include('target');
      query.include('responsible');
      var self = this;
      this.loading = true;
      query.get(id).done(function (result) {
        self.workflowParse = result;
        self.workflow = result.toJSON();
        var querySharedFields = result.relation('defaultSharedFields').query();
        return querySharedFields.find();
      }).then(function (fields) {
        self.workflow.defaultSharedFields = fields.map(function (f) {
          return f.toJSON();
        });
        self.customizations = self.workflow.customizations;
        var startDate = self.workflow.startDate;
        var endDate = self.workflow.endDate;
        if (startDate) {
          self.workflow.startDate = new Date(startDate.iso);
        }
        if (endDate) {
          self.workflow.endDate = new Date(endDate.iso);
        }
        queryGroup.ascending('description');
        queryGroup.limit(10000);
        return queryGroup.find();
      }).done(function (result) {
        self.groups = result.map(function (r) {
          return r.toJSON();
        });
        queryReqType.ascending('name');
        queryReqType.equalTo('active', true);
        queryReqType.limit(10000);
        return queryReqType.find();
      }).done(function (result) {
        self.reqTypes = result.map(function (r) {
          return r.toJSON();
        });
        querySteps.equalTo('workflow', self.workflowParse);
        return querySteps.find();
      }).done(function (results) {
        self.steps = results.map(function (r) {
          return r.toJSON();
        });
        queryRequest.equalTo('status', 'processing');
        queryRequest.equalTo('workflow', self.workflowParse);
        return queryRequest.count();
      }).done(function (count) {
        self.hasLinkedRequests = count > 0;
        _this.loadFields(self.workflow.reqType.objectId);
      }).fail(function (error) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
      }).always(function () {
        self.loading = false;
      });
    },
    save: function save() {
      var self = this;

      if (self.hasLinkedRequests) {
        var shouldSave = confirm('Tem certeza que deseja modificar o Workflow que já possui requisições vinculadas?');
        if (!shouldSave) {
          return;
        }
      }
      if (!self.workflow.target || !self.workflow.responsible || !self.workflow.reqType) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].warn('Selecione o Grupo Alvo & Responsável e o Tipo de Requisição');
        return;
      }
      var startDate = self.workflow.startDate;
      var endDate = self.workflow.endDate;
      if (startDate && endDate) {
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 59);
        if (startDate.getTime() > endDate.getTime()) {
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].warn('A data de Início de Vigência não pode ser superior à de Fim de Vigência.');
          return;
        }
      }
      if (self.steps.some(function (step) {
        return !step.target || !step.name || !step.description;
      })) {
        __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].warn('Todos os dados dos Passos devem ser preenchidos.');
        return;
      }
      self.loading = true;
      var props = ['name', 'description', 'active', 'feedback', 'startDate', 'endDate', 'tags'];
      props.forEach(function (p) {
        return self.workflowParse.set(p, self.workflow[p]);
      });
      if (!self.workflowParse.get('customizations')) {
        self.workflowParse.set('customizations', {});
      }

      var hasMoreOptions = false;
      for (var field in self.customizations) {
        if (self.customizations[field]) {
          hasMoreOptions = true;
        }
      }
      if (hasMoreOptions) {
        self.workflowParse.set('customizations', self.customizations);
      }
      if (self.workflow.defaultSharedFields) {
        var relation = self.workflowParse.relation('defaultSharedFields');
        self.fields.forEach(function (f) {
          var field = new FormField();
          field.id = f.objectId;
          relation.remove(field);
        });
        self.workflow.defaultSharedFields.forEach(function (f) {
          var field = new FormField();
          field.id = f.objectId;
          relation.add(field);
        });
      }
      var reqType = new RequestType();
      reqType.set('id', self.workflow.reqType.objectId);
      self.workflowParse.set('reqType', reqType);
      var target = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role();
      target.set('id', self.workflow.target.objectId);
      var responsible = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role();
      responsible.set('id', self.workflow.responsible.objectId);
      self.workflowParse.set('target', target);
      self.workflowParse.set('responsible', responsible);
      var acl = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].ACL();
      acl.setRoleWriteAccess(ADMIN_WORKFLOW, true);
      acl.setRoleReadAccess(ADMIN_WORKFLOW, true);
      acl.setRoleReadAccess(self.workflow.target.name, true);
      acl.setRoleReadAccess(self.workflow.responsible.name, true);
      self.workflowParse.setACL(acl);
      this.workflowParse.save().then(function (obj) {
        var stepsParse = [];

        var _loop = function _loop(i) {
          var s = self.steps[i];
          var stepParse = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object('Step');
          if (s.objectId) stepParse.set('id', s.objectId);
          var props = ['name', 'description'];
          props.forEach(function (p) {
            return stepParse.set(p, s[p]);
          });
          stepParse.set('workflow', self.workflowParse);
          if (s.target) {
            var roleTarget = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Role();
            roleTarget.set('id', s.target.objectId);
            stepParse.set('target', roleTarget);
            var _acl = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].ACL();
            _acl.setRoleWriteAccess(ADMIN_WORKFLOW, true);
            _acl.setRoleReadAccess(ADMIN_WORKFLOW, true);
            _acl.setRoleReadAccess(s.target.name, true);
            stepParse.setACL(_acl);
          }
          stepParse.set('order', i);
          stepsParse.push(stepParse);
        };

        for (var i = 0; i < self.steps.length; i++) {
          _loop(i);
        }

        __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.saveAll(stepsParse).then(function () {
          var queryStepsToBeDeleted = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query('Step');
          queryStepsToBeDeleted.equalTo('workflow', self.workflowParse);
          queryStepsToBeDeleted.notContainedIn('objectId', stepsParse.map(function (s) {
            return s.id;
          }));
          return queryStepsToBeDeleted.find();
        }, function (obj, error) {
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(obj.message);
        }).then(function (stepsToBeDeleted) {
          return __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.destroyAll(stepsToBeDeleted);
        }).then(function () {
          __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].success('Informações salvas');
          self.loading = false;
          self.getById(obj.id);
          self.$router.replace({ name: 'WorkflowDetail', params: { id: obj.id } });
        }, function (error) {
          self.loading = false;
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ErrorHandling__["handleParseError"])(self, error);
        });
      });
    },
    addStep: function addStep(index) {
      if (this.steps === undefined) this.steps = [];
      var fakeStep = { 'name': null, 'description': null, target: null };
      this.steps.splice(index + 1, 0, fakeStep);
    },
    removeStep: function removeStep(index) {
      this.steps.splice(index, 1);
    },
    addFieldsToTrammit: function addFieldsToTrammit(step) {
      this.$router.push({ name: 'StepFieldList', params: { stepId: step.objectId, action: 'trammit' } });
    },
    addExtraActions: function addExtraActions(step) {
      this.$router.push({ name: 'StepActionList', params: { stepId: step.objectId } });
    }
  }
});

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__);






var Workflow = __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Object.extend('Workflow');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1__util_Loader___default.a
  },
  data: function data() {
    return {
      workflows: [],
      workflowsParse: [],
      loading: false,
      fields: {
        name: { label: 'Nome', sortable: true },
        active: { label: 'Status', sortable: true },
        target: { label: 'Grupo Alvo', sortable: true },
        startDateFmt: { label: 'Início de Vigência', sortable: true },
        endDateFmt: { label: 'Fim de Vigência', sortable: true },
        createdAtFmt: { label: 'Data de Criação', sortable: true },
        updatedAtFmt: { label: 'Última Atualização', sortable: true },
        options: { label: 'Opções' }
      },
      currentPage: 1,
      perPage: 5,
      filter: null
    };
  },
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    refresh: function refresh() {
      this.loading = true;
      var query = new __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Query(Workflow);
      query.include('target');
      query.descending('updatedAt');
      var self = this;
      query.find({
        success: function success(results) {
          self.workflows = results.map(function (r) {
            var json = r.toJSON();
            if (json.createdAt) {
              var dtFormat = new Date(json.createdAt);
              json.createdAtFmt = dtFormat.toLocaleString('pt-BR');
            }
            if (json.updatedAt) {
              var _dtFormat = new Date(json.updatedAt);
              json.updatedAtFmt = _dtFormat.toLocaleString('pt-BR');
            }
            if (json.startDate) {
              var _dtFormat2 = new Date(json.startDate.iso);
              json.startDateFmt = _dtFormat2.toLocaleString('pt-BR');
            }
            if (json.endDate) {
              var _dtFormat3 = new Date(json.endDate.iso);
              json.endDateFmt = _dtFormat3.toLocaleString('pt-BR');
            }
            return json;
          });
          self.workflowsParse = results;
          self.loading = false;
        },
        error: function error(obj) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_ErrorHandling__["handleParseError"])(self, obj);
          self.loading = false;
        }
      });
    }
  }
});

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__util_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RequestStatus__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_RequestStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_RequestStatus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__);









var self = null;
var Workflow = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('Workflow');
var RequestType = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('RequestType');
var FormField = __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Object.extend('FormField');

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_2__util_Loader___default.a,
    RequestStatus: __WEBPACK_IMPORTED_MODULE_3__util_RequestStatus___default.a,
    DynamicFormField: __WEBPACK_IMPORTED_MODULE_5__util_DynamicFormField___default.a,
    Multiselect: __WEBPACK_IMPORTED_MODULE_4_vue_multiselect___default.a
  },
  data: function data() {
    return {
      loading: false,
      requests: [],
      count: 0,
      requestsfields: {
        icon: { label: '' },
        objectId: { label: 'Identificador' },
        reqType: { label: 'Tipo', sortable: true },
        workflow: { label: 'Workflow', sortable: true },
        currentStep: { label: 'Passo', sortable: true },
        status: { label: 'Status', sortable: true },
        createdAtFmt: { label: 'Data de Abertura', sortable: true },
        options: { label: 'Opções' }
      },
      statusFilter: [],
      statuses: [{ name: 'Em análise', value: 'processing' }, { name: 'Concluído', value: 'grant' }, { name: 'Cancelado', value: 'deny' }],
      currentPage: 1,
      perPage: 10,
      workflow: {},
      filter: null,
      fieldFilters: [],
      formFields: []
    };
  },
  mounted: function mounted() {
    self = this;
    self.statusFilter = self.statuses.map(function (s) {
      return s.value;
    });
    this.init();
  },

  methods: {
    init: function init() {
      self.loading = true;
      var workflowId = self.$route.params.id;
      var queryWorkflow = new __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Query(Workflow);
      queryWorkflow.descending('createdAt');
      queryWorkflow.get(workflowId).then(function (workflow) {
        self.workflow = workflow.toJSON();
        var reqType = new RequestType();
        reqType.id = self.workflow.reqType.objectId;
        var queryReqType = new __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Query(FormField);
        queryReqType.ascending('order');
        queryReqType.notContainedIn('type', ['separator', 'file', 'document']);
        queryReqType.equalTo('reqType', reqType);
        queryReqType.limit(1000);
        return queryReqType.find();
      }).then(function (results) {
        self.formFields = results.map(function (r) {
          return r.toJSON();
        });
        return self.getRequests();
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    getRequests: function getRequests() {
      var valid = true;
      self.fieldFilters.forEach(function (filter) {
        var type = filter.field.type;
        var value = filter.field.value;
        var dateValue = filter.field.dateValue;
        var dateInvalid = type === 'date' && !dateValue;
        var selectInvalid = type === 'select' && !value;
        var othersInvalid = !value || typeof value === 'string' && !value.trim();
        if (dateInvalid || selectInvalid || othersInvalid) {
          valid = false;
        }
      });
      if (!valid) {
        __WEBPACK_IMPORTED_MODULE_1__Global__["c" /* miniToastr */].warn('Preencha todos os campos do filtro.');
        return;
      }
      self.loading = true;
      var params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.$route.params.id,
        fieldFilters: self.fieldFilters,
        statusFilter: self.statusFilter
      };
      return __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('workflowRequests', params).then(function (results) {
        self.requests = results.requests.map(function (r) {
          if (r.createdAt) {
            var dtFormat = new Date(r.createdAt);
            r.createdAtFmt = dtFormat.toLocaleString('pt-BR');
          }
          return r;
        });
        self.count = results.total;
        self.loading = false;
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
      });
    },
    addFilterField: function addFilterField() {
      self.fieldFilters.push({ field: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.formFields[0])), operator: '=' });
    },
    removeFilter: function removeFilter(index) {
      self.fieldFilters.splice(index, 1);
    },
    downloadWorkflowRequests: function downloadWorkflowRequests() {
      var self = this;
      self.loading = true;
      var params = {
        currentPage: self.currentPage,
        perPage: self.perPage,
        filter: self.filter,
        workflowId: self.$route.params.id,
        fieldFilters: self.fieldFilters,
        statusFilter: self.statusFilter
      };
      __WEBPACK_IMPORTED_MODULE_1__Global__["a" /* Parse */].Cloud.run('workflowRequestsXlsReport', params).then(function (data) {
        self.loading = false;
        var buffer = new Buffer(data, 'base64');
        var blob = new Blob([new Uint8Array(buffer)], { type: 'application/vnd.ms-excel' });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'requests.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }).fail(function (error) {
        self.loading = false;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ErrorHandling__["handleParseError"])(self, error);
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(44).Buffer))

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['event'],
  computed: {
    text: function text() {
      var result = '';
      if (this.event === 'grant') {
        result = 'Sucesso';
      } else if (this.event === 'deny') {
        result = 'Cancelado';
      } else if (this.event === 'reopen') {
        result = 'Reaberto';
      } else if (this.event === 'revert') {
        result = 'Revertido';
      } else if (this.event === 'processing') {
        result = 'Processamento';
      } else if (this.event === 'note') {
        result = 'Comentário';
      } else if (this.event === 'edit') {
        result = 'Edição';
      }
      return result;
    }
  }
});

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['event'],
  methods: {
    getIconClass: function getIconClass() {
      var event = this.event;
      var iconCls = '';
      if (event === 'note') {
        iconCls = 'glyphicon-file';
      } else if (event === 'reopen') {
        iconCls = 'glyphicon-open';
      } else if (event === 'deny') {
        iconCls = 'glyphicon-thumbs-down';
      } else if (event === 'processing') {
        iconCls = 'glyphicon-arrow-right';
      } else if (event === 'revert') {
        iconCls = 'glyphicon-erase';
      } else if (event === 'grant') {
        iconCls = 'glyphicon-thumbs-up';
      } else if (event === 'edit') {
        iconCls = 'glyphicon-edit';
      }
      return event + ' ' + iconCls;
    }
  }
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentIcon__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CommentIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CommentIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommentEvent__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CommentEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CommentEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_twitter__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_twitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_twitter__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['comments'],
  components: {
    CommentIcon: __WEBPACK_IMPORTED_MODULE_0__CommentIcon___default.a,
    CommentEvent: __WEBPACK_IMPORTED_MODULE_1__CommentEvent___default.a
  },
  methods: {
    format: function format(date) {
      __WEBPACK_IMPORTED_MODULE_2_moment_twitter___default.a.locale('pt-br');
      return __WEBPACK_IMPORTED_MODULE_2_moment_twitter___default()(date).twitterShort();
    }
  }
});

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_text_mask__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_text_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_text_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createNumberMask__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createNumberMask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createNumberMask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentInputPreview__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocumentInputPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DocumentInputPreview__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['formField', 'onChange', 'showSummary'],
  components: {
    MaskedInput: __WEBPACK_IMPORTED_MODULE_0_vue_text_mask___default.a,
    DocumentInputPreview: __WEBPACK_IMPORTED_MODULE_2__DocumentInputPreview___default.a
  },
  methods: {
    callOnChange: function callOnChange(formField, event) {
      this.onChange(formField, event);
      this.$forceUpdate();
    },
    currencyMask: function currencyMask(rawValue) {
      var numberMask = __WEBPACK_IMPORTED_MODULE_1_text_mask_addons_dist_createNumberMask___default()({
        prefix: '',
        suffix: '',
        includeThousandsSeparator: false,
        allowDecimal: true,
        requireDecimal: true,
        allowLeadingZeroes: false
      });
      var mask = numberMask(rawValue);
      var decimalsRegex = /\.([0-9]{1,2})/;
      var result = decimalsRegex.exec(rawValue);

      if (result && result[1].length < 2) {
        mask.push('0');
      } else if (!result) {
        mask.push('0');
        mask.push('0');
      }
      return mask;
    }
  }
});

/***/ }),

/***/ 610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('pt-br');

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['field', 'fields', 'sectionOrder', 'sectionId'],
  data: function data() {
    return {
      showHistory: false
    };
  },

  methods: {
    isSameSection: function isSameSection(f, order, sectionIdWithOrder) {
      return !f.section || order + '-' + f.section.objectId === sectionIdWithOrder;
    },
    compute: function compute(formula, fields) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Global__["e" /* computeValue */])(formula, fields);
    },
    getVersions: function getVersions() {
      var _this = this;

      var versions = this.fields && this.fields.filter(function (f) {
        return f.newerVersion && (_this.field.original && f.objectId === _this.field.original.objectId || f.original && _this.field.original && f.original.objectId === _this.field.original.objectId);
      });
      if (versions) {
        versions.sort(function (v1, v2) {
          return v1.createdAt < v2.createdAt;
        });
      }
      return versions;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date(date)).fromNow();
    }
  },
  computed: {
    hasVersions: function hasVersions() {
      var versions = this.getVersions();
      return versions && versions.length;
    },
    newerField: function newerField() {
      return this.field;
    },
    versions: function versions() {
      if (this.showHistory) {
        return [this.field].concat(this.getVersions());
      } else {
        return [this.newerField];
      }
    }
  }
});

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["handleParseError"] = handleParseError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global__ = __webpack_require__(10);



function handleParseError(self, error) {
  __WEBPACK_IMPORTED_MODULE_0__Global__["c" /* miniToastr */].error(error.message);
  switch (error.code) {
    case __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].Error.INVALID_SESSION_TOKEN:
      __WEBPACK_IMPORTED_MODULE_0__Global__["a" /* Parse */].User.logOut();
      self.$router.push('/login?next=');
      break;
  }
}

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    ClipLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_ClipLoader___default.a
  },
  data: function data() {
    return {
      loading: true
    };
  }
});

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      message: '',
      username: ''
    };
  },
  mounted: function mounted() {
    this.username = this.$route.query.username;
    this.message = this.$route.params.message;
  }
});

/***/ }),

/***/ 614:
/***/ (function(module, exports) {



/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['status']
});

/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multiselect__);
var _this = this;



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['steps', 'request', 'editable', 'events', 'groups', 'linkedRequests', 'icons'],
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_0_vue_multiselect___default.a
  },
  watch: {
    steps: function steps(value) {
      _this.steps = value;
    }
  }
});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.6.1","_id":"elliptic@6.6.1","_inBundle":false,"_integrity":"sha512-RaddvvMatK2LJHqFJ+YA4WysVN5Ita9E35botqIYspQ4TkRAlCicdzKOjlyv/1Za5RyTNn7di//eEV0uTAfe3g==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.6.1","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.6.1","saveSpec":null,"fetchSpec":"^6.6.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.6.1.tgz","_shasum":"3b8ffb02670bf69e382c7f65bf524c97c5405c06","_spec":"elliptic@^6.6.1","_where":"/ifpe/etc/workflowjs/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.6.1"}

/***/ }),

/***/ 853:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 854:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 855:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 857:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 862:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 864:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 865:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 866:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 867:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 868:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 869:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 870:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 871:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 872:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 873:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 874:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 875:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 876:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 877:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 878:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 880:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 881:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 882:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 883:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 884:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 886:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 887:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 888:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 890:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 892:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 893:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 894:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 899:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 900:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 901:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[562]);


// WEBPACK FOOTER //
// static/js/app.8cf6e09499b7d49acdc6.js